angular.module('components.create-menu.create-menu',
  ['components.datepicker.datepicker',
    'components.data-access.api.menu-api-service',
    'components.create-menu-helper.create-menu-helper',
    'components.data-access.title-service'])
  .directive('createMenu',
    function ($locale, $modal, $state, $alert,
              recipeApiService, userListApiService, menuApiService, createMenuHelper, titleService) {
      return {
        restrict: 'E',
        scope: {
          menuData: '=?',
        },
        replace: true,
        templateUrl: 'app/components/menu/create-menu/create-menu.html',
        link: function ($scope) {
          var SHORT_DAYS = createMenuHelper.getShortDays();
          $scope.localChefs = [];
          titleService.setTitle($scope.menuData ? 'Edit Menu' : 'Create Menu');

          $scope.tabs = SHORT_DAYS.map(function (day) {
            return { name: day.toLowerCase(), isSelected: false };
          });

          $scope.tabs[0].isSelected = true;
          $scope.selectedTab = $scope.tabs[0];

          $scope.menu = createMenuHelper.getMenuData();
          $scope.menu.data = $scope.menuData || $scope.menu.data;

          $scope.addNewStation = function (menu) {
            menu[$scope.selectedTab.name].push(angular.copy($scope.menu.emptyStation));
          };

          $scope.selectTab = function (selectedTab) {
            $scope.tabs.find(function (tab) {
              return tab.isSelected;
            }).isSelected = false;

            selectedTab.isSelected = true;
            $scope.selectedTab = selectedTab;
          };

          recipeApiService.getFilters().then(function (filters) {
            $scope.filters = filters;
          });

          recipeApiService.getRecipe().then(function (recipes) {
            $scope.recipes = recipes.data;
            $scope.pagination = recipes.meta.pagination;
          });

          userListApiService.getLocalChefs().then(function (chefs) {
            $scope.localChefs = chefs;
          });

          $scope.removeByIndex = function (recipes, index) {
            return recipes.splice(index, 1);
          };

          $scope.selectChefs = function (src, dest) {
            $scope.menu.data.assigned_chefs = dest.slice();
          };

          $scope.addRecipe = function (stationRecipes, title, index) {
            return $modal({
              title: title || 'Add Recipe',
              templateUrl: 'app/components/modal/templates/catalogue.html',
              customClass: 'menu-modal-large',
              scope: $scope,
              controller: function ($scope) {
                if (!$scope.recipes) {
                  recipeApiService.getRecipe().then(function (recipes) {
                    $scope.recipes = recipes.data;
                  });
                }

                $scope.recipes = $scope.recipes.filter(function (recipe) {
                  return stationRecipes.filter(function (item) {
                    return item.id === recipe.id;
                  }).length === 0;
                });

                $scope.onSelectRecipe = function (recipe) {
                  if (index !== undefined) {
                    stationRecipes[index] = recipe;
                  } else {
                    stationRecipes.push(recipe);
                  }
                  $scope.$hide();
                };
              },
            });
          };

          $scope.assignChefs = function () {
            return $modal({
              title: 'Assigned to',
              templateUrl: 'app/components/modal/templates/local-chefs.html',
              customClass: 'local-chefs-modal',
              scope: $scope,
              controller: function ($scope) {
                $scope.originalList = angular.copy($scope.localChefs);
                $scope.localChefs.forEach(function (localChef) {
                  !$scope.menu.data.assigned_chefs.some(function (selectedChef) {
                    return localChef.id === selectedChef.id;
                  }) && (localChef.isChecked = false);
                });

                $scope.menu.data.assigned_chefs.forEach(function (chef) {
                  var findedChef = $scope.localChefs.find(function (localChef) {
                    return chef.id === localChef.id;
                  });
                  if (findedChef) {
                    findedChef.isChecked = true;
                  }
                });

                $scope.action = function () {
                  $scope.selectChefs('selectedChefs', $scope.localChefs.filter(function (chef) {
                    return chef.isChecked;
                  }));
                  $scope.$hide();
                };

                $scope.cancel = function () {
                  $scope.$hide();
                };
              },
            });
          };

          $scope.openRemoveModal = function (arr, type, index, name) {
            var titles = {
              station: 'Are you sure want to delete this station?',
              recipe: 'Are you sure want to delete this recipe from the menu?',
              stationMenu: 'Are you sure want to delete <br>' + name + ' station from this menu?',
              chef: 'Are you sure want to deassign <br>' + name + ' from this menu?',
            };

            return $modal({
              title: titles[type],
              templateUrl: 'app/components/modal/templates/confirm.html',
              customClass: 'user-create-modal',
              scope: $scope,
              controller: function ($scope) {
                $scope.action = function () {
                  $scope.removeByIndex(arr, index);
                  $scope.$hide();
                };
              },
            });
          };

          $scope.openRemoveMenuModal = function (menuId) {
            return $modal({
              title: 'Are you sure want to delete this menu?',
              templateUrl: 'app/components/modal/templates/confirm.html',
              customClass: 'user-create-modal',
              scope: $scope,
              controller: function ($scope) {
                $scope.action = function () {
                  menuApiService.deleteMenu(menuId).then(function () {
                    $scope.$hide();
                    $state.go('main.menu');
                  });
                };
              },
            });
          };

          $scope.createMenu = function (method, isCopy) {
            $scope.disableSubmit = true;
            var copyMenuData = angular.copy($scope.menu.data);
            var alertTitle = isCopy ?
              'Copy menu has been created' :
              $scope.menuData ? 'The menu has been changed' : 'New menu has been created';

            delete copyMenuData.author_chef_id;
            menuApiService[(method || ($scope.menuData ? 'update' : 'create')) + 'Menu'](copyMenuData, isCopy)
              .then(function (data) {
                $alert({
                  content: '<span class="check-icon"></span>' + alertTitle,
                  type: 'success',
                  show: true,
                  container: '.alert-container',
                });
                $state.go('main.' + (isCopy ? 'edit-menu' : 'menu'), {
                  menuId: data.id,
                  startDate: $scope.menu.data.start_date,
                });
              }, enableSubmit);
          };

          $scope.onSetPage = function (offset) {
            $scope.offset = offset;

            return recipeApiService.filterRecipes($scope.categories, offset, $scope.sort).then(function (recipes) {
              $scope.filteredRecipes = recipes.data;
              $scope.pagination = recipes.meta.pagination;
              $scope.isChanged = false;
            });
          };

          $scope.scheduleHours = createMenuHelper.getScheduleHours();

          $scope.scheduleMeal = function (schedule) {
            return $modal({
              title: 'Schedule of meal',
              templateUrl: 'app/components/modal/templates/schedule.html',
              customClass: 'user-create-modal',
              scope: $scope,
              controller: function ($scope) {
                $scope.schedule = angular.copy(schedule) || [];

                $scope.cancel = function () {
                  $scope.$hide();
                };

                $scope.addStation = function () {
                  $scope.schedule.length < 10 && $scope.schedule.push({ name: '', start: '', end: '' });
                };

                $scope.edit = function () {
                  $scope.menu.data.schedule = angular.copy($scope.schedule);
                  $scope.$hide();
                };

                if ($scope.schedule.length === 0) {
                  $scope.addStation();
                }
              },
            });
          };

          $scope.cancelPage = function (isEditMenu) {
            var chefsLength = $scope.menu.data.assigned_chefs.length;
            var titleLength = $scope.menu.data.title.length;
            var isRecipesAdded = false;
            var weekDaysKeys = Object.keys($scope.menu.data.weekdays);

            weekDaysKeys.map(function (day) {
              $scope.menu.data.weekdays[day].map(function (station) {
                if (station.recipes.length || station.name) {
                  isRecipesAdded = true;
                }
              });
            });

            if (isEditMenu || chefsLength || titleLength || isRecipesAdded) {
              $modal({
                title: 'Are you sure you want to leave this page? All changes will be lost',
                templateUrl: 'app/components/modal/templates/confirm.html',
                customClass: 'user-create-modal',
                scope: $scope,
                controller: function ($scope) {
                  $scope.action = function () {
                    $scope.$hide();
                    $state.go('main.menu');
                  };
                },
              });
            } else {
              $state.go('main.menu');
            }
          };

          function enableSubmit() {
            $scope.disableSubmit = false;
          }
        },
      };
    });

angular.module('components.create-menu-helper.create-menu-helper', [])
  .factory('createMenuHelper', function($locale) {
    var DEFAULT_STATIONS = [
      {
        name: '',
        recipes: []
      },
      {
        name: '',
        recipes: []
      },
      {
        name: '',
        recipes: []
      },
      {
        name: '',
        recipes: []
      }
    ];

    var menu = {
      data: {
        title: '',
        start_date: '',
        weekdays: {
          mon: [],
          tue: [],
          wed: [],
          thu: [],
          fri: [],
          sat: [],
          sun: []
        },
        assigned_chefs: []
      },
      emptyStation: {
        name: '',
        recipes: []
      }
    };

    angular.forEach(menu.data.weekdays, function(weekday, field) {
      menu.data.weekdays[field] = angular.copy(DEFAULT_STATIONS);
    });

    return {
      getMenuData: function() {
        return angular.copy(menu);
      },

      getShortDays: function() {
        var shortDays = angular.copy($locale.DATETIME_FORMATS.SHORTDAY);
        shortDays.push(shortDays.shift());

        return shortDays;
      },

      getScheduleHours: function() {
        var scheduleHours = [],
            h = 6,
            m = ':00',
            hh = ':30',
            ampm = ' am',
            isSwitched = false;

        for(var i = 0; i < 35; i++) {
          var postfix = i % 2 ? hh : m;

          if(h > 12) {
            h = 1;
            isSwitched = false;
          }

          if(h >= 12 && !isSwitched) {
            ampm = ampm === ' am' ? ' pm' : ' am';
            isSwitched = true;
          }

          scheduleHours.push(h + postfix + ampm);

          if (i % 2) h++;
        }

        return scheduleHours;
      }
    }
  });

angular.module('components.data-access.api.user-list-service', ['ngResource'])
  .factory('userListApiService', function($resource, API_URL, CONFIRM_URL) {
    var URL = API_URL + '/:type/:id';

    var userListApi = $resource(URL, {limit: '@limit', offset: '@offset', id: '@id'}, {
      getUsers: {
        method: 'GET',
        params: {
          type: 'users'
        },
        transformResponse: function(res) {
          res = res ? JSON.parse(res) : {};
          res.data = res.data ? res.data.map(function(user) {
            user.fullName = user.first_name + ' ' + user.last_name;
            return user;
          }) : {};

          return res;
        }
      },

      createUser: {
        method: 'POST',
        params: {
          type: 'users'
        },
        transformResponse: function(res) {
          res = JSON.parse(res);
          res.fullName = res.first_name + ' ' + res.last_name;

          return res;
        }
      },

      updateUser: {
        method: 'PUT',
        params: {
          type: 'users'
        },
        transformResponse: function(res) {
          res = JSON.parse(res);
          res.fullName = res.first_name + ' ' + res.last_name;

          return res;
        }
      },

      getLocalChefs: {
        method: 'GET',
        params: {
          type: 'menus',
          id: 'chefs'
        },
        isArray: true
      },

      deleteUser: {
        method: 'DELETE',
        params: {
          type: 'users'
        }
      }
    });

    return {
      getAllUsers: function() {
        return userListApi.getUsers({limit: 1000, offset: 0}).$promise;
      },

      createUser: function(user) {
        user.role_id = user.role_id.id;
        user.confirm_url = CONFIRM_URL;

        return userListApi.createUser(user).$promise;
      },

      updateUser: function(user) {
        user.role_id = user.role_id.id;

        return userListApi.updateUser(user).$promise;
      },

      deleteUser: function(id) {
        return userListApi.deleteUser({id: id}).$promise;
      },

      getLocalChefs: function() {
        return userListApi.getLocalChefs().$promise;
      }
    }
  });

angular.module('components.data-access.api.user-api-service', ['ngResource'])
  .factory('userApiService', function($resource, API_URL, CONFIRM_URL) {
    var URL = API_URL + '/:type/:action';

    var userApi = $resource(URL, {}, {
      login: {
        method: 'POST',
        params: {
          type: 'session'
        }
      },

      resetPassword: {
        method: 'POST',
        params: {
          type: 'users',
          action: 'reset-password'
        }
      },

      changePassword: {
        method: 'PUT',
        params: {
          type: 'users',
          action: 'update-password'
        }
      },

      checkResetToken: {
        method: 'POST',
        params: {
          type: 'users',
          action: 'check-password-reset-token'
        }
      }
    });

    return {
      login: function(user) {
        return userApi.login(user).$promise;
      },

      resetPassword: function(email) {
        var data = {
          email: email,
          'confirm_url': CONFIRM_URL
        };

        return userApi.resetPassword(data).$promise;
      },

      changePassword: function(password, resetToken) {
        var data = {
          'reset_token': resetToken,
          'new_password': password
        };

        return userApi.changePassword(data).$promise;
      },

      checkResetToken: function(resetToken) {
        var data = {
          'reset_token': resetToken
        };

        return userApi.checkResetToken(data).$promise;
      }
    }
  });

angular.module('components.data-access.api.recipe-api-service', ['ngResource'])
  .factory('recipeApiService', function($resource, API_URL) {
    var URL = API_URL + '/:type/:action/:id/:size';

    function getIds(arr) {
      return Array.isArray(arr) ? arr.map(function(el) {
        return el.id;
      }) : arr.id;
    }

    var recipeApi = $resource(URL, {}, {
      createRecipe: {
        method: 'POST',
        params: {
          type: 'recipes'
        }
      },

      updateRecipe: {
        method: 'PUT',
        params: {
          type: 'recipes',
          id: '@id'
        }
      },

      deleteRecipe: {
        method: 'DELETE',
        params: {
          type: 'recipes'
        }
      },

      getFilters: {
        method: 'GET',
        params: {
          type: 'recipes',
          action: 'general-options-list'
        }
      },

      getRecipe: {
        method: 'GET',
        params: {
          type: 'recipes'
        }
      },

      getSubRecipe: {
        method: 'GET',
        params: {
          action: 'subrecipes'
        }
      },

      calculateRecipe: {
        method: 'PUT',
        params: {
          type: 'recipes',
          action: 'recalculate',
          id: '@id',
          size: '@size'
        }
      },

      importRecipe: {
        method: 'GET',
        params: {
          type: 'recipes',
          action: 'import'
        }
      },

      searchRecipe: {
        method: 'GET',
        isArray: true,
        params: {
          type: 'recipes',
          action: 'search'
        }
      },

      getNutritionFacts: {
        method: 'POST',
        isArray: true,
        params: {
          type: 'ingredients',
          action: 'calc'
        }
      },

      getIngredients: {
        method: 'GET',
        params: {
          type: 'ingredients',
          action: 'nid',
          unit: 'unit',
          amount: 'amount'
        }
      },

      searchIngredients: {
        method: 'GET',
        params: {
          type: 'ingredients',
          action: 'search'
        },
        isArray: true
      }
    });

    return {
      filterPromise: {},

      saveFilters: function(data) {
        this.filterPromise.data = angular.copy(data);
      },

      getDefaultFilters: function() {
        return this.filterPromise.data || this.getFilters();
      },

      createRecipe: function(recipe, isCopy) {
        var recipeCopy = angular.copy(recipe);

        var recipeData = {
          title: isCopy ? 'Copy of ' + recipeCopy.mainRecipe.title : recipeCopy.mainRecipe.title,
          serving: recipeCopy.mainRecipe.serving,
          portion: {
            size: recipeCopy.mainRecipe.portion.size,
            unit: getIds(recipeCopy.mainRecipe.portion.unit)
          },
          categories_id: getIds(recipeCopy.mainRecipe.categories),
          allergens_id: getIds(recipeCopy.mainRecipe.allergens),
          dietaries_id: getIds(recipeCopy.mainRecipe.dietaries),
          sub_recipes: recipeCopy.recipes.map(function(subrecipe, index) {
            subrecipe.ingredients = subrecipe.ingredients.map(function(ingredient) {
              var ing = {
                id: ingredient.nid - 0,
                amount: ingredient.amount,
                unit_id: getIds(ingredient.unit)
              };

              if(!ingredient.nid) {
                ing = {
                  amount: ingredient.amount,
                  custom: {
                    name: ingredient.name,
                    unit: {
                      calories: ingredient.calories - 0,
                      total_fat: ingredient.total_fat - 0,
                      saturated_fat: ingredient.saturated_fat ? ingredient.saturated_fat - 0 : 0,
                      cholesterol: ingredient.cholesterol - 0,
                      sodium: ingredient.sodium - 0,
                      carbohydrate: ingredient.carbohydrate - 0,
                      dietary_fiber: ingredient.dietary_fiber - 0,
                      protein: ingredient.protein - 0,
                      sugar: ingredient.sugar - 0,
                      name: ingredient.unit.value
                    }
                  }
                }
              }

              return ing;
            });

            return {
              title: index === 0 ? recipeCopy.mainRecipe.title : subrecipe.title,
              ingredients: subrecipe.ingredients,
              methods: subrecipe.methods.filter(function(method) {
                return !!method.desc;
              })
            }
          })
        };

        if(recipeCopy.mainRecipe.cuisine && recipeCopy.mainRecipe.cuisine.id) {
          recipeData.cuisine_id = getIds(recipeCopy.mainRecipe.cuisine);
        }

        if(recipeCopy.mainRecipe.photo) {
          recipeData.photo = recipeCopy.mainRecipe.photo.id || recipeCopy.mainRecipe.photo;
        }

        return recipeApi.createRecipe(recipeData).$promise;
      },

      updateRecipe: function(recipe) {
        var recipeCopy = angular.copy(recipe);

        var recipeData = {
          id: recipeCopy.id,
          title: recipeCopy.mainRecipe.title,
          serving: recipeCopy.mainRecipe.serving,
          portion: {
            size: recipeCopy.mainRecipe.portion.size,
            unit: getIds(recipeCopy.mainRecipe.portion.unit)
          },
          categories_id: getIds(recipeCopy.mainRecipe.categories),
          allergens_id: getIds(recipeCopy.mainRecipe.allergens),
          dietaries_id: getIds(recipeCopy.mainRecipe.dietaries),
          sub_recipes: recipeCopy.recipes.map(function(subrecipe, index) {
            subrecipe.ingredients = subrecipe.ingredients.map(function(ingredient) {
              var ing = {
                id: ingredient.nid - 0,
                amount: ingredient.amount,
                unit_id: getIds(ingredient.unit)
              };

              if(!ingredient.nid) {
                ing = {
                  amount: ingredient.amount,
                  custom: {
                    name: ingredient.name,
                    unit: {
                      calories: ingredient.calories - 0,
                      total_fat: ingredient.total_fat - 0,
                      saturated_fat: ingredient.saturated_fat ? ingredient.saturated_fat - 0 : 0,
                      cholesterol: ingredient.cholesterol - 0,
                      sodium: ingredient.sodium - 0,
                      carbohydrate: ingredient.carbohydrate - 0,
                      dietary_fiber: ingredient.dietary_fiber - 0,
                      protein: ingredient.protein - 0,
                      sugar: ingredient.sugar - 0,
                      name: ingredient.unit.value
                    }
                  }
                }
              }

              return ing;
            });

            return {
              title: index === 0 ? recipeCopy.mainRecipe.title : subrecipe.title,
              ingredients: subrecipe.ingredients,
              methods: subrecipe.methods.filter(function(method) {
                return !!method.desc;
              })
            }
          }),
          photo: (recipeCopy.mainRecipe.photo && recipeCopy.mainRecipe.photo.id) || recipeCopy.mainRecipe.photo
        };

        if(recipeCopy.mainRecipe.cuisine && recipeCopy.mainRecipe.cuisine.id) {
          recipeData.cuisine_id = getIds(recipeCopy.mainRecipe.cuisine);
        }

        return recipeApi.updateRecipe(recipeData).$promise;
      },

      patchRecipe: function(recipe) {
        var recipeCopy = angular.copy(recipe);

        var recipeData = {
          id: recipeCopy.id,
          title: recipeCopy.title,
          serving: recipeCopy.serving,
          portion: recipeCopy.portion,
          categories_id: getIds(recipeCopy.categories),
          allergens_id: getIds(recipeCopy.allergens),
          dietaries_id: getIds(recipeCopy.dietaries),
          sub_recipes: recipeCopy.sub_recipes.map(function(subrecipe) {
            subrecipe.ingredients = subrecipe.ingredients.map(function(ingredient) {
              var ing = {
                id: ingredient.id - 0,
                amount: ingredient.amount,
                unit_id: getIds(ingredient.unit)
              };
              if(ingredient.user_title) {
                ing.user_title = ingredient.user_title;
              }

              return ing;
            });

            return {
              title: subrecipe.title,
              ingredients: subrecipe.ingredients,
              methods: subrecipe.methods.filter(function(method) {
                return !!method.desc;
              })
            }
          }),
          photo: (recipeCopy.photo && recipeCopy.photo.id) || recipeCopy.photo
        };

        if(recipeCopy.cuisine && recipeCopy.cuisine.id) {
          recipeData.cuisine_id = getIds(recipeCopy.cuisine);
        }

        return recipeApi.updateRecipe(recipeData).$promise;
      },

      deleteRecipe: function(id) {
        return recipeApi.deleteRecipe({id: id}).$promise;
      },

      getFilters: function() {
        return recipeApi.getFilters().$promise;
      },

      getRecipe: function(recipeId) {
        return recipeApi.getRecipe({id: recipeId || '', limit: 51}).$promise;
      },

      getSubRecipe: function(subRecipeId) {
        return recipeApi.getSubRecipe({id: subRecipeId}).$promise;
      },

      calculateRecipe: function(data) {
        return recipeApi.calculateRecipe(data).$promise;
      },

      importRecipe: function(recipeUrl) {
        return recipeApi.importRecipe({url: recipeUrl}).$promise;
      },

      filterRecipes: function(categories, offset, sort) {
        sort = sort || {};
        offset = offset || 0;
        var options = {
          'category[]': categories['category[]'],
          'cuisine[]': categories['cuisine[]'],
          'dietary[]': categories['dietary[]'],
          limit: 51,
          offset: offset,
          sort: sort.predicate,
          direction: sort.dir
        };
        return recipeApi.getRecipe(options).$promise;
      },

      getPhotoUrl: function() {
        return API_URL + '/recipes/photo';
      },

      searchRecipe: function(search) {
        return recipeApi.searchRecipe({q: search}).$promise;
      },

      getIngredients: function(data) {
        return recipeApi.getIngredients({id: data.nid, unit: data.unit, amount: data.amount}).$promise;
      },

      searchIngredients: function(search) {
        return recipeApi.searchIngredients({q: search}).$promise;
      },

      getNutritionFacts: function(ingredient) {
        var ing = angular.copy(ingredient);
        ing.unit = ing.unit.value;
        delete ing.name;
        delete ing.amount;

        return recipeApi.getNutritionFacts(ing).$promise;
      }
    }
  });

angular.module('components.data-access.api.menu-api-service', ['ngResource'])
  .factory('menuApiService', function($resource, $http, API_URL, moment, $filter) {
    function transformMenuData(menuData, skipDelete, isCopy) {
      menuData.assigned_chefs = menuData.assigned_chefs && menuData.assigned_chefs.length ? menuData.assigned_chefs.map(function(chef) {
        return chef.id;
      }) : [];
      menuData.start_date = $filter('date')(menuData.start_date, 'yyyy-MM-dd');
      angular.forEach(menuData.weekdays, function(weekday) {
        weekday.forEach(function(day, index) {
          weekday[index] = {
            name: day.name,
            recipes: day.recipes
          };

          weekday[index].recipes = day.recipes.map(function(recipe) {
            return {recipe_id: recipe.id, price: recipe.price};
          })
        });
      });

      if(menuData.id && !skipDelete) {
        delete menuData.id;
        delete menuData.author_chef_name;
      }

      if(isCopy) {
        menuData.title = 'Copy of ' + menuData.title;
      }
    }

    var URL = API_URL + '/:type/:action';

    var menuApi = $resource(URL, {}, {
      createMenu: {
        method: 'POST',
        params: {
          type: 'menus'
        }
      },

      updateMenu: {
        method: 'PUT',
        params: {
          type: 'menus',
          action: '@id'
        }
      },

      deleteMenu: {
        method: 'DELETE',
        params: {
          type: 'menus',
          action: '@id'
        }
      },

      getMenu: {
        method: 'GET',
        params: {
          type: 'menus'
        }
      },

      getMenuList: {
        method: 'GET',
        isArray: true,
        params: {
          type: 'menus'
        }
      }
    });

    return {
      createMenu: function(data, isCopy) {
        var menuData = angular.copy(data);
        transformMenuData(menuData, false, isCopy);

        return menuApi.createMenu(menuData).$promise;
      },

      updateMenu: function(data) {
        var menuData = angular.copy(data);
        transformMenuData(menuData, true);

        return menuApi.updateMenu(menuData).$promise;
      },

      deleteMenu: function(menuId) {
        return menuApi.deleteMenu({action: menuId}).$promise;
      },

      getMenu: function(menuId) {
        return menuApi.getMenu({action: menuId}).$promise.then(function(menuData) {
          menuData.start_date = moment(menuData.start_date).utcOffset(0)._d;

          return menuData;
        });
      },

      getMenuList: function(date) {
        return menuApi.getMenuList({date: date || $filter('date')(moment().day(1)._d, 'yyyy-MM-dd')}).$promise;
      },

      downloadMenuSheet: function(menuId) {
        return $http({
          url: API_URL + '/menus/' + menuId + '/download',
          method: 'GET'
        });
      },

      downloadMenuTemplate: function(menuId) {
        return $http({
          url: API_URL + '/menus/' + menuId + '/word',
          method: 'GET'
        });
      },

      downloadMenuPDF: function(menuId) {
        return $http({
          url: API_URL + '/export/menu/' + menuId,
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf',
            'Accept': 'application/pdf'
          },
          responseType: 'blob'
        });
      }
    }
  });

angular.module("components.catalogue.view-recipe.view-recipe",
  ["components.nutritions-table.nutritions-table", "components.data-access.title-service"])
  .directive("viewRecipe",
    function ($window, $modal, placeholderColors, NUTRITION_MAPPING,
              userService, PermPermissionStore, recipeApiService, titleService, recipeHelper) {
      return {
        restrict: "E",
        scope: {
          recipe: "=",
        },
        replace: true,
        templateUrl: "app/components/catalogue/view-recipe/view-recipe.html",
        link: function ($scope) {
          $scope.print = function () {
            return $window.print();
          };
          $scope.helper = recipeHelper;
          $scope.NUTRITION_MAPPING = NUTRITION_MAPPING;
          $scope.categoriesToPrint = [];
          $scope.addSection = [].concat($scope.recipe.allergens);
          $scope.disableApply = true;
          $scope.disableReset = $scope.recipe.serving === $scope.recipe.default.serving;

          $scope.NUTRITION_TO_PRINT_MAPPING = [
            { key: "Calories", value: "calories" },
            {
              key: "Total Fat", value: "total_fat", categories: [{
                key: "Saturated Fat", value: "saturated_fat", unit: "g",
              }], unit: "g",
            },
            { key: "Cholesterol", value: "cholesterol", unit: "mg" },
            { key: "Sodium", value: "sodium", unit: "mg " },
            {
              key: "Total Carbohydrates",
              categories: [{ key: "Dietary Fiber", value: "dietary_fiber", unit: "g" }, {
                key: "Total Sugars",
                value: "sugar",
                unit: "g",
              }],
              value: "carbohydrate",
              unit: "g",
            },
            { key: "Protein", value: "protein", unit: "g" },
          ];

          $scope.calculateIngredients = function (servingSize) {
            return recipeApiService.calculateRecipe({
              size: servingSize,
              id: $scope.recipe.id,
            }).then(function (calculatedRecipe) {
              $scope.disableApply = true;
              $scope.disableReset = $scope.recipe.serving === $scope.recipe.default.serving;
              return $scope.recipe = calculatedRecipe;
            });
          };

          $scope.onChangeServings = function () {
            $scope.disableApply = (!$scope.recipe.serving);
          };

          $scope.color = placeholderColors.getColor();

          titleService.setTitle($scope.recipe.title);

          $scope.recipe.dietaries.forEach(function (category) {
            var labelTypes = ["vegetarian", "vegan", "gluten free"];
            var categoryName = category.name.toLowerCase();

            if (labelTypes.indexOf(categoryName) + 1) {
              $scope.categoriesToPrint.push(categoryName.split(" ").join("_"));
            }
          });

          PermPermissionStore
            .definePermission("canEditRecipe", function () {
              return userService.getUser("id") === $scope.recipe.chef.id;
            });

          $scope.getIngredientsForPrint = function (ingredients) {
            var result = [];
            ingredients.forEach(function (ingredient) {
              result.push(ingredient.user_title || ingredient.name);
            });
            return result.join(", ");
          };

          $scope.openEditModal = function (ingredient) {
            return $modal({
              title: "Change ingredient name",
              templateUrl: "app/components/modal/templates/edit-ingredient.html",
              customClass: "user-create-modal",
              scope: $scope,
              controller: function ($scope) {
                $scope.ingredient = ingredient;
                $scope.ingredientName = ingredient.user_title || ingredient.name;

                $scope.resetToDefault = function (defaultValue) {
                  $scope.ingredientName = defaultValue;
                };

                $scope.action = function (ingredientName) {
                  ingredient.user_title = ingredientName;
                  $scope.disableSubmit = true;
                  return recipeApiService.patchRecipe($scope.recipe).then(function () {
                    $scope.$hide();
                  }, function enableSubmit() {
                    $scope.disableSubmit = false;
                    ingredient.user_title = ingredientName;
                  });
                };
              },
            });
          };

          $scope.transformNutritions = function() {
            $scope.recipe.sub_recipes.forEach(function(recipe) {
              recipe = $scope.helper.transformIngredients(recipe);
            });
            var totalNutritions = {};

            $scope.recipe.sub_recipes.forEach(function (recipe) {
              $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
                if (totalNutritions[nutrition.value] === undefined) {
                  totalNutritions[nutrition.value] = 0;
                }
                recipe.nutritionsSum = recipe.nutritionsSum || {};
                totalNutritions[nutrition.value] += angular.isNumber(recipe.nutritionsSum[nutrition.value] - 0) ? recipe.nutritionsSum[nutrition.value] : 0;
              });
            });
          };

          $scope.transformNutritions();

          $scope.$watch("recipe.sub_recipes", function (subRecipes) {
            if (subRecipes) {
              $scope.addSection = $scope.addSection = [].concat($scope.recipe.allergens);

              subRecipes.forEach(function (subRecipe) {
                $scope.addSection = $scope.addSection.concat(subRecipe.ingredients);
              });

              $scope.addSection = $scope.addSection.map(function (section) {
                return section.user_title ? section.user_title : section.name;
              }).join("");
            }
          }, true);
        },
      };

    }).factory("placeholderColors", function () {
  var colors = ["#FFEED6", "#ECE4F7", "#DAEFFA", "#FFF5D6", "#FCE1EF", "#E5F6D3"];

  return {
    getColor: function () {
      return colors[Math.floor(Math.random() * colors.length)];
    },
  };
});

angular.module("components.catalogue.recipe-list.recipe-list", [])
  .directive("recipeList", function ($state) {
    return {
      restrict: "E",
      scope: {
        recipes: "=",
        onSelect: "=?",
        isLoading: "=",
      },
      replace: true,
      templateUrl: "app/components/catalogue/recipe-list/recipe-list.html",
      link: function ($scope) {
        $scope.onSelect = $scope.onSelect || function (recipe) {
          return $state.go("main.view-recipe", { recipeId: recipe.id });
        };

        $scope.getRandomColor = function (num) {
          var colors = ["violet", "pink", "yellow", "green", "orange", "blue"];
          var index = Math.floor(num%6) > 5 ? 0 : Math.floor(num%6);
          return colors[index];
        };
      },
    };
  }).filter("truncate", function () {
  return function (input, chars, breakOnWord) {
    if (isNaN(chars)) return input;
    if (chars <= 0) return "";
    if (input && input.length > chars) {
      input = input.substring(0, chars);

      if (!breakOnWord) {
        var lastspace = input.lastIndexOf(" ");
        //get last space
        if (lastspace !== -1) {
          input = input.substr(0, lastspace);
        }
      } else {
        while (input.charAt(input.length - 1) === " ") {
          input = input.substr(0, input.length - 1);
        }
      }
      return input + "…";
    }
    return input;
  };
});

angular.module('components.catalogue.recipe-filters.recipe-filters', [])
  .directive('recipeFilters', function () {
    return {
      restrict: 'E',
      scope: {
        filters: '=',
        onChange: '=?',
        categoriesFilter: '=?',
        isMenuState: '=?'
      },
      templateUrl: 'app/components/catalogue/recipe-filters/recipe-filters.html',
      replace: true,
      link: function ($scope) {
        $scope.categories = {
          'cuisine[]': [],
          'category[]': [],
          'dietary[]': []
        };

        if ($scope.categoriesFilter && Object.keys($scope.categoriesFilter).length) {
          $scope.categories = initFilter($scope.categoriesFilter);
        }

        $scope.onChange = $scope.onChange || angular.noop;

        $scope.selectOption = function (data, field, name, skipChangeCb) {
          var index = $scope.categories[name].indexOf(data.id);

          if (index === -1 && data.isChecked) {
            $scope.categories[name].push(data.id);
          }
          if (index !== -1 && !data.isChecked) {
            $scope.categories[name].splice(index, 1);
          }

          !skipChangeCb && $scope.onChange($scope.categories);
        };

        $scope.selectAllOptions = function (data, field, name, checkbox) {
          data.forEach(function (category) {
            category.isChecked = checkbox.isChecked;
            $scope.selectOption(category, field, name, true);
          });

          $scope.onChange($scope.categories);
        };

        $scope.clearAll = function () {
          angular.forEach($scope.categories, function (category) {
            category.length = 0;
          });

          $scope.filters.cuisines.forEach(function (cuisine) {
            cuisine.isChecked = false;
          });

          $scope.filters.category_groups.forEach(function (categoryGroup) {
            categoryGroup.isChecked = false;
            categoryGroup.categories.forEach(function (category) {
              category.isChecked = false;
            });
          });

          $scope.onChange($scope.categories);
        };

        if ($scope.isMenuState) {
          $scope.clearAll();
        }

        function initFilter(categories) {
          $scope.filters.cuisines.forEach(function (cuisine) {
            if (categories['cuisine[]'].indexOf(cuisine.id) > -1) {
              cuisine.isChecked = true;
            }
          });

          $scope.filters.category_groups.forEach(function (categoryGroup) {
            categoryGroup.categories.forEach(function (category) {
              if (categories['category[]'].indexOf(category.id) > -1) {
                category.isChecked = true;
              }
            });
          });

          $scope.filters.dietary.forEach(function (dietary) {
            if (categories['dietary[]'].indexOf(dietary.id) > -1) {
              dietary.isChecked = true;
            }
          });

          return categories;
        }
      }
    };
  });

angular.module(
  "components.catalogue.create-recipe.create-recipe",
  ["angucomplete", "components.max-length", "components.data-access.title-service"])
  .directive("createRecipe",
    function (recipeData, titleService, $modal, $window, recipeApiService, $state, $filter, $alert, API_URL, recipeHelper, NUTRITION_MAPPING, Upload) {
      return {
        restrict: "E",
        scope: {
          options: "=",
          recipe: "=?",
        },
        templateUrl: "app/components/catalogue/create-recipe/create-recipe.html",
        link: function ($scope) {
          $scope.API_URL = API_URL;
          $scope.NUTRITION_MAPPING = NUTRITION_MAPPING;
          $scope.totalNutritions = {};
          $scope.totalNutritionsWithServing = {};
          $scope.disableSubmit = true;
          $scope.options.cuisines = $filter("orderBy")($scope.options.cuisines, "name");

          $scope.recipeData = angular.copy(recipeData);

          $scope.helper = recipeHelper;

          titleService.setTitle($scope.recipe ? "Edit recipe" : "Create recipe");

          $scope.selectOption = function (data, field) {
            var index = $scope.recipeData.mainRecipe[field].findIndex(function (option) {
              return option.id === data.id;
            });

            if (index !== -1) {
              $scope.recipeData.mainRecipe[field].splice(index, 1);
            } else {
              $scope.recipeData.mainRecipe[field].push(data);
            }
          };

          $scope.getColumnsCount = function (length, limit) {
            return Math.ceil(length / limit);
          };

          $scope.uploadImage = function (img, invalidFiles) {
            $scope.recipeData.mainRecipe.photo = null;

            $scope.invalidImg = !!invalidFiles.length;
            if (img) {
              $scope.img = img;
            }
          };

          $scope.onBlurIngredient = function (ingredient, name, recipe, $index) {
            $scope.helper.checkIngredient(ingredient, name, recipe, $index);
            $scope.checkSubmit();
          };

          $scope.checkSubmit = function () {
            $scope.disableSubmit = !isValidRecipe(false);
          };

          $scope.checkSubrecipe = function (subRecipe, name) {
            subRecipe.title = name;
            $scope.checkSubmit();
          };

          function enableSubmit() {
            $scope.disableSubmit = false;
          }

          function isValidRecipe(forCancel) {
            var recipeTitleLength = $scope.recipeData.mainRecipe.title ? $scope.recipeData.mainRecipe.title.length : false;
            var ingredientsLength = [];
            var methodsLength = [];
            var nutritionsLength = true;
            var isValid = false;

            $scope.recipeData.recipes.map(function (recipe) {
              recipe.methods.map(function (el) {
                if (el.desc !== "") {
                  methodsLength.push(el);
                }
              });
              recipe.ingredients.map(function (el) {
                if (el.name !== "") {
                  ingredientsLength.push(el);
                }
                if (!el.nutritionSum) {
                  nutritionsLength = false;
                }
              });
            });

            if (forCancel) {
              isValid = (recipeTitleLength || ingredientsLength.length || methodsLength.length);
            } else {
              isValid = (recipeTitleLength && ingredientsLength.length && nutritionsLength);
            }

            return isValid;
          }

          $scope.removeByIndex = function (recipe, index, recipeArr, title) {
            return $modal({
              title: "Are you sure want to delete this " + title + "?",
              templateUrl: "app/components/modal/templates/confirm.html",
              customClass: "user-create-modal",
              scope: $scope,
              controller: function ($scope) {
                $scope.action = function () {
                  recipe.splice(index, 1);
                  $scope.$hide();
                  $scope.changeAmount(recipeArr || recipe, index <= 0 ? index : index - 1);
                };
              },
            });
          };

          $scope.editNutritions = function (ingredient, recipe, $index) {
            return $modal({
              title: "Nutrition facts",
              templateUrl: "app/components/modal/templates/edit-nutritions.html",
              customClass: "user-create-modal",
              scope: $scope,
              controller: function ($scope) {
                $scope.originalVal = angular.copy(ingredient);
                $scope.ingredient = ingredient;

                $scope.cancel = function () {
                  recipe.ingredients[$index] = $scope.originalVal;
                  $scope.$hide();
                };

                $scope.edit = function () {
                  if ($scope.ingredient.unit.id !== "lbs" && $scope.ingredient.unit.id !== "qty") {
                    recipeApiService.getNutritionFacts($scope.ingredient).then(function (units) {
                      $scope.ingredient.units = units;
                      $scope.changeAmount(recipe, $index);
                      $scope.$hide();
                    });
                  } else {
                    $scope.changeAmount(recipe, $index);
                    $scope.$hide();
                  }
                };
              },
            });
          };

          $scope.calculateTotalNutritions = function (skipAdding) {
            if (skipAdding) {
              $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
                $scope.totalNutritionsWithServing[nutrition.value] = $scope.totalNutritions[nutrition.value] / ($scope.recipeData.mainRecipe.serving || 1);
              });

              return;
            }

            $scope.recipeData.recipes.forEach(function (recipe) {
              $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
                if ($scope.totalNutritions[nutrition.value] === undefined) {
                  $scope.totalNutritions[nutrition.value] = 0;
                }
                recipe.nutritionsSum = recipe.nutritionsSum || {};
                $scope.totalNutritions[nutrition.value] += angular.isNumber(recipe.nutritionsSum[nutrition.value] - 0) ? recipe.nutritionsSum[nutrition.value] : 0;
              });
            });

            $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
              $scope.totalNutritionsWithServing[nutrition.value] = $scope.totalNutritions[nutrition.value] / $scope.recipeData.mainRecipe.serving;
            });
            $scope.checkSubmit();
          };

          $scope.changeAmount = function (recipe, $index) {
            $index = $index || 0;
            if (!recipe.ingredients || !recipe.ingredients.length) {
              return;
            }

            $scope.totalNutritions = {};

            recipe.ingredients[$index] = recipe.ingredients[$index] || { nutritionSum: {} };
            recipe.ingredients[$index].nutritionSum = {};
            recipe.nutritionsSum = {};

            recipe.ingredients.forEach(function (ingredient) {
              $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
                recipe.nutritionsSum[nutrition.value] = $scope.helper.calculateNutritionSum(recipe.nutritionsSum, ingredient, nutrition.value, 0, $scope.editRecipe);
              });
            });

            $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
              recipe.ingredients[$index].nutritionSum[nutrition.value] =
                $scope.helper.calculateNutritionSum(recipe.ingredients[$index].nutritionSum, recipe.ingredients[$index], nutrition.value, 1, $scope.editRecipe);
            });

            $scope.calculateTotalNutritions();
          };

          $scope.checkIngredient = function (ingredient, part) {
            if (!ingredient[part]) {
              ingredient[part] = "N/A";
            }
          };

          $scope.getInfo = function (value, ingredient, recipe, $index) {
            recipeApiService.getIngredients({ nid: value.originalObject.nid }).then(function (ingredients) {
              $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
                ingredient[nutrition.value] = ingredients.units[0][nutrition.value] && ingredients.units[0][nutrition.value].toFixed(2);
              });

              ingredient.units = $scope.helper.checkUnits(ingredients.units);
              ingredient.name = ingredients.name;
              ingredient.nid = ingredients.id;
              ingredient.unit = ingredient.units[0];
              ingredient.amount = recipe.ingredients[$index].amount || 1;
              ingredient.is_custom = ingredients.is_custom;

              recipe.ingredients[$index] = ingredient;

              $scope.changeAmount(recipe, $index);

              var timeout = setTimeout(function () {
                var el = document.getElementById(ingredient.nid + "_value");
                el.focus();
                clearTimeout(timeout);
              }, 10);
            });
          };

          $scope.getSubRecipe = function (value, subRecipe, recipe, $index) {
            recipeApiService.getSubRecipe(value.originalObject.id).then(function (subRecipe) {
              $scope.recipeData.recipes[$index] = subRecipe;
              subRecipe.ingredients.forEach(function (ingredient, index) {
                var unitIndex = ingredient.units.findIndex(function (unit) {
                  return unit.name === ingredient.unit.name;
                });
                if (unitIndex === -1) {
                  unitIndex = 0;
                }

                $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
                  ingredient[nutrition.value] = ingredient.units[unitIndex][nutrition.value] && ingredient.units[unitIndex][nutrition.value].toFixed(2);
                });

                if (subRecipe.ingredients[index].is_custom) {
                  var id = subRecipe.ingredients[index].unit.name === "cup" ? "cups" : subRecipe.ingredients[index].unit.name;

                  subRecipe.ingredients[index].unit = {
                    name: id,
                    id: id,
                    value: subRecipe.ingredients[index].unit.name,
                  };
                  subRecipe.ingredients[index].units = null;
                } else {
                  subRecipe.ingredients[index].nid = subRecipe.ingredients[index].id;
                  subRecipe.ingredients[index].units = subRecipe.ingredients[index].units.map(function (unit) {
                    return { name: unit.name, id: unit.id, nutritions: unit };
                  });
                  subRecipe.ingredients[index].unit = subRecipe.ingredients[index].units.find(function (unit) {
                    return subRecipe.ingredients[index].unit.id === unit.id;
                  });
                }
                $scope.changeAmount(subRecipe, index);
              });
            });
          };

          $scope.changeIngredientUnit = function (unit, recipe, $index) {
            $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
              recipe.ingredients[$index][nutrition.value] = unit.nutritions[nutrition.value].toFixed(2);
            });

            $scope.changeAmount(recipe, $index);
          };

          $scope.changeCustomIngredientUnit = function (unit, recipe, $index) {
            recipe.ingredients[$index].units = recipe.ingredients[$index].units || [];

            var nutritions = recipe.ingredients[$index].units.find(function (ing) {
              return ing.name === unit.value;
            }) || {};

            $scope.NUTRITION_MAPPING.forEach(function (nutrition) {
              recipe.ingredients[$index][nutrition.value] = nutritions[nutrition.value] ? nutritions[nutrition.value].toFixed(2) : undefined;
            });

            $scope.changeAmount(recipe, $index);
          };

          $scope.submitRecipe = function (method, isCopy) {
            var upload = {};

            if ($scope.img) {
              upload = Upload.upload({
                url: recipeApiService.getPhotoUrl(),
                data: { photo: $scope.img },
                method: "POST",
              });

              upload.then(function (photo) {
                $scope.recipeData.mainRecipe.photo = photo.data.id;
                saveRecipe(method, isCopy);
              });
            } else {
              saveRecipe(method, isCopy);
            }
          };

          function saveRecipe(method, isCopy) {
            $scope.disableSubmit = true;
            recipeApiService[method + "Recipe"]($scope.recipeData, isCopy)
              .then(function (data) {
                  $state.go("main." + (isCopy ? "edit" : "view") + "-recipe", { recipeId: data.id });
                  showAlert(isCopy, method);
                },
                enableSubmit);
          }

          function showAlert(isCopy, method) {
            var alertTitle = isCopy ? "Copy recipe has been created" :
              method === "create" ? "New recipe has been created" : "The recipe has been changed";
            $alert({
              content: "<span class=\"check-icon\"></span>" + alertTitle,
              type: "success",
              show: true,
              container: ".alert-container"
            });

          }

          $scope.deleteRecipe = function (id) {
            return $modal({
              title: "Are you sure want to delete this recipe? It may affect menus",
              templateUrl: "app/components/modal/templates/confirm.html",
              customClass: "user-create-modal",
              scope: $scope,
              controller: function ($scope) {
                $scope.action = function () {
                  return recipeApiService.deleteRecipe(id).then(function () {
                    $scope.$hide();
                    $state.go("main.catalogue");
                  });
                };
              },
            });
          };

          $scope.cancelPage = function () {
            if ($scope.recipeData.mainRecipe.id || isValidRecipe(true)) {
              $modal({
                title: "Are you sure you want to leave this page? All changes will be lost",
                templateUrl: "app/components/modal/templates/confirm.html",
                customClass: "user-create-modal",
                scope: $scope,
                controller: function ($scope) {
                  $scope.action = function () {
                    $scope.$hide();
                    if ($scope.recipeData.mainRecipe.id) {
                      $state.go("main.view-recipe", { recipeId: $scope.recipeData.mainRecipe.id });
                    } else {
                      $state.go("main.catalogue");
                    }
                  };
                },
              });
            } else {
              $state.go("main.catalogue");
            }
          };

          if ($scope.recipe) {
            $scope.editRecipe = true;
            $scope.helper.transformRecipeData($scope.recipeData, $scope.recipe, $scope.options, $scope.changeAmount);
            $scope.checkSubmit();
            if ($scope.recipe.photo) {
              $scope.imgPreview = $scope.recipe.photo;
            }
          }
        },
      };
    }).constant("NUTRITION_MAPPING", [
  { key: "Calories", value: "calories" },
  { key: "Total Fat", value: "total_fat", unit: "g" },
  { key: "Saturated Fat", value: "saturated_fat", unit: "g" },
  { key: "Cholesterol", value: "cholesterol", unit: "mg" },
  { key: "Sodium", value: "sodium", unit: "mg " },
  { key: "Total Carbohydrates", value: "carbohydrate", unit: "g" },
  { key: "Dietary Fiber", value: "dietary_fiber", unit: "g" },
  { key: "Total Sugars", value: "sugar", unit: "g" },
  { key: "Protein", value: "protein", unit: "g" },
]);

angular.module("components.catalogue.create-recipe.create-recipe").factory("recipeHelper", function (NUTRITION_MAPPING) {
  function checkUnits(units) {
    var customUnits = [];
    var ingredientUnits = [];
    var defaultUnits = ["tsp", "tbsp", "oz", "cups", "gallon", "pint", "ml", "g", "pound", "clove",
      "can", "serving", "each", "slice", "head", "bunch", "small", "medium", "large", "whole", "lbs"];

    units.forEach(function (unit) {
      if (defaultUnits.indexOf(unit.name) === -1) {
        // if unit is not default
        customUnits.push({ name: unit.name, id: unit.id, nutritions: unit });
      } else {
        ingredientUnits.push({ name: unit.name, id: unit.id, nutritions: unit });
      }
    });

    if (customUnits.length) {
      ingredientUnits.push({ name: "─────────────────", id: 0, nutritions: null, separator: true });
      ingredientUnits = ingredientUnits.concat(customUnits);
    }

    return ingredientUnits;
  }

  function transformIngredient(recipe, index) {
    if (recipe.ingredients[index].is_custom) {
      var id = recipe.ingredients[index].unit.name === 'cup' ? 'cups' : recipe.ingredients[index].unit.name;

      recipe.ingredients[index].unit = { name: id, id: id, value: recipe.ingredients[index].unit.name };
      recipe.ingredients[index].units = null;
    } else {
      recipe.ingredients[index].nid = recipe.ingredients[index].id;
      recipe.ingredients[index].units = recipe.ingredients[index].units.map(function (unit) {
        return { name: unit.name, id: unit.id, nutritions: unit };
      });
      recipe.ingredients[index].units = checkUnits(recipe.ingredients[index].units);
      // recipe.ingredients[index].defaultAmount = recipe.ingredients[index].amount;
      recipe.ingredients[index].unit = recipe.ingredients[index].units.find(function (unit) {
        return recipe.ingredients[index].unit.id === unit.id;
      });
    }

    return recipe;
  }

  function changeAmount(recipe, $index, editRecipe) {
    $index = $index || 0;

    recipe.transformedIngredients[$index] = recipe.transformedIngredients[$index] || { nutritionSum: {} };
    recipe.transformedIngredients[$index].nutritionSum = {};
    recipe.nutritionsSum = {};

    recipe.transformedIngredients.forEach(function (ingredient) {
      NUTRITION_MAPPING.forEach(function (nutrition) {
        recipe.nutritionsSum[nutrition.value] = calculateNutrition(recipe.nutritionsSum, ingredient, nutrition.value, 0, editRecipe);
      });
    });

    NUTRITION_MAPPING.forEach(function (nutrition) {
      recipe.transformedIngredients[$index].nutritionSum[nutrition.value] =
        calculateNutrition(recipe.transformedIngredients[$index].nutritionSum, recipe.transformedIngredients[$index], nutrition.value, 1, editRecipe);
    });

    return recipe;
  }

  function calculateNutrition(sum, item, prop, replaceAmount, editRecipe) {
    var value = sum[prop];
    var nutritionValue = item[prop];
    var itemDefaultAmount = (item.defaultAmount || 1);

    if (value === undefined) {
      value = 0;
    }
    if (editRecipe) {
      value += angular.isNumber(nutritionValue - 0) ? (nutritionValue / itemDefaultAmount * (item.amount || 0)) : 0;
    } else {
      value += angular.isNumber(nutritionValue - 0) ? nutritionValue * (item.amount || replaceAmount) : 0;
    }
    return value;
  }

  return {
    transformRecipeData: function (recipeData, recipe, options, changeAmount) {
      recipeData.id = recipe.id;
      recipeData.mainRecipe = recipe;
      recipeData.recipes = recipe.sub_recipes;

      recipeData.mainRecipe.categories.forEach(function (category) {
        options.category_groups.forEach(function (categoryGroup) {
          categoryGroup.categories.forEach(function (option) {
            if (category.id === option.id) {
              option.isChecked = true;
            }
          });
        });
      });

      recipeData.mainRecipe.allergens.forEach(function (allergen) {
        options.allergens.forEach(function (option) {
          if (allergen.id === option.id) {
            option.isChecked = true;
          }
        });
      });

      recipeData.mainRecipe.dietaries.forEach(function (dietary) {
        options.dietary.forEach(function (option) {
          if (dietary.id === option.id) {
            option.isChecked = true;
          }
        });
      });

      recipeData.recipes.forEach(function (recipe) {
        if (!recipe.methods.length) {
          recipe.methods.push({ desc: "" });
        }
        recipe.ingredients.forEach(function (ing, index) {
          NUTRITION_MAPPING.forEach(function (nutrition) {
            recipe.ingredients[index][nutrition.value] = recipe.ingredients[index].nutrition_facts[nutrition.value] / recipe.ingredients[index].amount;
          });

          recipe = transformIngredient(recipe, index);
          changeAmount(recipe, index);
        });
      });

      recipeData.mainRecipe.portion.unit = recipeData.unit.availableOptions.find(function (option) {
        return recipe.portion.unit === option.id;
      });
    },

    calculateNutritionSum: function (sum, item, prop, replaceAmount, editRecipe) {
      return calculateNutrition(sum, item, prop, replaceAmount, editRecipe);
    },

    transformIngredients: function (recipe) {
      recipe.transformedIngredients = [];
      recipe.ingredients.forEach(function (ingredient, index) {
        NUTRITION_MAPPING.forEach(function (nutrition) {
          recipe.ingredients[index][nutrition.value] = recipe.ingredients[index].nutrition_facts[nutrition.value];
        });

        recipe = transformIngredient(recipe, index);
        recipe.transformedIngredients[index] = ingredient;
        recipe = changeAmount(recipe, index, true);
      });

      return recipe;
    },

    addRecipeIngredient: function (ingredients) {
      ingredients.push({
        id: 0,
        name: "",
        total_fat: "-",
        carbohydrate: "-",
        protein: "-",
        calories: "-",
        sugar: "-",
        amount: 1,
        unit: { id: "lbs", name: "lbs", value: "lbs" },
      });
    },

    checkIngredient: function (ingredient, name, recipe, $index) {
      if (recipe.ingredients[$index].name !== name) {
        recipe.ingredients[$index] = {
          name: name,
          total_fat: undefined,
          carbohydrate: undefined,
          protein: undefined,
          calories: undefined,
          sugar: undefined,
          amount: 1,
          unit: { id: "lbs", name: "lbs", value: "lbs" },
        };
      }
    },

    addRecipe: function (array) {
      array.push({
        subrecipe: "Sub Recipe",
        name: "",
        ingredients: [
          {
            name: "",
            fat: "",
            carbs: "",
            prot: "",
            kcal: "",
            sugar: "",
            amount: 1,
            unit: { id: "lbs", name: "lbs", value: "lbs" },
            nutritionsSum: {},
          },
        ],
        methods: [
          {
            desc: "",
          },
        ],
        nutritionsSum: {},
      });
    },

    addRecipeMethod: function (methods, index) {
      methods.splice(index + 1, 0, {
        desc: "",
      });
      // methods.push({
      //   desc: "",
      // });
    },

    checkUnits: function (units) {
      return checkUnits(units);
    },
  };
})
  .constant("recipeData", {
    unit: {
      availableOptions: [
        { id: "oz", name: "oz", value: "oz" },
        { id: "cups", name: "Cups", value: "cup" },
        { id: "qty", name: "Quantity", value: "qty" },
      ],
      selectedOption: { id: "oz", name: "oz", value: "oz" },
    },
    ingredientUnits: {
      availableOptions: [
        { id: "lbs", name: "lbs", value: "lbs" },
        { id: "tsp", name: "tsp", value: "tsp" },
        { id: "tbsp", name: "tbsp", value: "tbsp" },
        { id: "oz", name: "oz", value: "oz" },
        { id: "cups", name: "cups", value: "cup" },
        { id: "qty", name: "qty", value: "qty" },
      ],
      selectedOption: { id: "lbs", name: "lbs", value: "lbs" },
    },
    mainRecipe: {
      title: "",
      categories: [],
      allergens: [],
      cuisine: [],
      dietaries: [],
      serving: 1,
      portion: {
        size: 1,
        unit: { id: "oz", name: "oz", value: "oz" },
      },
    },
    recipes: [
      {
        title: "Main Recipe",
        ingredients: [
          {
            name: "",
            total_fat: "-",
            carbohydrate: "-",
            protein: "-",
            calories: "-",
            amount: 0,
            unit: { id: "lbs", name: "lbs", value: "lbs" },
          },
        ],
        methods: [
          {
            desc: "",
          },
        ],
        nutritionsSum: {},
      },
    ],
  });

angular.module('components.catalogue.catalogue-pagination.catalogue-pagination', [])
  .directive('cataloguePagination', function () {
    function getPagesArray(totalPages) {
      var pagesArray = [];

      for (var i = 0; i <= totalPages; i++) {
        pagesArray.push(i);
      }

      return chunk(pagesArray, 10);
    }

    function chunk(array, chunkSize) {
      return [].concat.apply([],
        array.map(function (elem, i) {
          return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
        })
      );
    }

    return {
      restrict: 'E',
      scope: {
        data: '=',
        onSetPage: '=?',
      },
      replace: true,
      templateUrl: 'app/components/catalogue/catalogue-pagination/catalogue-pagination.html',
      link: {
        pre: function($scope) {
          $scope.currentPage = 0;
          $scope.onSetPage = $scope.onSetPage || angular.noop;
          $scope.currentChunk = 0;

          $scope.setPage = function (page, $event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.currentPage = page;
            $scope.onSetPage($scope.currentPage * $scope.data.per_page);
          };

          $scope.setChunk = function (index, $event) {
            $event.preventDefault();
            $scope.currentChunk = $scope.currentChunk + index;
          };

          $scope.$watch('data', function (data) {
            if (data) {
              $scope.pagination = data;
              $scope.pages = getPagesArray(Math.floor((data.total - 1) / data.per_page));
              if (data.current_page === 0) {
                $scope.currentPage = 0;
              } else {
                $scope.currentPage = Math.ceil(data.current_page / data.per_page);
                $scope.currentChunk = Math.floor(($scope.currentPage - 1) / 10);
              }
            }
          });
        },
      },
    };
  });

angular.module('components.user-login.user-login', [
  'components.data-access.user-service',
  'components.alert.alert'
]).directive('userLogin', function (userService, $alert, $state) {
  return {
    scope: {
      tplType: '@'
    },
    templateUrl: 'app/components/user-login/user-login.html',
    link: function ($scope) {
      $scope.tplType = $scope.tplType || 'login'

      $scope.user = {
        email: userService.getUser('email'),
        isPasswordReset: this.isPasswordReset || userService.getUser('isPasswordReset')
      }

      if ( $scope.tplType === 'change-password' && !!userService.getResetToken() ) {
        userService.checkResetToken().then(function () {}, function () {
          $alert({
            content: 'This link is expired or has already been used. <br>Please provide your Guest Services login email and request a new link',
            type: 'info',
            show: true,
            container: '.password-reset-alert-wrapper'
          })

          $state.go('forgot-password')
        })
      }

      $scope.login = function ($event) {
        if ( $scope.loginForm.$valid && !$scope.disableSubmit ) {
          $scope.submit('login', $scope.user, $event)
        }
      }

      $scope.submit = function (action, data, $event) {
        if ( $event ) {
          $event.preventDefault()
          $event.stopPropagation()
        }

        $scope.disableSubmit = true
        userService[action](data).then(function () {
          $scope.isUserExist = true
          $scope.disableSubmit = false
          if ( action === 'resetPassword' ) {
            return $alert({
              content: 'Email with a link to restore your password has been sent to <span class="text-weight-bold">' + $scope.user.email + '</span> address',
              type: 'success',
              show: true,
              container: '.password-reset-alert-wrapper'
            })
          }
        }, function () {
          $scope.isUserExist = false
          $scope.disableSubmit = false
        })
      }

      $scope.$watch('user.email', function (email) {
        if ( email ) {
          userService.setUser({ email: email })
        }
      })
    }
  }
}).directive('equals', function () {
  return {
    require: 'ngModel',
    link: function ($scope, $element, $attrs, $ctrl) {
      $ctrl.$validators.equals = function (modelValue, viewValue) {
        return $ctrl.$$parentForm[$attrs.equals].$viewValue === viewValue
      }
    }
  }
}).directive('onEnterPress', function () {
  return function ($scope, $element, $attrs) {
    $element.bind('keyup', function (e) {
      if ( e.which === 13 ) {
        $scope.$apply(function () {
          $scope.$eval($attrs.onEnterPress)
        })
      }
    })
  }
})

angular.module('components.user-list-table.user-list-table',
  ['components.tooltip.tooltip', 'components.pagination.pagination', 'components.data-access.title-service',])
  .directive('userListTable', function($modal, $alert, userListApiService, titleService) {
    return {
      restrict: 'E',
      scope: {
        users: '=',
        mapping: '=?'
      },
      templateUrl: 'app/components/user-list-table/user-list-table.html',
      link: function($scope) {
        $scope.ACCEPTED_USER_ROLES = [
          {name: 'Main Chef', value: 'Main_Chef', id: 2},
          {name: 'Local Chef', value: 'Local_Chef', id: 3},
          {name: 'Admin', value: 'Admin', id: 1}
        ];
        titleService.setTitle('Users');

        $scope.openUserCreateModal = function() {
          return $modal({
            title: 'Create New User',
            templateUrl: 'app/components/modal/templates/user-create.tpl.html',
            customClass: 'user-create-modal',
            scope: $scope,
            controller: function($scope) {
              $scope.newUser = {
                role_id: $scope.ACCEPTED_USER_ROLES[1]
              };

              $scope.createUser = function($event) {
                $event.preventDefault();
                $event.stopPropagation();
                var reqData = angular.copy($scope.newUser);

                userListApiService.createUser(reqData).then(function(data) {
                  $scope.users.push(data);
                  $scope.setPage($scope.from, $scope.to);
                  $scope.$hide();
                  $alert({
                    content: '<span class="check-icon"></span>New user was created',
                    type: 'success',
                    show: true,
                    container: '.alert-container'
                  });
                }, function(res) {
                  if(res.status === 409) {
                    $scope.emailAlreadyTaken = true;
                  }
                })
              };
            }
          });
        };

        $scope.openUserEditModal = function(user) {
          return $modal({
            title: 'Edit User',
            templateUrl: 'app/components/modal/templates/user-edit.tpl.html',
            customClass: 'user-create-modal',
            scope: $scope,
            controller: function($scope) {

              var role = $scope.ACCEPTED_USER_ROLES.find(function(role) {
                return user['role_id'] === role.id;
              });

              $scope.user = {
                'first_name': user['first_name'],
                'last_name': user['last_name'],
                role_id: role,
                id: user.id
              };

              $scope.email = user.email;

              $scope.editUser = function($event) {
                $event.preventDefault();
                $event.stopPropagation();

                var reqData = angular.copy($scope.user);

                userListApiService.updateUser(reqData).then(function(data) {

                  var index = $scope.users.findIndex(function(user) {
                    return user.id === data.id;
                  });

                  var filteredIndex = $scope.filteredUsers.findIndex(function(user) {
                    return user.id === data.id;
                  });

                  $scope.users[index] = data;
                  $scope.filteredUsers[filteredIndex] = data;

                  $scope.$hide();
                  $alert({
                    content: '<span class="edit-icon"></span>User ' + data.fullName + ' was changed successfully',
                    type: 'success',
                    show: true,
                    container: '.alert-container'
                  });
                })
              };
            }
          });
        };

        $scope.openUserRemoveModal = function(id) {
          return $modal({
            title: 'Are you sure want to delete this user?',
            templateUrl: 'app/components/modal/templates/user-remove.tpl.html',
            customClass: 'user-create-modal',
            scope: $scope,
            controller: function($scope) {
              $scope.removeUser = function() {
                userListApiService.deleteUser(id).then(function() {
                  var index = $scope.users.findIndex(function(user) {
                    return user.id === id;
                  });
                  var deletedUser = $scope.users[index].fullName;
                  $scope.users.splice(index, 1);
                  $scope.setPage($scope.from, $scope.to);
                  $scope.$hide();
                  $alert({
                    content: '<span class="delete-icon"></span>User ' + deletedUser + ' was deleted',
                    type: 'info',
                    show: true,
                    container: '.alert-container'
                  });
                });
              };
            }
          });
        };

        $scope.setPage = function(from, to) {
          $scope.from = from || 0;
          $scope.to = to || 50;
          $scope.filteredUsers = $scope.users.slice($scope.from, $scope.to);
        };

        $scope.setPage($scope.from, $scope.to);
      }
    }
  });

angular.module('components.tooltip.tooltip', ['components.tooltip.dimensions-helper'])
  .provider('$tooltip', function () {

    var defaults = this.defaults = {
      animation: 'am-fade',
      customClass: '',
      prefixClass: 'tooltip',
      prefixEvent: 'tooltip',
      container: false,
      target: false,
      placement: 'top',
      templateUrl: 'app/components/tooltip/tooltip.html',
      template: '',
      titleTemplate: false,
      trigger: 'hover focus',
      keyboard: false,
      html: false,
      show: false,
      title: '',
      type: '',
      delay: 0,
      autoClose: false,
      bsEnabled: true,
      mouseDownPreventDefault: true,
      mouseDownStopPropagation: true,
      viewport: {
        selector: 'body',
        padding: 0
      }
    };

    this.$get = function ($window, $rootScope, $bsCompiler, $q, $templateCache, $http, $animate, $sce, dimensions, $$rAF, $timeout) {

      var isNative = /(ip[ao]d|iphone|android)/ig.test($window.navigator.userAgent);
      var isTouch = ('createTouch' in $window.document) && isNative;
      var $body = angular.element($window.document);

      function TooltipFactory (element, config) {

        var $tooltip = {};

        // Common vars
        var options = $tooltip.$options = angular.extend({}, defaults, config);
        var promise = $tooltip.$promise = $bsCompiler.compile(options);
        var scope = $tooltip.$scope = options.scope && options.scope.$new() || $rootScope.$new();

        var nodeName = element[0].nodeName.toLowerCase();
        if (options.delay && angular.isString(options.delay)) {
          var split = options.delay.split(',').map(parseFloat);
          options.delay = split.length > 1 ? {show: split[0], hide: split[1]} : split[0];
        }

        // Store $id to identify the triggering element in events
        // give priority to options.id, otherwise, try to use
        // element id if defined
        $tooltip.$id = options.id || element.attr('id') || '';

        // Support scope as string options
        if (options.title) {
          scope.title = $sce.trustAsHtml(options.title);
        }

        // Provide scope helpers
        scope.$setEnabled = function (isEnabled) {
          scope.$$postDigest(function () {
            $tooltip.setEnabled(isEnabled);
          });
        };
        scope.$hide = function () {
          scope.$$postDigest(function () {
            $tooltip.hide();
          });
        };
        scope.$show = function () {
          scope.$$postDigest(function () {
            $tooltip.show();
          });
        };
        scope.$toggle = function () {
          scope.$$postDigest(function () {
            $tooltip.toggle();
          });
        };
        // Publish isShown as a protected var on scope
        $tooltip.$isShown = scope.$isShown = false;

        // Private vars
        var timeout;
        var hoverState;

        // Fetch, compile then initialize tooltip
        var compileData;
        var tipElement;
        var tipContainer;
        var tipScope;
        promise.then(function (data) {
          compileData = data;
          $tooltip.init();
        });

        $tooltip.init = function () {

          // Options: delay
          if (options.delay && angular.isNumber(options.delay)) {
            options.delay = {
              show: options.delay,
              hide: options.delay
            };
          }

          // Replace trigger on touch devices ?
          // if(isTouch && options.trigger === defaults.trigger) {
          //   options.trigger.replace(/hover/g, 'click');
          // }

          // Options : container
          if (options.container === 'self') {
            tipContainer = element;
          } else if (angular.isElement(options.container)) {
            tipContainer = options.container;
          } else if (options.container) {
            tipContainer = findElement(options.container);
          }

          // Options: trigger
          bindTriggerEvents();

          // Options: target
          if (options.target) {
            options.target = angular.isElement(options.target) ? options.target : findElement(options.target);
          }

          // Options: show
          if (options.show) {
            scope.$$postDigest(function () {
              if (options.trigger === 'focus') {
                element[0].focus();
              } else {
                $tooltip.show();
              }
            });
          }

        };

        $tooltip.destroy = function () {

          // Unbind events
          unbindTriggerEvents();

          // Remove element
          destroyTipElement();

          // Destroy scope
          scope.$destroy();

        };

        $tooltip.enter = function () {

          clearTimeout(timeout);
          hoverState = 'in';
          if (!options.delay || !options.delay.show) {
            return $tooltip.show();
          }

          timeout = setTimeout(function () {
            if (hoverState === 'in') $tooltip.show();
          }, options.delay.show);

        };

        $tooltip.show = function () {
          if (!options.bsEnabled || $tooltip.$isShown) return;

          scope.$emit(options.prefixEvent + '.show.before', $tooltip);
          if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
            options.onBeforeShow($tooltip);
          }
          var parent;
          var after;
          if (options.container) {
            parent = tipContainer;
            if (tipContainer[0].lastChild) {
              after = angular.element(tipContainer[0].lastChild);
            } else {
              after = null;
            }
          } else {
            parent = null;
            after = element;
          }


          // Hide any existing tipElement
          if (tipElement) destroyTipElement();
          // Fetch a cloned element linked from template
          tipScope = $tooltip.$scope.$new();
          tipElement = $tooltip.$element = compileData.link(tipScope, function (clonedElement, scope) {});

          // Set the initial positioning.  Make the tooltip invisible
          // so IE doesn't try to focus on it off screen.
          tipElement.css({top: '-9999px', left: '-9999px', right: 'auto', display: 'block', visibility: 'hidden'});

          // Options: animation
          if (options.animation) tipElement.addClass(options.animation);
          // Options: type
          if (options.type) tipElement.addClass(options.prefixClass + '-' + options.type);
          // Options: custom classes
          if (options.customClass) tipElement.addClass(options.customClass);

          // Append the element, without any animations.  If we append
          // using $animate.enter, some of the animations cause the placement
          // to be off due to the transforms.
          if (after) {
            after.after(tipElement);
          } else {
            parent.prepend(tipElement);
          }

          $tooltip.$isShown = scope.$isShown = true;
          safeDigest(scope);

          // Now, apply placement
          $tooltip.$applyPlacement();

          // Once placed, animate it.
          // Support v1.2+ $animate
          // https://github.com/angular/angular.js/issues/11713
          if (angular.version.minor <= 2) {
            $animate.enter(tipElement, parent, after, enterAnimateCallback);
          } else {
            $animate.enter(tipElement, parent, after).then(enterAnimateCallback);
          }
          safeDigest(scope);

          $$rAF(function () {
            // Once the tooltip is placed and the animation starts, make the tooltip visible
            if (tipElement) tipElement.css({visibility: 'visible'});

            // Bind events
            if (options.keyboard) {
              if (options.trigger !== 'focus') {
                $tooltip.focus();
              }
              bindKeyboardEvents();
            }
          });

          if (options.autoClose) {
            bindAutoCloseEvents();
          }

        };

        function enterAnimateCallback () {
          scope.$emit(options.prefixEvent + '.show', $tooltip);
          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
            options.onShow($tooltip);
          }
        }

        $tooltip.leave = function () {

          clearTimeout(timeout);
          hoverState = 'out';
          if (!options.delay || !options.delay.hide) {
            return $tooltip.hide();
          }
          timeout = setTimeout(function () {
            if (hoverState === 'out') {
              $tooltip.hide();
            }
          }, options.delay.hide);

        };

        var _blur;
        var _tipToHide;
        $tooltip.hide = function (blur) {

          if (!$tooltip.$isShown) return;
          scope.$emit(options.prefixEvent + '.hide.before', $tooltip);
          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
            options.onBeforeHide($tooltip);
          }

          // store blur value for leaveAnimateCallback to use
          _blur = blur;

          // store current tipElement reference to use
          // in leaveAnimateCallback
          _tipToHide = tipElement;

          // Support v1.2+ $animate
          // https://github.com/angular/angular.js/issues/11713
          if (angular.version.minor <= 2) {
            $animate.leave(tipElement, leaveAnimateCallback);
          } else {
            $animate.leave(tipElement).then(leaveAnimateCallback);
          }

          $tooltip.$isShown = scope.$isShown = false;
          safeDigest(scope);

          // Unbind events
          if (options.keyboard && tipElement !== null) {
            unbindKeyboardEvents();
          }

          if (options.autoClose && tipElement !== null) {
            unbindAutoCloseEvents();
          }
        };

        function leaveAnimateCallback () {
          scope.$emit(options.prefixEvent + '.hide', $tooltip);
          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
            options.onHide($tooltip);
          }

          // check if current tipElement still references
          // the same element when hide was called
          if (tipElement === _tipToHide) {
            // Allow to blur the input when hidden, like when pressing enter key
            if (_blur && options.trigger === 'focus') {
              return element[0].blur();
            }

            // clean up child scopes
            destroyTipElement();
          }
        }

        $tooltip.toggle = function (evt) {
          if (evt) { evt.preventDefault(); }
          if ($tooltip.$isShown) {
            $tooltip.leave();
          } else {
            $tooltip.enter();
          }
        };

        $tooltip.focus = function () {
          tipElement[0].focus();
        };

        $tooltip.setEnabled = function (isEnabled) {
          options.bsEnabled = isEnabled;
        };

        $tooltip.setViewport = function (viewport) {
          options.viewport = viewport;
        };

        // Protected methods

        $tooltip.$applyPlacement = function () {
          if (!tipElement) return;

          // Determine if we're doing an auto or normal placement
          var placement = options.placement;
          var autoToken = /\s?auto?\s?/i;
          var autoPlace = autoToken.test(placement);

          if (autoPlace) {
            placement = placement.replace(autoToken, '') || defaults.placement;
          }

          // Need to add the position class before we get
          // the offsets
          tipElement.addClass(options.placement);

          // Get the position of the target element
          // and the height and width of the tooltip so we can center it.
          var elementPosition = getPosition();
          var tipWidth = tipElement.prop('offsetWidth');
          var tipHeight = tipElement.prop('offsetHeight');

          // Refresh viewport position
          $tooltip.$viewport = options.viewport && findElement(options.viewport.selector || options.viewport);

          // If we're auto placing, we need to check the positioning
          if (autoPlace) {
            var originalPlacement = placement;
            var viewportPosition = getPosition($tooltip.$viewport);

            if (/bottom/.test(originalPlacement) && elementPosition.bottom + tipHeight > viewportPosition.bottom) {
              placement = originalPlacement.replace('bottom', 'top');
            } else if (/top/.test(originalPlacement) && elementPosition.top - tipHeight < viewportPosition.top) {
              placement = originalPlacement.replace('top', 'bottom');
            }

            if (/left/.test(originalPlacement) && elementPosition.left - tipWidth < viewportPosition.left) {
              placement = placement.replace('left', 'right');
            } else if (/right/.test(originalPlacement) && elementPosition.right + tipWidth > viewportPosition.width) {
              placement = placement.replace('right', 'left');
            }

            tipElement.removeClass(originalPlacement).addClass(placement);
          }

          // Get the tooltip's top and left coordinates to center it with this directive.
          var tipPosition = getCalculatedOffset(placement, elementPosition, tipWidth, tipHeight);
          applyPlacement(tipPosition, placement);
        };

        $tooltip.$onKeyUp = function (evt) {
          if (evt.which === 27 && $tooltip.$isShown) {
            $tooltip.hide();
            evt.stopPropagation();
          }
        };

        $tooltip.$onFocusKeyUp = function (evt) {
          if (evt.which === 27) {
            element[0].blur();
            evt.stopPropagation();
          }
        };

        $tooltip.$onFocusElementMouseDown = function (evt) {
          if (options.mouseDownPreventDefault) { evt.preventDefault(); }
          if (options.mouseDownStopPropagation) { evt.stopPropagation(); }
          // Some browsers do not auto-focus buttons (eg. Safari)
          if ($tooltip.$isShown) {
            element[0].blur();
          } else {
            element[0].focus();
          }
        };

        // bind/unbind events
        function bindTriggerEvents () {
          var triggers = options.trigger.split(' ');
          angular.forEach(triggers, function (trigger) {
            if (trigger === 'click' || trigger === 'contextmenu') {
              element.on(trigger, $tooltip.toggle);
            } else if (trigger !== 'manual') {
              element.on(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
              element.on(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
              if (nodeName === 'button' && trigger !== 'hover') {
                element.on(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
              }
            }
          });
        }

        function unbindTriggerEvents () {
          var triggers = options.trigger.split(' ');
          for (var i = triggers.length; i--;) {
            var trigger = triggers[i];
            if (trigger === 'click' || trigger === 'contextmenu') {
              element.off(trigger, $tooltip.toggle);
            } else if (trigger !== 'manual') {
              element.off(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
              element.off(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
              if (nodeName === 'button' && trigger !== 'hover') {
                element.off(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
              }
            }
          }
        }

        function bindKeyboardEvents () {
          if (options.trigger !== 'focus') {
            tipElement.on('keyup', $tooltip.$onKeyUp);
          } else {
            element.on('keyup', $tooltip.$onFocusKeyUp);
          }
        }

        function unbindKeyboardEvents () {
          if (options.trigger !== 'focus') {
            tipElement.off('keyup', $tooltip.$onKeyUp);
          } else {
            element.off('keyup', $tooltip.$onFocusKeyUp);
          }
        }

        var _autoCloseEventsBinded = false;
        function bindAutoCloseEvents () {
          // use timeout to hookup the events to prevent
          // event bubbling from being processed imediately.
          $timeout(function () {
            // Stop propagation when clicking inside tooltip
            tipElement.on('click', stopEventPropagation);

            // Hide when clicking outside tooltip
            $body.on('click', $tooltip.hide);

            _autoCloseEventsBinded = true;
          }, 0, false);
        }

        function unbindAutoCloseEvents () {
          if (_autoCloseEventsBinded) {
            tipElement.off('click', stopEventPropagation);
            $body.off('click', $tooltip.hide);
            _autoCloseEventsBinded = false;
          }
        }

        function stopEventPropagation (event) {
          event.stopPropagation();
        }

        // Private methods

        function getPosition ($element) {
          $element = $element || (options.target || element);

          var el = $element[0];
          var isBody = el.tagName === 'BODY';

          var elRect = el.getBoundingClientRect();
          var rect = {};

          // IE8 has issues with angular.extend and using elRect directly.
          // By coping the values of elRect into a new object, we can continue to use extend
          /* eslint-disable guard-for-in */
          for (var p in elRect) { // eslint-disable-line
            // DO NOT use hasOwnProperty when inspecting the return of getBoundingClientRect.
            rect[p] = elRect[p];
          }
          /* eslint-enable guard-for-in */

          if (rect.width === null) {
            // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
            rect = angular.extend({}, rect, {width: elRect.right - elRect.left, height: elRect.bottom - elRect.top});
          }
          var elOffset = isBody ? {top: 0, left: 0} : dimensions.offset(el);
          var scroll = {scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.prop('scrollTop') || 0};
          var outerDims = isBody ? {width: document.documentElement.clientWidth, height: $window.innerHeight} : null;

          return angular.extend({}, rect, scroll, outerDims, elOffset);
        }

        function getCalculatedOffset (placement, position, actualWidth, actualHeight) {
          var offset;
          var split = placement.split('-');

          switch (split[0]) {
            case 'right':
              offset = {
                top: position.top + position.height / 2 - actualHeight / 2,
                left: position.left + position.width
              };
              break;
            case 'bottom':
              offset = {
                top: position.top + position.height,
                left: position.left + position.width / 2 - actualWidth / 2
              };
              break;
            case 'left':
              offset = {
                top: position.top + position.height / 2 - actualHeight / 2,
                left: position.left - actualWidth
              };
              break;
            default:
              offset = {
                top: position.top - actualHeight,
                left: position.left + position.width / 2 - actualWidth / 2
              };
              break;
          }

          if (!split[1]) {
            return offset;
          }

          // Add support for corners @todo css
          if (split[0] === 'top' || split[0] === 'bottom') {
            switch (split[1]) {
              case 'left':
                offset.left = position.left;
                break;
              case 'right':
                offset.left = position.left + position.width - actualWidth;
                break;
              default:
                break;
            }
          } else if (split[0] === 'left' || split[0] === 'right') {
            switch (split[1]) {
              case 'top':
                offset.top = position.top - actualHeight + position.height;
                break;
              case 'bottom':
                offset.top = position.top;
                break;
              default:
                break;
            }
          }

          return offset;
        }

        function applyPlacement (offset, placement) {
          var tip = tipElement[0];
          var width = tip.offsetWidth;
          var height = tip.offsetHeight;

          // manually read margins because getBoundingClientRect includes difference
          var marginTop = parseInt(dimensions.css(tip, 'margin-top'), 10);
          var marginLeft = parseInt(dimensions.css(tip, 'margin-left'), 10);

          // we must check for NaN for ie 8/9
          if (isNaN(marginTop)) marginTop = 0;
          if (isNaN(marginLeft)) marginLeft = 0;

          offset.top = offset.top + marginTop;
          offset.left = offset.left + marginLeft;

          // dimensions setOffset doesn't round pixel values
          // so we use setOffset directly with our own function
          dimensions.setOffset(tip, angular.extend({
            using: function (props) {
              tipElement.css({
                top: Math.round(props.top) + 'px',
                left: Math.round(props.left) + 'px',
                right: ''
              });
            }
          }, offset), 0);

          // check to see if placing tip in new offset caused the tip to resize itself
          var actualWidth = tip.offsetWidth;
          var actualHeight = tip.offsetHeight;

          if (placement === 'top' && actualHeight !== height) {
            offset.top = offset.top + height - actualHeight;
          }

          // If it's an exotic placement, exit now instead of
          // applying a delta and changing the arrow
          if (/top-left|top-right|bottom-left|bottom-right/.test(placement)) return;

          var delta = getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);

          if (delta.left) {
            offset.left += delta.left;
          } else {
            offset.top += delta.top;
          }

          dimensions.setOffset(tip, offset);

          if (/top|right|bottom|left/.test(placement)) {
            var isVertical = /top|bottom/.test(placement);
            var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
            var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';

            replaceArrow(arrowDelta, tip[arrowOffsetPosition], isVertical);
          }
        }

        // @source https://github.com/twbs/bootstrap/blob/v3.3.5/js/tooltip.js#L380
        function getViewportAdjustedDelta (placement, position, actualWidth, actualHeight) {
          var delta = {top: 0, left: 0};
          if (!$tooltip.$viewport) return delta;

          var viewportPadding = options.viewport && options.viewport.padding || 0;
          var viewportDimensions = getPosition($tooltip.$viewport);

          if (/right|left/.test(placement)) {
            var topEdgeOffset = position.top - viewportPadding - viewportDimensions.scroll;
            var bottomEdgeOffset = position.top + viewportPadding - viewportDimensions.scroll + actualHeight;
            if (topEdgeOffset < viewportDimensions.top) { // top overflow
              delta.top = viewportDimensions.top - topEdgeOffset;
            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
              delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
            }
          } else {
            var leftEdgeOffset = position.left - viewportPadding;
            var rightEdgeOffset = position.left + viewportPadding + actualWidth;
            if (leftEdgeOffset < viewportDimensions.left) { // left overflow
              delta.left = viewportDimensions.left - leftEdgeOffset;
            } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
              delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
            }
          }

          return delta;
        }

        function replaceArrow (delta, dimension, isHorizontal) {
          var $arrow = findElement('.tooltip-arrow, .arrow', tipElement[0]);

          $arrow.css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
            .css(isHorizontal ? 'top' : 'left', '');
        }

        function destroyTipElement () {
          // Cancel pending callbacks
          clearTimeout(timeout);

          if ($tooltip.$isShown && tipElement !== null) {
            if (options.autoClose) {
              unbindAutoCloseEvents();
            }

            if (options.keyboard) {
              unbindKeyboardEvents();
            }
          }

          if (tipScope) {
            tipScope.$destroy();
            tipScope = null;
          }

          if (tipElement) {
            tipElement.remove();
            tipElement = $tooltip.$element = null;
          }
        }

        return $tooltip;

      }

      // Helper functions

      function safeDigest (scope) {
        /* eslint-disable no-unused-expressions */
        scope.$$phase || (scope.$root && scope.$root.$$phase) || scope.$digest();
        /* eslint-enable no-unused-expressions */
      }

      function findElement (query, element) {
        return angular.element((element || document).querySelectorAll(query));
      }

      return TooltipFactory;

    };

  })

  .directive('bsTooltip', function ($window, $location, $sce, $parse, $tooltip, $$rAF) {

    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink (scope, element, attr, transclusion) {

        var tooltip;
        // Directive options
        var options = {scope: scope};
        angular.forEach(['template', 'templateUrl', 'controller', 'controllerAs', 'titleTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'backdropAnimation', 'type', 'customClass', 'id'], function (key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });

        // use string regex match boolean attr falsy values, leave truthy values be
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach(['html', 'container'], function (key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
            options[key] = false;
          }
        });

        // bind functions from the attrs to the show and hide events
        angular.forEach(['onBeforeShow', 'onShow', 'onBeforeHide', 'onHide'], function (key) {
          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
          if (angular.isDefined(attr[bsKey])) {
            options[key] = scope.$eval(attr[bsKey]);
          }
        });

        // should not parse target attribute (anchor tag), only data-target #1454
        var dataTarget = element.attr('data-target');
        if (angular.isDefined(dataTarget)) {
          if (falseValueRegExp.test(dataTarget)) {
            options.target = false;
          } else {
            options.target = dataTarget;
          }
        }

        // overwrite inherited title value when no value specified
        // fix for angular 1.3.1 531a8de72c439d8ddd064874bf364c00cedabb11
        if (!scope.hasOwnProperty('title')) {
          scope.title = '';
        }

        // Observe scope attributes for change
        attr.$observe('title', function (newValue) {
          if (angular.isDefined(newValue) || !scope.hasOwnProperty('title')) {
            var oldValue = scope.title;
            scope.title = $sce.trustAsHtml(newValue);
            if (angular.isDefined(oldValue)) {
              $$rAF(function () {
                if (tooltip) tooltip.$applyPlacement();
              });
            }
          }
        });

        attr.$observe('disabled', function (newValue) {
          if (newValue && tooltip.$isShown) {
            tooltip.hide();
          }
        });

        // Support scope as an object
        if (attr.bsTooltip) {
          scope.$watch(attr.bsTooltip, function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
              angular.extend(scope, newValue);
            } else {
              scope.title = newValue;
            }
            if (angular.isDefined(oldValue)) {
              $$rAF(function () {
                if (tooltip) tooltip.$applyPlacement();
              });
            }
          }, true);
        }

        // Visibility binding support
        if (attr.bsShow) {
          scope.$watch(attr.bsShow, function (newValue, oldValue) {
            if (!tooltip || !angular.isDefined(newValue)) return;
            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(tooltip),?/i);
            if (newValue === true) {
              tooltip.show();
            } else {
              tooltip.hide();
            }
          });
        }

        // Enabled binding support
        if (attr.bsEnabled) {
          scope.$watch(attr.bsEnabled, function (newValue, oldValue) {
            // console.warn('scope.$watch(%s)', attr.bsEnabled, newValue, oldValue);
            if (!tooltip || !angular.isDefined(newValue)) return;
            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(tooltip),?/i);
            if (newValue === false) {
              tooltip.setEnabled(false);
            } else {
              tooltip.setEnabled(true);
            }
          });
        }

        // Viewport support
        if (attr.viewport) {
          scope.$watch(attr.viewport, function (newValue) {
            if (!tooltip || !angular.isDefined(newValue)) return;
            tooltip.setViewport(newValue);
          });
        }

        // Initialize popover
        tooltip = $tooltip(element, options);

        // Garbage collection
        scope.$on('$destroy', function () {
          if (tooltip) tooltip.destroy();
          options = null;
          tooltip = null;
        });

      }
    };

  });

'use strict';

angular.module('components.tooltip.dimensions-helper', [])

  .factory('dimensions', function () {

    var fn = {};

    /**
     * Test the element nodeName
     * @param element
     * @param name
     */
    var nodeName = fn.nodeName = function (element, name) {
      return element.nodeName && element.nodeName.toLowerCase() === name.toLowerCase();
    };

    /**
     * Returns the element computed style
     * @param element
     * @param prop
     * @param extra
     */
    fn.css = function (element, prop, extra) {
      var value;
      if (element.currentStyle) { // IE
        value = element.currentStyle[prop];
      } else if (window.getComputedStyle) {
        value = window.getComputedStyle(element)[prop];
      } else {
        value = element.style[prop];
      }
      return extra === true ? parseFloat(value) || 0 : value;
    };

    /**
     * Provides read-only equivalent of jQuery's offset function:
     * @required-by bootstrap-tooltip, bootstrap-affix
     * @url http://api.jquery.com/offset/
     * @param element
     */
    fn.offset = function (element) {
      var boxRect = element.getBoundingClientRect();
      var docElement = element.ownerDocument;
      return {
        width: boxRect.width || element.offsetWidth,
        height: boxRect.height || element.offsetHeight,
        top: boxRect.top + (window.pageYOffset || docElement.documentElement.scrollTop) - (docElement.documentElement.clientTop || 0),
        left: boxRect.left + (window.pageXOffset || docElement.documentElement.scrollLeft) - (docElement.documentElement.clientLeft || 0)
      };
    };

    /**
     * Provides set equivalent of jQuery's offset function:
     * @required-by bootstrap-tooltip
     * @url http://api.jquery.com/offset/
     * @param element
     * @param options
     * @param i
     */
    fn.setOffset = function (element, options, i) {
      var curPosition;
      var curLeft;
      var curCSSTop;
      var curTop;
      var curOffset;
      var curCSSLeft;
      var calculatePosition;
      var position = fn.css(element, 'position');
      var curElem = angular.element(element);
      var props = {};

      // Set position first, in-case top/left are set even on static elem
      if (position === 'static') {
        element.style.position = 'relative';
      }

      curOffset = fn.offset(element);
      curCSSTop = fn.css(element, 'top');
      curCSSLeft = fn.css(element, 'left');
      calculatePosition = (position === 'absolute' || position === 'fixed') &&
        (curCSSTop + curCSSLeft).indexOf('auto') > -1;

      // Need to be able to calculate position if either
      // top or left is auto and position is either absolute or fixed
      if (calculatePosition) {
        curPosition = fn.position(element);
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat(curCSSTop) || 0;
        curLeft = parseFloat(curCSSLeft) || 0;
      }

      if (angular.isFunction(options)) {
        options = options.call(element, i, curOffset);
      }

      if (options.top !== null) {
        props.top = (options.top - curOffset.top) + curTop;
      }
      if (options.left !== null) {
        props.left = (options.left - curOffset.left) + curLeft;
      }

      if ('using' in options) {
        options.using.call(curElem, props);
      } else {
        curElem.css({
          top: props.top + 'px',
          left: props.left + 'px'
        });
      }
    };

    /**
     * Provides read-only equivalent of jQuery's position function
     * @required-by bootstrap-tooltip, bootstrap-affix
     * @url http://api.jquery.com/offset/
     * @param element
     */
    fn.position = function (element) {

      var offsetParentRect = {top: 0, left: 0};
      var offsetParentEl;
      var offset;

      // Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is it's only offset parent
      if (fn.css(element, 'position') === 'fixed') {

        // We assume that getBoundingClientRect is available when computed position is fixed
        offset = element.getBoundingClientRect();

      } else {

        // Get *real* offsetParentEl
        offsetParentEl = offsetParentElement(element);

        // Get correct offsets
        offset = fn.offset(element);
        if (!nodeName(offsetParentEl, 'html')) {
          offsetParentRect = fn.offset(offsetParentEl);
        }

        // Add offsetParent borders
        offsetParentRect.top += fn.css(offsetParentEl, 'borderTopWidth', true);
        offsetParentRect.left += fn.css(offsetParentEl, 'borderLeftWidth', true);
      }

      // Subtract parent offsets and element margins
      return {
        width: element.offsetWidth,
        height: element.offsetHeight,
        top: offset.top - offsetParentRect.top - fn.css(element, 'marginTop', true),
        left: offset.left - offsetParentRect.left - fn.css(element, 'marginLeft', true)
      };

    };

    /**
     * Returns the closest, non-statically positioned offsetParent of a given element
     * @required-by fn.position
     * @param element
     */
    function offsetParentElement (element) {
      var docElement = element.ownerDocument;
      var offsetParent = element.offsetParent || docElement;
      if (nodeName(offsetParent, '#document')) return docElement.documentElement;
      while (offsetParent && !nodeName(offsetParent, 'html') && fn.css(offsetParent, 'position') === 'static') {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docElement.documentElement;
    }

    /**
     * Provides equivalent of jQuery's height function
     * @required-by bootstrap-affix
     * @url http://api.jquery.com/height/
     * @param element
     * @param outer
     */
    fn.height = function (element, outer) {
      var value = element.offsetHeight;
      if (outer) {
        value += fn.css(element, 'marginTop', true) + fn.css(element, 'marginBottom', true);
      } else {
        value -= fn.css(element, 'paddingTop', true) + fn.css(element, 'paddingBottom', true) + fn.css(element, 'borderTopWidth', true) + fn.css(element, 'borderBottomWidth', true);
      }
      return value;
    };

    /**
     * Provides equivalent of jQuery's width function
     * @required-by bootstrap-affix
     * @url http://api.jquery.com/width/
     * @param element
     * @param outer
     */
    fn.width = function (element, outer) {
      var value = element.offsetWidth;
      if (outer) {
        value += fn.css(element, 'marginLeft', true) + fn.css(element, 'marginRight', true);
      } else {
        value -= fn.css(element, 'paddingLeft', true) + fn.css(element, 'paddingRight', true) + fn.css(element, 'borderLeftWidth', true) + fn.css(element, 'borderRightWidth', true);
      }
      return value;
    };

    return fn;

  });

angular.module('components.popover.popover', ['components.tooltip.tooltip'])
  .provider('$popover', function () {

    var defaults = this.defaults = {
      animation: 'am-fade',
      customClass: '',
      // uncommenting the next two lines will break backwards compatability
      // prefixClass: 'popover',
      // prefixEvent: 'popover',
      container: false,
      target: false,
      placement: 'right',
      templateUrl: 'app/components/popover/popover.html',
      contentTemplate: false,
      trigger: 'click',
      keyboard: true,
      html: false,
      title: '',
      content: '',
      delay: 0,
      autoClose: false
    };

    this.$get = function ($tooltip) {

      function PopoverFactory (element, config) {

        // Common vars
        var options = angular.extend({}, defaults, config);

        var $popover = $tooltip(element, options);

        // Support scope as string options [/*title, */content]
        if (options.content) {
          $popover.$scope.content = options.content;
        }

        return $popover;

      }

      return PopoverFactory;

    };

  })

  .directive('bsPopover', function ($window, $sce, $popover) {

    var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;

    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink (scope, element, attr) {

        var popover;
        // Directive options
        var options = {scope: scope};
        angular.forEach(['template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'customClass', 'autoClose', 'id', 'prefixClass', 'prefixEvent', 'bsEnabled'], function (key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });

        // use string regex match boolean attr falsy values, leave truthy values be
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach(['html', 'container', 'autoClose'], function (key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });

        // bind functions from the attrs to the show and hide events
        angular.forEach(['onBeforeShow', 'onShow', 'onBeforeHide', 'onHide'], function (key) {
          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
          if (angular.isDefined(attr[bsKey])) {
            options[key] = scope.$eval(attr[bsKey]);
          }
        });

        // should not parse target attribute (anchor tag), only data-target #1454
        var dataTarget = element.attr('data-target');
        if (angular.isDefined(dataTarget)) {
          if (falseValueRegExp.test(dataTarget)) {
            options.target = false;
          } else {
            options.target = dataTarget;
          }
        }

        // Support scope as data-attrs
        angular.forEach(['title', 'content'], function (key) {
          if (attr[key]) {
            attr.$observe(key, function (newValue, oldValue) {
              scope[key] = $sce.trustAsHtml(newValue);
              if (angular.isDefined(oldValue)) {
                requestAnimationFrame(function () {
                  if (popover) popover.$applyPlacement();
                });
              }
            });
          }
        });

        // Support scope as an object
        if (attr.bsPopover) {
          scope.$watch(attr.bsPopover, function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
              angular.extend(scope, newValue);
            } else {
              scope.content = newValue;
            }
            if (angular.isDefined(oldValue)) {
              requestAnimationFrame(function () {
                if (popover) popover.$applyPlacement();
              });
            }
          }, true);
        }

        // Visibility binding support
        if (attr.bsShow) {
          scope.$watch(attr.bsShow, function (newValue, oldValue) {
            if (!popover || !angular.isDefined(newValue)) return;
            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(popover),?/i);
            if (newValue === true) {
              popover.show();
            } else {
              popover.hide();
            }
          });
        }

        // Enabled binding support
        if (attr.bsEnabled) {
          scope.$watch(attr.bsEnabled, function (newValue) {
            if (!popover || !angular.isDefined(newValue)) return;
            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(popover),?/i);
            if (newValue === false) {
              popover.setEnabled(false);
            } else {
              popover.setEnabled(true);
            }
          });
        }

        // Viewport support
        if (attr.viewport) {
          scope.$watch(attr.viewport, function (newValue) {
            if (!popover || !angular.isDefined(newValue)) return;
            popover.setViewport(newValue);
          });
        }

        // Initialize popover
        popover = $popover(element, options);

        // Garbage collection
        scope.$on('$destroy', function () {
          if (popover) popover.destroy();
          options = null;
          popover = null;
        });

      }
    };

  });

angular.module('components.pagination.pagination', [])
  .directive('pagination', function() {
    function getPagesArray(totalPages) {
      var pagesArray = [];

      for(var i = 1; i <= totalPages + 1; i++) {
        pagesArray.push(i);
      }
      return chunk(pagesArray, 10);
    }

    function chunk(array, chunkSize) {
      return [].concat.apply([],
        array.map(function(elem,i) {
          return i % chunkSize ? [] : [array.slice(i,i+chunkSize)];
        })
      );
    }

    return {
      restrict: 'E',
      scope: {
        totalCount: '=',
        perPage: '=?',
        onSetPage: '='
      },
      replace: true,
      templateUrl: 'app/components/pagination/pagination.html',
      link: {
        pre: function($scope) {
          $scope.perPage = $scope.perPage || 50;
          $scope.currentPage = 0;
          $scope.onSetPage = $scope.onSetPage || angular.noop;
          $scope.currentChunk = 0;

          $scope.setPage = function(page, $event) {
            if($event) {
              $event && $event.preventDefault();
              $event.stopPropagation();
            }

            $scope.currentPage = page;
            $scope.onSetPage($scope.currentPage * $scope.perPage, ($scope.currentPage + 1) * $scope.perPage);
          };

          $scope.setChunk = function(index, $event) {
            $event.preventDefault();
            $scope.currentChunk = $scope.currentChunk + index;
          };

          $scope.$watch('totalCount', function() {
            var totalPages = $scope.totalCount / $scope.perPage;

            $scope.pages = getPagesArray(totalPages);
            if($scope.currentPage + 1 > totalPages) {
              $scope.setPage(0);
            }
          });
        }
      }
    }
  });

angular.module('guestServices', [
  'ngResource',
  'ui.router',
  'permission',
  'permission.ui',
  'ngFileUpload',
  'components.data-access.api.user-api-service',
  'components.data-access.api.user-list-service',
  'components.data-access.user-service',
  'components.user-login.user-login',
  'components.catalogue.catalogue',
  'components.menu.menu',
  'components.modal.modal',
  'components.main-menu.main-menu',
  'components.user-list-table.user-list-table',
  'components.logout.logout',
  'angucomplete',
  'components.data-access.title-service',
]);

angular.module('guestServices')
  .directive('onClickOutside', function($document) {
    return {
      restrict: 'A',
      link: function($scope, $element, $attrs) {
        function listener(e) {
          if(!$element[0].contains(e.target)) {
            $scope.$eval($attrs.onClickOutside);
            $scope.$applyAsync();
          }
        }
        $document.on('click', listener);

        $scope.$on('$destroy', function() {
          $document.off('click', listener);
        });
      }
    };
}).directive('onKeyup', function() {
  return function(scope, elm, attrs) {
    function applyKeyup() {
      scope.$apply(attrs.onKeyup);
    }

    var allowedKeys = attrs.keys.split(',');
    elm.bind('keyup', function(evt) {
      angular.forEach(allowedKeys, function(key) {
        if ((key - 0) === evt.which) {
          applyKeyup();
        }
      });
    });
  };
});

angular.module('components.nutritions-table.nutritions-table', [])
  .directive('nutritionsTable', function($document, $window) {
    return {
      restrict: 'E',
      scope: {
        mapping: '=?',
        data: '='
      },
      replace: true,
      templateUrl: 'app/components/nutritions-table/nutritions-table.html',
      link: function($scope) {
        var body = angular.element($document[0].body);

        $scope.print = function() {
          body.removeClass('nutritions-table-print');
          body.addClass('nutritions-table-print');
          $window.print();
          body.removeClass('nutritions-table-print');
        };
      }
    }
  });


angular.module('components.modal.modal', ['ngAnimate'])

  .provider('$modal', function () {

    var defaults = this.defaults = {
      animation: 'am-fade',
      backdropAnimation: 'am-fade',
      customClass: '',
      prefixClass: 'modal',
      prefixEvent: 'modal',
      placement: 'top',
      templateUrl: 'app/components/modal/modal.html',
      template: '',
      contentTemplate: false,
      container: false,
      element: null,
      backdrop: true,
      keyboard: true,
      html: false,
      show: true,
      size: null,
      zIndex: null
    };

    this.$get = function ($window, $rootScope, $bsCompiler, $animate, $timeout, $sce) {

      var forEach = angular.forEach;
      var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
      var bodyElement = angular.element($window.document.body);

      var backdropCount = 0;
      var dialogBaseZindex = 1080;
      var backdropBaseZindex = 1040;

      var validSizes = {
        lg: 'modal-lg',
        sm: 'modal-sm'
      };

      function ModalFactory (config) {

        var $modal = {};

        // Common vars
        var options = $modal.$options = angular.extend({}, defaults, config);
        var promise = $modal.$promise = $bsCompiler.compile(options);
        var scope = $modal.$scope = options.scope && options.scope.$new() || $rootScope.$new();

        if (!options.element && !options.container) {
          options.container = 'body';
        }

        if (options.zIndex) {
          dialogBaseZindex = parseInt(options.zIndex, 10);
          backdropBaseZindex = dialogBaseZindex - 10;
        }

        // Store $id to identify the triggering element in events
        // give priority to options.id, otherwise, try to use
        // element id if defined
        $modal.$id = options.id || options.element && options.element.attr('id') || '';

        // Support scope as string options
        forEach(['title', 'content'], function (key) {
          if (options[key]) scope[key] = $sce.trustAsHtml(options[key]);
        });

        // Provide scope helpers
        scope.$hide = function () {
          scope.$$postDigest(function () {
            $modal.hide();
          });
        };
        scope.$show = function () {
          scope.$$postDigest(function () {
            $modal.show();
          });
        };
        scope.$toggle = function () {
          scope.$$postDigest(function () {
            $modal.toggle();
          });
        };
        // Publish isShown as a protected var on scope
        $modal.$isShown = scope.$isShown = false;

        // Fetch, compile then initialize modal
        var compileData;
        var modalElement;
        var modalScope;
        var backdropElement = angular.element('<div class="' + options.prefixClass + '-backdrop"/>');
        backdropElement.css({position: 'fixed', top: '0px', left: '0px', bottom: '0px', right: '0px'});
        promise.then(function (data) {
          compileData = data;
          $modal.init();
        });

        $modal.init = function () {

          // Options: show
          if (options.show) {
            scope.$$postDigest(function () {
              $modal.show();
            });
          }

        };

        $modal.destroy = function () {

          // Remove element
          destroyModalElement();

          // remove backdrop element
          if (backdropElement) {
            backdropElement.remove();
            backdropElement = null;
          }

          // Destroy scope
          scope.$destroy();
        };

        $modal.show = function () {
          if ($modal.$isShown) return;

          var parent;
          var after;
          if (angular.isElement(options.container)) {
            parent = options.container;
            after = options.container[0].lastChild ? angular.element(options.container[0].lastChild) : null;
          } else {
            if (options.container) {
              parent = findElement(options.container);
              after = parent[0] && parent[0].lastChild ? angular.element(parent[0].lastChild) : null;
            } else {
              parent = null;
              after = options.element;
            }
          }

          // destroy any existing modal elements
          if (modalElement) destroyModalElement();

          // create a new scope, so we can destroy it and all child scopes
          // when destroying the modal element
          modalScope = $modal.$scope.$new();
          // Fetch a cloned element linked from template (noop callback is required)
          modalElement = $modal.$element = compileData.link(modalScope, function (clonedElement, scope) {});

          if (options.backdrop) {
            // set z-index
            modalElement.css({'z-index': dialogBaseZindex + (backdropCount * 20)});
            backdropElement.css({'z-index': backdropBaseZindex + (backdropCount * 20)});

            // increment number of backdrops
            backdropCount++;
          }

          if (scope.$emit(options.prefixEvent + '.show.before', $modal).defaultPrevented) {
            return;
          }
          if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
            options.onBeforeShow($modal);
          }

          // Set the initial positioning.
          modalElement.css({display: 'block'}).addClass(options.placement);

          // Options: customClass
          if (options.customClass) {
            modalElement.addClass(options.customClass);
          }

          // Options: size
          if (options.size && validSizes[options.size]) {
            angular.element(findElement('.modal-dialog', modalElement[0])).addClass(validSizes[options.size]);
          }

          // Options: animation
          if (options.animation) {
            if (options.backdrop) {
              backdropElement.addClass(options.backdropAnimation);
            }
            modalElement.addClass(options.animation);
          }

          if (options.backdrop) {
            $animate.enter(backdropElement, bodyElement, null);
          }

          // Support v1.2+ $animate
          // https://github.com/angular/angular.js/issues/11713
          if (angular.version.minor <= 2) {
            $animate.enter(modalElement, parent, after, enterAnimateCallback);
          } else {
            $animate.enter(modalElement, parent, after).then(enterAnimateCallback);
          }

          $modal.$isShown = scope.$isShown = true;
          safeDigest(scope);
          // Focus once the enter-animation has started
          // Weird PhantomJS bug hack
          var el = modalElement[0];
          requestAnimationFrame(function () {
            el.focus();
          });

          bodyElement.addClass(options.prefixClass + '-open');
          if (options.animation) {
            bodyElement.addClass(options.prefixClass + '-with-' + options.animation);
          }

          // Bind events
          bindBackdropEvents();
          bindKeyboardEvents();
        };

        function enterAnimateCallback () {
          scope.$emit(options.prefixEvent + '.show', $modal);
          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
            options.onShow($modal);
          }
        }

        $modal.hide = function () {
          if (!$modal.$isShown) return;

          if (scope.$emit(options.prefixEvent + '.hide.before', $modal).defaultPrevented) {
            return;
          }
          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
            options.onBeforeHide($modal);
          }

          // Support v1.2+ $animate
          // https://github.com/angular/angular.js/issues/11713
          if (angular.version.minor <= 2) {
            $animate.leave(modalElement, leaveAnimateCallback);
          } else {
            $animate.leave(modalElement).then(leaveAnimateCallback);
          }

          if (options.backdrop) {
            // decrement number of backdrops
            backdropCount--;
            $animate.leave(backdropElement);
          }
          $modal.$isShown = scope.$isShown = false;
          safeDigest(scope);

          // Unbind events
          unbindBackdropEvents();
          unbindKeyboardEvents();
        };

        function leaveAnimateCallback () {
          scope.$emit(options.prefixEvent + '.hide', $modal);
          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
            options.onHide($modal);
          }
          if (findElement('.modal').length <= 0) {
            bodyElement.removeClass(options.prefixClass + '-open');
          }
          if (options.animation) {
            bodyElement.removeClass(options.prefixClass + '-with-' + options.animation);
          }
        }

        $modal.toggle = function () {
          if ($modal.$isShown) {
            $modal.hide();
          } else {
            $modal.show();
          }
        };

        $modal.focus = function () {
          modalElement[0].focus();
        };

        // Protected methods

        $modal.$onKeyUp = function (evt) {

          if (evt.which === 27 && $modal.$isShown) {
            $modal.hide();
            evt.stopPropagation();
          }

        };

        function bindBackdropEvents () {
          if (options.backdrop) {
            modalElement.on('click', hideOnBackdropClick);
            backdropElement.on('click', hideOnBackdropClick);
            backdropElement.on('wheel', preventEventDefault);
          }
        }

        function unbindBackdropEvents () {
          if (options.backdrop) {
            modalElement.off('click', hideOnBackdropClick);
            backdropElement.off('click', hideOnBackdropClick);
            backdropElement.off('wheel', preventEventDefault);
          }
        }

        function bindKeyboardEvents () {
          if (options.keyboard) {
            modalElement.on('keyup', $modal.$onKeyUp);
          }
        }

        function unbindKeyboardEvents () {
          if (options.keyboard) {
            modalElement.off('keyup', $modal.$onKeyUp);
          }
        }

        // Private helpers

        function hideOnBackdropClick (evt) {
          if (evt.target !== evt.currentTarget) return;
          if (options.backdrop === 'static') {
            $modal.focus();
          } else {
            $modal.hide();
          }
        }

        function preventEventDefault (evt) {
          evt.preventDefault();
        }

        function destroyModalElement () {
          if ($modal.$isShown && modalElement !== null) {
            // un-bind events
            unbindBackdropEvents();
            unbindKeyboardEvents();
          }

          if (modalScope) {
            modalScope.$destroy();
            modalScope = null;
          }

          if (modalElement) {
            modalElement.remove();
            modalElement = $modal.$element = null;
          }
        }

        return $modal;

      }

      // Helper functions

      function safeDigest (scope) {
        /* eslint-disable no-unused-expressions */
        scope.$$phase || (scope.$root && scope.$root.$$phase) || scope.$digest();
        /* eslint-enable no-unused-expressions */
      }

      function findElement (query, element) {
        return angular.element((element || document).querySelectorAll(query));
      }

      return ModalFactory;

    };

  })

  .directive('bsModal', function ($window, $sce, $parse, $modal) {

    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink (scope, element, attr) {

        // Directive options
        var options = {scope: scope, element: element, show: false};
        angular.forEach(['template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation', 'backdropAnimation', 'id', 'prefixEvent', 'prefixClass', 'customClass', 'modalClass', 'size', 'zIndex'], function (key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });

        // Options: alias modalClass to customClass
        if (options.modalClass) {
          options.customClass = options.modalClass;
        }

        // use string regex match boolean attr falsy values, leave truthy values be
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach(['backdrop', 'keyboard', 'html', 'container'], function (key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });

        // bind functions from the attrs to the show and hide events
        angular.forEach(['onBeforeShow', 'onShow', 'onBeforeHide', 'onHide'], function (key) {
          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
          if (angular.isDefined(attr[bsKey])) {
            options[key] = scope.$eval(attr[bsKey]);
          }
        });

        // Support scope as data-attrs
        angular.forEach(['title', 'content'], function (key) {
          if (attr[key]) {
            attr.$observe(key, function (newValue) {
              scope[key] = $sce.trustAsHtml(newValue);
            });
          }
        });

        // Support scope as an object
        if (attr.bsModal) {
          scope.$watch(attr.bsModal, function (newValue) {
            if (angular.isObject(newValue)) {
              angular.extend(scope, newValue);
            } else {
              scope.content = newValue;
            }
          }, true);
        }

        // Initialize modal
        var modal = $modal(options);

        // Trigger
        element.on(attr.trigger || 'click', modal.toggle);

        // Garbage collection
        scope.$on('$destroy', function () {
          if (modal) modal.destroy();
          options = null;
          modal = null;
        });

      }
    };

  });

angular.module('components.modal.modal')
  .service('$bsCompiler', bsCompilerService);

function bsCompilerService ($q, $http, $injector, $compile, $controller, $templateCache, $log) {
  this.compile = function (options) {

    if (options.template && /\.html$/.test(options.template)) {
      $log.warn('Deprecated use of `template` option to pass a file. Please use the `templateUrl` option instead.');
      options.templateUrl = options.template;
      options.template = '';
    }

    var templateUrl = options.templateUrl;
    var template = options.template || '';
    var controller = options.controller;
    var controllerAs = options.controllerAs;
    var resolve = angular.copy(options.resolve || {});
    var locals = angular.copy(options.locals || {});
    var transformTemplate = options.transformTemplate || angular.identity;
    var bindToController = options.bindToController;

    // Take resolve values and invoke them.
    // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
    // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
    angular.forEach(resolve, function (value, key) {
      if (angular.isString(value)) {
        resolve[key] = $injector.get(value);
      } else {
        resolve[key] = $injector.invoke(value);
      }
    });
    // Add the locals, which are just straight values to inject
    // eg locals: { three: 3 }, will inject three into the controller
    angular.extend(resolve, locals);

    if (template) {
      resolve.$template = $q.when(template);
    } else if (templateUrl) {
      resolve.$template = fetchTemplate(templateUrl);
    } else {
      throw new Error('Missing `template` / `templateUrl` option.');
    }

    if (options.titleTemplate) {
      resolve.$template = $q.all([resolve.$template, fetchTemplate(options.titleTemplate)])
        .then(function (templates) {
          var templateEl = angular.element(templates[0]);
          findElement('[ng-bind="title"]', templateEl[0])
            .removeAttr('ng-bind')
            .html(templates[1]);
          return templateEl[0].outerHTML;
        });
    }

    if (options.contentTemplate) {
      // TODO(mgcrea): deprecate?
      resolve.$template = $q.all([resolve.$template, fetchTemplate(options.contentTemplate)])
        .then(function (templates) {
          var templateEl = angular.element(templates[0]);
          var contentEl = findElement('[ng-bind="content"]', templateEl[0])
            .removeAttr('ng-bind')
            .html(templates[1]);
          // Drop the default footer as you probably don't want it if you use a custom contentTemplate
          if (!options.templateUrl) contentEl.next().remove();
          return templateEl[0].outerHTML;
        });
    }

    // Wait for all the resolves to finish if they are promises
    return $q.all(resolve).then(function (locals) {

      var template = transformTemplate(locals.$template);
      if (options.html) {
        template = template.replace(/ng-bind="/ig, 'ng-bind-html="');
      }
      // var element = options.element || angular.element('<div>').html(template.trim()).contents();
      var element = angular.element('<div>').html(template.trim()).contents();
      var linkFn = $compile(element);

      // Return a linking function that can be used later when the element is ready
      return {
        locals: locals,
        element: element,
        link: function link (scope) {
          locals.$scope = scope;

          // Instantiate controller if it exists, because we have scope
          if (controller) {
            var invokeCtrl = $controller(controller, locals, true);
            if (bindToController) {
              angular.extend(invokeCtrl.instance, locals);
            }
            // Support angular@~1.2 invokeCtrl
            var ctrl = angular.isObject(invokeCtrl) ? invokeCtrl : invokeCtrl();
            // See angular-route source for this logic
            element.data('$ngControllerController', ctrl);
            element.children().data('$ngControllerController', ctrl);

            if (controllerAs) {
              scope[controllerAs] = ctrl;
            }
          }

          return linkFn.apply(null, arguments);
        }
      };
    });

  };

  function findElement (query, element) {
    return angular.element((element || document).querySelectorAll(query));
  }

  var fetchPromises = {};
  function fetchTemplate (template) {
    if (fetchPromises[template]) return fetchPromises[template];
    return (fetchPromises[template] = $http.get(template, {cache: $templateCache})
      .then(function (res) {
        return res.data;
      }));
  }

}

angular.module('components.menu.menu',
  ['components.create-menu.create-menu',
    'components.create-menu-helper.create-menu-helper',
    'components.popover.popover',
    'components.data-access.title-service',
    'ngFileSaver',
    'ngStorage'])
  .directive('menu',
    function (
      createMenuHelper, moment, menuApiService, titleService,
      $window, $filter, $modal, FileSaver, Blob, $localStorage,
      userService) {
      return {
        restrict: 'E',
        scope: {
          startDate: '=',
        },
        replace: true,
        templateUrl: 'app/components/menu/menu.html',
        link: function ($scope) {
          var SHORT_DAYS = createMenuHelper.getShortDays();
          titleService.setTitle('Menu');

          if ($scope.startDate) {
            $localStorage.fromDate = moment($scope.startDate).format('YYYY-MM-DD');
          } else if (typeof $localStorage.fromDate === 'undefined' || $localStorage.fromDate === null) {
            // set Monday only
            $localStorage.fromDate = moment().day(1).format('YYYY-MM-DD');
          }

          $scope.tabs = SHORT_DAYS.map(function (day) {
            return { name: day.toLowerCase(), isSelected: false };
          });

          $scope.tabs[0].isSelected = true;
          $scope.selectedTab = $scope.tabs[0];

          $scope.selectTab = function (selectedTab) {
            $scope.tabs.find(function (tab) {
              return tab.isSelected;
            }).isSelected = false;

            selectedTab.isSelected = true;

            $scope.selectedTab = selectedTab;
          };

          $scope.selectMenu = function (menuItem, $event, clearMenu) {
            $event && $event.stopPropagation();
            if (clearMenu) {
              $scope.menuData = {};
            }

            if (menuItem) {
              $scope.menuList.map(function (item) {
                item.isSelected = false;
                return item;
              });

              menuItem.isSelected = true;

              return menuApiService.getMenu(menuItem.id).then(function (data) {
                $scope.menuData = data;
              });
            } else {
              return false;
            }
          };

          $scope.setDate = function (date) {
            if (date) {
              $scope.currentWeek = date;
              $localStorage.fromDate = moment(date).format('YYYY-MM-DD');
            } else if (typeof $localStorage.fromDate !== 'undefined' && $localStorage.fromDate !== null) {
              $scope.currentWeek = moment($localStorage.fromDate, 'YYYY-MM-DD')._d;
            } else {
              var weekMonday = moment().day(1);
              $scope.currentWeek = weekMonday._d;
              $localStorage.fromDate = weekMonday.format('YYYY-MM-DD');
            }

            menuApiService.getMenuList($localStorage.fromDate).then(function (data) {
              $scope.menuList = data;

              if ($scope.menuList[0]) {
                $scope.menuList[0].isSelected = true;
                menuApiService.getMenu($scope.menuList[0].id).then(function (data) {
                  $scope.menuData = data;
                  if ($scope.menuList.$resolved && !$scope.menuList.length) {
                    $scope.menuData = {};
                  }
                  $localStorage.fromDate = moment($scope.menuData.start_date).format('YYYY-MM-DD');
                });
              } else {
                $scope.menuData = {};
              }
            });
          };

          $scope.setDate();

          $scope.print = function () {
            return $window.print();
          };

          $scope.openRemoveModal = function (menuId) {
            return $modal({
              title: 'Are you sure want to delete this menu?',
              templateUrl: 'app/components/modal/templates/confirm.html',
              customClass: 'user-create-modal',
              scope: $scope,
              controller: function ($scope) {
                $scope.action = function () {
                  menuApiService.deleteMenu(menuId).then(function () {
                    var deletedIndex = $scope.menuList.findIndex(function (item) {
                      return item.id === menuId;
                    });

                    $scope.menuList.splice(deletedIndex, 1);
                    $scope.selectMenu($scope.menuList[0], null, true);
                    $scope.$hide();
                  });
                };
              },
            });
          };

          $scope.downloadMenuSheet = function (menuId) {
            $scope.disableDownload = true;
            return menuApiService.downloadMenuSheet(menuId).then(function (res) {
              $scope.disableDownload = false;
              // $window.location = $window.location.origin + '/' + res.data.path;
              // @todo PAS USE config variable, or built in variable for API HOST!
              $window.location = 'https://recipes-api.zurka.com' + '/' + res.data.path;
            }, function () {
              $scope.disableDownload = false;
            });
          };

          $scope.downloadMenuTemplate = function (menuId) {
            $scope.disableDownload = true;
            return menuApiService.downloadMenuTemplate(menuId).then(function (res) {
              $scope.disableDownload = false;
              // $window.location = $window.location.origin + '/' + res.data.path;
              // @todo PAS USE config variable, or built in variable for API HOST!
              $window.location = 'https://recipes-api.zurka.com' + '/' + res.data.path;
            }, function () {
              $scope.disableDownload = false;
            });
          };

          $scope.downloadMenuPDF = function (menuId) {
            $scope.disableDownload = true;
            return menuApiService.downloadMenuPDF(menuId).then(function (res) {
              $scope.disableDownload = false;
              return FileSaver.saveAs(new Blob([res.data], { type: 'application/pdf' }), $scope.menuData.title + '.pdf');
            }, function () {
              $scope.disableDownload = false;
            });
          };

          $scope.isMenuAuthor = function() {
            var currentUser = userService.getUser();

            if (currentUser.role === 'Admin') {
              return true;
            }

            return ($scope.menuData ? ($scope.menuData.author_chef_id === currentUser.id) : false);
          };
        },
      };
    }).filter('currencyCustom', function () {
  return function (value) {
    if (!value) return value;
    return value.indexOf('$') + 1 ? value : '$' + value;
  };
});

angular.module('components.max-length', [])
  .directive('inputMaxLength', function() {
    return {
      scope: {},
      require: '?ngModel',
      link: function($scope, $element, $attrs, ngModel) {
        $scope.maxLength = $attrs.inputMaxLength - 0;
        var val = '';

        $scope.$watch(function () {
          return ngModel.$modelValue;
        }, function(newValue) {
          if ((newValue && ((newValue + '').length > $scope.maxLength))) {
            val = (newValue + '').slice(0, $scope.maxLength);
            ngModel.$setViewValue(val);
            $element.val(val);
          }
        });
      }
    }
  }).directive('only', function () {
      return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attr, ctrl) {
          function inputInteger(val) {
            if (val) {
              val = val + '';
              var digits = val.replace(/[^0-9.]/g, '');

              if (digits.split('.').length > 1 || (val - 0) < attr.min) {
                digits = digits.substring(0, digits.length - 1);
              }

              if (digits !== val) {
                ctrl.$setViewValue(digits);
                ctrl.$render();
              }
              return parseFloat(digits);
            }
            return undefined;
          }

          function inputFloat(val) {
            if (val) {
              var digits = val.replace(/[^0-9.]/g, '');

              if (digits.split('.').length > 2) {
                digits = digits.substring(0, digits.length - 1);
              }

              if (digits !== val) {
                ctrl.$setViewValue(digits);
                ctrl.$render();
              }
              return parseFloat(digits);
            }
            return undefined;
          }

          function inputCurrency(val) {
            if (val) {
              var digits = val.replace(/[^0-9.|\/$]/g, '');

              if (digits.split('.').length > 3 || digits.split('/').length > 2) {
                digits = digits.substring(0, digits.length - 1);
              }

              ctrl.$setViewValue('$' + digits);
              ctrl.$render();
              return '$' + digits;
            }
            return undefined;
          }

          if(attr.only === 'integer') {
            ctrl.$parsers.push(inputInteger);
          } else if(attr.only === 'float') {
            ctrl.$parsers.push(inputFloat);
          } else if(attr.only === 'currency') {
            ctrl.$parsers.push(inputCurrency);
          }
        }
      };
    });

angular.module('components.main-menu.main-menu', [])
  .directive('mainMenu', function($state) {
    return {
      restrict: 'E',
      scope: {
        role: '=',
        mapping: '='
      },
      replace: true,
      templateUrl: 'app/components/main-menu/main-menu.html',
      link: function($scope) {
        $scope.isActive = function(routeName) {
          var activeRoute = false;
          routeName.map(function(item) {
            if (!activeRoute) {
              activeRoute = $state.current.name.indexOf(item) > -1;
            }
          });
          return activeRoute;
        }
      }
    }
  });

angular.module('components.logout.logout', [])
  .directive('logout', function($modal, userService) {
    return {
      restrict: 'E',
      scope: {},
      replace: true,
      templateUrl: 'app/components/logout/logout.html',
      link: function($scope) {
        $scope.userService = userService;

        $scope.openLogoutModal = function() {
          return $modal({
            title: 'Are you sure want to log out?',
            templateUrl: 'app/components/modal/templates/logout.html',
            customClass: 'user-create-modal',
            scope: $scope,
            controller: function($scope) {
              $scope.logout = function() {
                $scope.$hide();
                return $scope.userService.logout();
              }
            }
          });
        }
      }
    }
  });

angular.module('components.dropdown.dropdown', ['components.tooltip.tooltip'])
  .provider('$dropdown', function () {

    var defaults = this.defaults = {
      animation: 'am-fade',
      prefixClass: 'dropdown',
      prefixEvent: 'dropdown',
      placement: 'bottom-left',
      templateUrl: 'app/components/dropdown/dropdown.html',
      trigger: 'click',
      container: false,
      keyboard: true,
      html: false,
      delay: 0
    };

    this.$get = function ($window, $rootScope, $tooltip, $timeout) {

      var bodyEl = angular.element($window.document.body);
      var matchesSelector = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector;

      function DropdownFactory (element, config) {

        var $dropdown = {};

        // Common vars
        var options = angular.extend({}, defaults, config);
        /* var scope = */$dropdown.$scope = options.scope && options.scope.$new() || $rootScope.$new();

        $dropdown = $tooltip(element, options);
        var parentEl = element.parent();

        // Protected methods

        $dropdown.$onKeyDown = function (evt) {
          if (!/(38|40)/.test(evt.keyCode)) return;
          evt.preventDefault();
          evt.stopPropagation();

          // Retrieve focused index
          var items = angular.element($dropdown.$element[0].querySelectorAll('li:not(.divider) a'));
          if (!items.length) return;
          var index;
          angular.forEach(items, function (el, i) {
            if (matchesSelector && matchesSelector.call(el, ':focus')) index = i;
          });

          // Navigate with keyboard
          if (evt.keyCode === 38 && index > 0) index--;
          else if (evt.keyCode === 40 && index < items.length - 1) index++;
          else if (angular.isUndefined(index)) index = 0;
          items.eq(index)[0].focus();

        };

        // Overrides

        var show = $dropdown.show;
        $dropdown.show = function () {
          show();
          // use timeout to hookup the events to prevent
          // event bubbling from being processed imediately.
          $timeout(function () {
            if (options.keyboard && $dropdown.$element) $dropdown.$element.on('keydown', $dropdown.$onKeyDown);
            bodyEl.on('click', onBodyClick);
          }, 0, false);
          if (parentEl.hasClass('dropdown')) parentEl.addClass('open');
        };

        var hide = $dropdown.hide;
        $dropdown.hide = function () {
          if (!$dropdown.$isShown) return;
          if (options.keyboard && $dropdown.$element) $dropdown.$element.off('keydown', $dropdown.$onKeyDown);
          bodyEl.off('click', onBodyClick);
          if (parentEl.hasClass('dropdown')) parentEl.removeClass('open');
          hide();
        };

        var destroy = $dropdown.destroy;
        $dropdown.destroy = function () {
          bodyEl.off('click', onBodyClick);
          destroy();
        };

        // Private functions

        function onBodyClick (evt) {
          if (evt.target === element[0]) return;
          return evt.target !== element[0] && $dropdown.hide();
        }

        return $dropdown;

      }

      return DropdownFactory;

    };

  })

  .directive('bsDropdown', function ($window, $sce, $dropdown) {

    return {
      restrict: 'EAC',
      scope: true,
      compile: function (tElement, tAttrs) {

        // Support for inlined template (next sibling)
        // It must be fetched before compilation
        if (!tAttrs.bsDropdown) {
          var nextSibling = tElement[0].nextSibling;
          while (nextSibling && nextSibling.nodeType !== 1) {
            nextSibling = nextSibling.nextSibling;
          }
          if (nextSibling && nextSibling.className.split(' ').indexOf('dropdown-menu') >= 0) {
            tAttrs.template = nextSibling.outerHTML;
            tAttrs.templateUrl = undefined;
            nextSibling.parentNode.removeChild(nextSibling);
          }
        }

        return function postLink (scope, element, attr) {

          // Directive options
          var options = {scope: scope};
          angular.forEach(['template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'id', 'autoClose'], function (key) {
            if (angular.isDefined(tAttrs[key])) options[key] = tAttrs[key];
          });

          // use string regex match boolean attr falsy values, leave truthy values be
          var falseValueRegExp = /^(false|0|)$/i;
          angular.forEach(['html', 'container'], function (key) {
            if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
          });

          // bind functions from the attrs to the show and hide events
          angular.forEach(['onBeforeShow', 'onShow', 'onBeforeHide', 'onHide'], function (key) {
            var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
            if (angular.isDefined(attr[bsKey])) {
              options[key] = scope.$eval(attr[bsKey]);
            }
          });

          // Support scope as an object
          if (attr.bsDropdown) {
            scope.$watch(attr.bsDropdown, function (newValue, oldValue) {
              scope.content = newValue;
            }, true);
          }

          // Initialize dropdown
          var dropdown = $dropdown(element, options);

          // Visibility binding support
          if (attr.bsShow) {
            scope.$watch(attr.bsShow, function (newValue, oldValue) {
              if (!dropdown || !angular.isDefined(newValue)) return;
              if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(dropdown),?/i);
              if (newValue === true) {
                dropdown.show();
              } else {
                dropdown.hide();
              }
            });
          }

          // Garbage collection
          scope.$on('$destroy', function () {
            if (dropdown) dropdown.destroy();
            options = null;
            dropdown = null;
          });

        };
      }
    };

  });

angular.module('components.datepicker-tooltip.datepicker-tooltip', ['components.tooltip.dimensions-helper'])
  .provider('$datePickerTooltip', function () {

    var defaults = this.defaults = {
      animation: 'am-fade',
      customClass: '',
      prefixClass: 'tooltip',
      prefixEvent: 'tooltip',
      container: false,
      target: false,
      placement: 'top',
      templateUrl: 'app/components/tooltip/tooltip.html',
      template: '',
      titleTemplate: false,
      trigger: 'hover focus',
      keyboard: false,
      html: false,
      show: false,
      title: '',
      type: '',
      delay: 0,
      autoClose: false,
      bsEnabled: true,
      mouseDownPreventDefault: true,
      mouseDownStopPropagation: true,
      viewport: {
        selector: 'body',
        padding: 0
      }
    };

    this.$get = function ($window, $rootScope, $bsCompiler, $q, $templateCache, $http, $animate, $sce, dimensions, $$rAF, $timeout) {

      var isNative = /(ip[ao]d|iphone|android)/ig.test($window.navigator.userAgent);
      var isTouch = ('createTouch' in $window.document) && isNative;
      var $body = angular.element($window.document);

      function TooltipFactory (element, config) {

        var $tooltip = {};

        // Common vars
        var options = $tooltip.$options = angular.extend({}, defaults, config);
        var promise = $tooltip.$promise = $bsCompiler.compile(options);
        var scope = $tooltip.$scope = options.scope && options.scope.$new() || $rootScope.$new();

        var nodeName = element[0].nodeName.toLowerCase();
        if (options.delay && angular.isString(options.delay)) {
          var split = options.delay.split(',').map(parseFloat);
          options.delay = split.length > 1 ? {show: split[0], hide: split[1]} : split[0];
        }

        // Store $id to identify the triggering element in events
        // give priority to options.id, otherwise, try to use
        // element id if defined
        $tooltip.$id = options.id || element.attr('id') || '';

        // Support scope as string options
        if (options.title) {
          scope.title = $sce.trustAsHtml(options.title);
        }

        // Provide scope helpers
        scope.$setEnabled = function (isEnabled) {
          scope.$$postDigest(function () {
            $tooltip.setEnabled(isEnabled);
          });
        };
        scope.$hide = function () {
          scope.$$postDigest(function () {
            $tooltip.hide();
          });
        };
        scope.$show = function () {
          scope.$$postDigest(function () {
            $tooltip.show();
          });
        };
        scope.$toggle = function () {
          scope.$$postDigest(function () {
            $tooltip.toggle();
          });
        };
        // Publish isShown as a protected var on scope
        $tooltip.$isShown = scope.$isShown = false;

        // Private vars
        var timeout;
        var hoverState;

        // Fetch, compile then initialize tooltip
        var compileData;
        var tipElement;
        var tipContainer;
        var tipScope;
        promise.then(function (data) {
          compileData = data;
          $tooltip.init();
        });

        $tooltip.init = function () {

          // Options: delay
          if (options.delay && angular.isNumber(options.delay)) {
            options.delay = {
              show: options.delay,
              hide: options.delay
            };
          }

          // Replace trigger on touch devices ?
          // if(isTouch && options.trigger === defaults.trigger) {
          //   options.trigger.replace(/hover/g, 'click');
          // }

          // Options : container
          if (options.container === 'self') {
            tipContainer = element;
          } else if (angular.isElement(options.container)) {
            tipContainer = options.container;
          } else if (options.container) {
            tipContainer = findElement(options.container);
          }

          // Options: trigger
          bindTriggerEvents();

          // Options: target
          if (options.target) {
            options.target = angular.isElement(options.target) ? options.target : findElement(options.target);
          }

          // Options: show
          if (options.show) {
            scope.$$postDigest(function () {
              if (options.trigger === 'focus') {
                element[0].focus();
              } else {
                $tooltip.show();
              }
            });
          }

        };

        $tooltip.destroy = function () {

          // Unbind events
          unbindTriggerEvents();

          // Remove element
          destroyTipElement();

          // Destroy scope
          scope.$destroy();

        };

        $tooltip.enter = function () {

          clearTimeout(timeout);
          hoverState = 'in';
          if (!options.delay || !options.delay.show) {
            return $tooltip.show();
          }

          timeout = setTimeout(function () {
            if (hoverState === 'in') $tooltip.show();
          }, options.delay.show);

        };

        $tooltip.show = function () {
          if (!options.bsEnabled || $tooltip.$isShown) return;
          promise.then(function (data) {
            compileData = data;
            scope.$emit(options.prefixEvent + '.show.before', $tooltip);
            if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
              options.onBeforeShow($tooltip);
            }
            var parent;
            var after;
            if (options.container) {
              parent = tipContainer;
              if (tipContainer[0].lastChild) {
                after = angular.element(tipContainer[0].lastChild);
              } else {
                after = null;
              }
            } else {
              parent = null;
              after = element;
            }


            // Hide any existing tipElement
            if (tipElement) destroyTipElement();
            // Fetch a cloned element linked from template
            tipScope = $tooltip.$scope.$new();
            tipElement = $tooltip.$element = compileData.link(tipScope, function (clonedElement, scope) {});

            // Set the initial positioning.  Make the tooltip invisible
            // so IE doesn't try to focus on it off screen.
            tipElement.css({top: '-9999px', left: '-9999px', right: 'auto', display: 'block', visibility: 'hidden'});

            // Options: animation
            if (options.animation) tipElement.addClass(options.animation);
            // Options: type
            if (options.type) tipElement.addClass(options.prefixClass + '-' + options.type);
            // Options: custom classes
            if (options.customClass) tipElement.addClass(options.customClass);

            // Append the element, without any animations.  If we append
            // using $animate.enter, some of the animations cause the placement
            // to be off due to the transforms.
            if (after) {
              after.after(tipElement);
            } else {
              parent.prepend(tipElement);
            }

            $tooltip.$isShown = scope.$isShown = true;
            safeDigest(scope);

            // Now, apply placement
            $tooltip.$applyPlacement();

            // Once placed, animate it.
            // Support v1.2+ $animate
            // https://github.com/angular/angular.js/issues/11713
            if (angular.version.minor <= 2) {
              $animate.enter(tipElement, parent, after, enterAnimateCallback);
            } else {
              $animate.enter(tipElement, parent, after).then(enterAnimateCallback);
            }
            safeDigest(scope);

            $$rAF(function () {
              // Once the tooltip is placed and the animation starts, make the tooltip visible
              if (tipElement) tipElement.css({visibility: 'visible'});

              // Bind events
              if (options.keyboard) {
                if (options.trigger !== 'focus') {
                  $tooltip.focus();
                }
                bindKeyboardEvents();
              }
            });

            if (options.autoClose) {
              bindAutoCloseEvents();
            }
          });

        };

        function enterAnimateCallback () {
          scope.$emit(options.prefixEvent + '.show', $tooltip);
          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
            options.onShow($tooltip);
          }
        }

        $tooltip.leave = function () {

          clearTimeout(timeout);
          hoverState = 'out';
          if (!options.delay || !options.delay.hide) {
            return $tooltip.hide();
          }
          timeout = setTimeout(function () {
            if (hoverState === 'out') {
              $tooltip.hide();
            }
          }, options.delay.hide);

        };

        var _blur;
        var _tipToHide;
        $tooltip.hide = function (blur) {

          if (!$tooltip.$isShown) return;
          scope.$emit(options.prefixEvent + '.hide.before', $tooltip);
          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
            options.onBeforeHide($tooltip);
          }

          // store blur value for leaveAnimateCallback to use
          _blur = blur;

          // store current tipElement reference to use
          // in leaveAnimateCallback
          _tipToHide = tipElement;

          // Support v1.2+ $animate
          // https://github.com/angular/angular.js/issues/11713
          if (angular.version.minor <= 2) {
            $animate.leave(tipElement, leaveAnimateCallback);
          } else {
            $animate.leave(tipElement).then(leaveAnimateCallback);
          }

          $tooltip.$isShown = scope.$isShown = false;
          safeDigest(scope);

          // Unbind events
          if (options.keyboard && tipElement !== null) {
            unbindKeyboardEvents();
          }

          if (options.autoClose && tipElement !== null) {
            unbindAutoCloseEvents();
          }
        };

        function leaveAnimateCallback () {
          scope.$emit(options.prefixEvent + '.hide', $tooltip);
          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
            options.onHide($tooltip);
          }

          // check if current tipElement still references
          // the same element when hide was called
          if (tipElement === _tipToHide) {
            // Allow to blur the input when hidden, like when pressing enter key
            if (_blur && options.trigger === 'focus') {
              return element[0].blur();
            }

            // clean up child scopes
            destroyTipElement();
          }
        }

        $tooltip.toggle = function (evt) {
          if (evt) { evt.preventDefault(); }
          if ($tooltip.$isShown) {
            $tooltip.leave();
          } else {
            $tooltip.enter();
          }
        };

        $tooltip.focus = function () {
          tipElement[0].focus();
        };

        $tooltip.setEnabled = function (isEnabled) {
          options.bsEnabled = isEnabled;
        };

        $tooltip.setViewport = function (viewport) {
          options.viewport = viewport;
        };

        // Protected methods

        $tooltip.$applyPlacement = function () {
          if (!tipElement) return;

          // Determine if we're doing an auto or normal placement
          var placement = options.placement;
          var autoToken = /\s?auto?\s?/i;
          var autoPlace = autoToken.test(placement);

          if (autoPlace) {
            placement = placement.replace(autoToken, '') || defaults.placement;
          }

          // Need to add the position class before we get
          // the offsets
          tipElement.addClass(options.placement);

          // Get the position of the target element
          // and the height and width of the tooltip so we can center it.
          var elementPosition = getPosition();
          var tipWidth = tipElement.prop('offsetWidth');
          var tipHeight = tipElement.prop('offsetHeight');

          // Refresh viewport position
          $tooltip.$viewport = options.viewport && findElement(options.viewport.selector || options.viewport);

          // If we're auto placing, we need to check the positioning
          if (autoPlace) {
            var originalPlacement = placement;
            var viewportPosition = getPosition($tooltip.$viewport);

            if (/bottom/.test(originalPlacement) && elementPosition.bottom + tipHeight > viewportPosition.bottom) {
              placement = originalPlacement.replace('bottom', 'top');
            } else if (/top/.test(originalPlacement) && elementPosition.top - tipHeight < viewportPosition.top) {
              placement = originalPlacement.replace('top', 'bottom');
            }

            if (/left/.test(originalPlacement) && elementPosition.left - tipWidth < viewportPosition.left) {
              placement = placement.replace('left', 'right');
            } else if (/right/.test(originalPlacement) && elementPosition.right + tipWidth > viewportPosition.width) {
              placement = placement.replace('right', 'left');
            }

            tipElement.removeClass(originalPlacement).addClass(placement);
          }

          // Get the tooltip's top and left coordinates to center it with this directive.
          var tipPosition = getCalculatedOffset(placement, elementPosition, tipWidth, tipHeight);
          applyPlacement(tipPosition, placement);
        };

        $tooltip.$onKeyUp = function (evt) {
          if (evt.which === 27 && $tooltip.$isShown) {
            $tooltip.hide();
            evt.stopPropagation();
          }
        };

        $tooltip.$onFocusKeyUp = function (evt) {
          if (evt.which === 27) {
            element[0].blur();
            evt.stopPropagation();
          }
        };

        $tooltip.$onFocusElementMouseDown = function (evt) {
          if (options.mouseDownPreventDefault) { evt.preventDefault(); }
          if (options.mouseDownStopPropagation) { evt.stopPropagation(); }
          // Some browsers do not auto-focus buttons (eg. Safari)
          if ($tooltip.$isShown) {
            element[0].blur();
          } else {
            element[0].focus();
          }
        };

        // bind/unbind events
        function bindTriggerEvents () {
          var triggers = options.trigger.split(' ');
          angular.forEach(triggers, function (trigger) {
            if (trigger === 'click' || trigger === 'contextmenu') {
              element.on(trigger, $tooltip.toggle);
            } else if (trigger !== 'manual') {
              element.on(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
              element.on(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
              if (nodeName === 'button' && trigger !== 'hover') {
                element.on(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
              }
            }
          });
        }

        function unbindTriggerEvents () {
          var triggers = options.trigger.split(' ');
          for (var i = triggers.length; i--;) {
            var trigger = triggers[i];
            if (trigger === 'click' || trigger === 'contextmenu') {
              element.off(trigger, $tooltip.toggle);
            } else if (trigger !== 'manual') {
              element.off(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
              element.off(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
              if (nodeName === 'button' && trigger !== 'hover') {
                element.off(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
              }
            }
          }
        }

        function bindKeyboardEvents () {
          if (options.trigger !== 'focus') {
            tipElement.on('keyup', $tooltip.$onKeyUp);
          } else {
            element.on('keyup', $tooltip.$onFocusKeyUp);
          }
        }

        function unbindKeyboardEvents () {
          if (options.trigger !== 'focus') {
            tipElement.off('keyup', $tooltip.$onKeyUp);
          } else {
            element.off('keyup', $tooltip.$onFocusKeyUp);
          }
        }

        var _autoCloseEventsBinded = false;
        function bindAutoCloseEvents () {
          // use timeout to hookup the events to prevent
          // event bubbling from being processed imediately.
          $timeout(function () {
            // Stop propagation when clicking inside tooltip
            tipElement.on('click', stopEventPropagation);

            // Hide when clicking outside tooltip
            $body.on('click', $tooltip.hide);

            _autoCloseEventsBinded = true;
          }, 0, false);
        }

        function unbindAutoCloseEvents () {
          if (_autoCloseEventsBinded) {
            tipElement.off('click', stopEventPropagation);
            $body.off('click', $tooltip.hide);
            _autoCloseEventsBinded = false;
          }
        }

        function stopEventPropagation (event) {
          event.stopPropagation();
        }

        // Private methods

        function getPosition ($element) {
          $element = $element || (options.target || element);

          var el = $element[0];
          var isBody = el.tagName === 'BODY';

          var elRect = el.getBoundingClientRect();
          var rect = {};

          // IE8 has issues with angular.extend and using elRect directly.
          // By coping the values of elRect into a new object, we can continue to use extend
          /* eslint-disable guard-for-in */
          for (var p in elRect) { // eslint-disable-line
            // DO NOT use hasOwnProperty when inspecting the return of getBoundingClientRect.
            rect[p] = elRect[p];
          }
          /* eslint-enable guard-for-in */

          if (rect.width === null) {
            // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
            rect = angular.extend({}, rect, {width: elRect.right - elRect.left, height: elRect.bottom - elRect.top});
          }
          var elOffset = isBody ? {top: 0, left: 0} : dimensions.offset(el);
          var scroll = {scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.prop('scrollTop') || 0};
          var outerDims = isBody ? {width: document.documentElement.clientWidth, height: $window.innerHeight} : null;

          return angular.extend({}, rect, scroll, outerDims, elOffset);
        }

        function getCalculatedOffset (placement, position, actualWidth, actualHeight) {
          var offset;
          var split = placement.split('-');

          switch (split[0]) {
            case 'right':
              offset = {
                top: position.top + position.height / 2 - actualHeight / 2,
                left: position.left + position.width
              };
              break;
            case 'bottom':
              offset = {
                top: position.top + position.height,
                left: position.left + position.width / 2 - actualWidth / 2
              };
              break;
            case 'left':
              offset = {
                top: position.top + position.height / 2 - actualHeight / 2,
                left: position.left - actualWidth
              };
              break;
            default:
              offset = {
                top: position.top - actualHeight,
                left: position.left + position.width / 2 - actualWidth / 2
              };
              break;
          }

          if (!split[1]) {
            return offset;
          }

          // Add support for corners @todo css
          if (split[0] === 'top' || split[0] === 'bottom') {
            switch (split[1]) {
              case 'left':
                offset.left = position.left;
                break;
              case 'right':
                offset.left = position.left + position.width - actualWidth;
                break;
              default:
                break;
            }
          } else if (split[0] === 'left' || split[0] === 'right') {
            switch (split[1]) {
              case 'top':
                offset.top = position.top - actualHeight + position.height;
                break;
              case 'bottom':
                offset.top = position.top;
                break;
              default:
                break;
            }
          }

          return offset;
        }

        function applyPlacement (offset, placement) {
          var tip = tipElement[0];
          var width = tip.offsetWidth;
          var height = tip.offsetHeight;

          // manually read margins because getBoundingClientRect includes difference
          var marginTop = parseInt(dimensions.css(tip, 'margin-top'), 10);
          var marginLeft = parseInt(dimensions.css(tip, 'margin-left'), 10);

          // we must check for NaN for ie 8/9
          if (isNaN(marginTop)) marginTop = 0;
          if (isNaN(marginLeft)) marginLeft = 0;

          offset.top = offset.top + marginTop;
          offset.left = offset.left + marginLeft;

          // dimensions setOffset doesn't round pixel values
          // so we use setOffset directly with our own function
          dimensions.setOffset(tip, angular.extend({
            using: function (props) {
              tipElement.css({
                top: Math.round(props.top) + 'px',
                left: Math.round(props.left) + 'px',
                right: ''
              });
            }
          }, offset), 0);

          // check to see if placing tip in new offset caused the tip to resize itself
          var actualWidth = tip.offsetWidth;
          var actualHeight = tip.offsetHeight;

          if (placement === 'top' && actualHeight !== height) {
            offset.top = offset.top + height - actualHeight;
          }

          // If it's an exotic placement, exit now instead of
          // applying a delta and changing the arrow
          if (/top-left|top-right|bottom-left|bottom-right/.test(placement)) return;

          var delta = getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);

          if (delta.left) {
            offset.left += delta.left;
          } else {
            offset.top += delta.top;
          }

          dimensions.setOffset(tip, offset);

          if (/top|right|bottom|left/.test(placement)) {
            var isVertical = /top|bottom/.test(placement);
            var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
            var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';

            replaceArrow(arrowDelta, tip[arrowOffsetPosition], isVertical);
          }
        }

        // @source https://github.com/twbs/bootstrap/blob/v3.3.5/js/tooltip.js#L380
        function getViewportAdjustedDelta (placement, position, actualWidth, actualHeight) {
          var delta = {top: 0, left: 0};
          if (!$tooltip.$viewport) return delta;

          var viewportPadding = options.viewport && options.viewport.padding || 0;
          var viewportDimensions = getPosition($tooltip.$viewport);

          if (/right|left/.test(placement)) {
            var topEdgeOffset = position.top - viewportPadding - viewportDimensions.scroll;
            var bottomEdgeOffset = position.top + viewportPadding - viewportDimensions.scroll + actualHeight;
            if (topEdgeOffset < viewportDimensions.top) { // top overflow
              delta.top = viewportDimensions.top - topEdgeOffset;
            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
              delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
            }
          } else {
            var leftEdgeOffset = position.left - viewportPadding;
            var rightEdgeOffset = position.left + viewportPadding + actualWidth;
            if (leftEdgeOffset < viewportDimensions.left) { // left overflow
              delta.left = viewportDimensions.left - leftEdgeOffset;
            } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
              delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
            }
          }

          return delta;
        }

        function replaceArrow (delta, dimension, isHorizontal) {
          var $arrow = findElement('.tooltip-arrow, .arrow', tipElement[0]);

          $arrow.css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
            .css(isHorizontal ? 'top' : 'left', '');
        }

        function destroyTipElement () {
          // Cancel pending callbacks
          clearTimeout(timeout);

          if ($tooltip.$isShown && tipElement !== null) {
            if (options.autoClose) {
              unbindAutoCloseEvents();
            }

            if (options.keyboard) {
              unbindKeyboardEvents();
            }
          }

          if (tipScope) {
            tipScope.$destroy();
            tipScope = null;
          }

          if (tipElement) {
            tipElement.remove();
            tipElement = $tooltip.$element = null;
          }
        }

        return $tooltip;

      }

      // Helper functions

      function safeDigest (scope) {
        /* eslint-disable no-unused-expressions */
        scope.$$phase || (scope.$root && scope.$root.$$phase) || scope.$digest();
        /* eslint-enable no-unused-expressions */
      }

      function findElement (query, element) {
        return angular.element((element || document).querySelectorAll(query));
      }

      return TooltipFactory;

    };

  })

  .directive('bsTooltip', function ($window, $location, $sce, $parse, $tooltip, $$rAF) {

    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink (scope, element, attr, transclusion) {

        var tooltip;
        // Directive options
        var options = {scope: scope};
        angular.forEach(['template', 'templateUrl', 'controller', 'controllerAs', 'titleTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'backdropAnimation', 'type', 'customClass', 'id'], function (key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });

        // use string regex match boolean attr falsy values, leave truthy values be
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach(['html', 'container'], function (key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
            options[key] = false;
          }
        });

        // bind functions from the attrs to the show and hide events
        angular.forEach(['onBeforeShow', 'onShow', 'onBeforeHide', 'onHide'], function (key) {
          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
          if (angular.isDefined(attr[bsKey])) {
            options[key] = scope.$eval(attr[bsKey]);
          }
        });

        // should not parse target attribute (anchor tag), only data-target #1454
        var dataTarget = element.attr('data-target');
        if (angular.isDefined(dataTarget)) {
          if (falseValueRegExp.test(dataTarget)) {
            options.target = false;
          } else {
            options.target = dataTarget;
          }
        }

        // overwrite inherited title value when no value specified
        // fix for angular 1.3.1 531a8de72c439d8ddd064874bf364c00cedabb11
        if (!scope.hasOwnProperty('title')) {
          scope.title = '';
        }

        // Observe scope attributes for change
        attr.$observe('title', function (newValue) {
          if (angular.isDefined(newValue) || !scope.hasOwnProperty('title')) {
            var oldValue = scope.title;
            scope.title = $sce.trustAsHtml(newValue);
            if (angular.isDefined(oldValue)) {
              $$rAF(function () {
                if (tooltip) tooltip.$applyPlacement();
              });
            }
          }
        });

        attr.$observe('disabled', function (newValue) {
          if (newValue && tooltip.$isShown) {
            tooltip.hide();
          }
        });

        // Support scope as an object
        if (attr.bsTooltip) {
          scope.$watch(attr.bsTooltip, function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
              angular.extend(scope, newValue);
            } else {
              scope.title = newValue;
            }
            if (angular.isDefined(oldValue)) {
              $$rAF(function () {
                if (tooltip) tooltip.$applyPlacement();
              });
            }
          }, true);
        }

        // Visibility binding support
        if (attr.bsShow) {
          scope.$watch(attr.bsShow, function (newValue, oldValue) {
            if (!tooltip || !angular.isDefined(newValue)) return;
            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(tooltip),?/i);
            if (newValue === true) {
              tooltip.show();
            } else {
              tooltip.hide();
            }
          });
        }

        // Enabled binding support
        if (attr.bsEnabled) {
          scope.$watch(attr.bsEnabled, function (newValue, oldValue) {
            // console.warn('scope.$watch(%s)', attr.bsEnabled, newValue, oldValue);
            if (!tooltip || !angular.isDefined(newValue)) return;
            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(tooltip),?/i);
            if (newValue === false) {
              tooltip.setEnabled(false);
            } else {
              tooltip.setEnabled(true);
            }
          });
        }

        // Viewport support
        if (attr.viewport) {
          scope.$watch(attr.viewport, function (newValue) {
            if (!tooltip || !angular.isDefined(newValue)) return;
            tooltip.setViewport(newValue);
          });
        }

        // Initialize popover
        tooltip = $tooltip(element, options);

        // Garbage collection
        scope.$on('$destroy', function () {
          if (tooltip) tooltip.destroy();
          options = null;
          tooltip = null;
        });

      }
    };

  });

angular.module('components.datepicker.datepicker', [
  'components.datepicker.date-parser',
  'components.datepicker.date-formatter',
  'components.datepicker-tooltip.datepicker-tooltip'])

  .provider('$datepicker', function () {

    var defaults = this.defaults = {
      animation: 'am-fade',
      // Uncommenting the following line will break backwards compatability
      // prefixEvent: 'datepicker',
      prefixClass: 'datepicker',
      placement: 'bottom-left',
      templateUrl: 'app/components/datepicker/datepicker.html',
      trigger: 'focus',
      container: false,
      keyboard: true,
      html: false,
      delay: 0,
      // lang: $locale.id,
      useNative: false,
      dateType: 'date',
      dateFormat: 'shortDate',
      timezone: null,
      modelDateFormat: null,
      dayFormat: 'dd',
      monthFormat: 'MMM',
      yearFormat: 'yyyy',
      monthTitleFormat: 'MMMM yyyy',
      yearTitleFormat: 'yyyy',
      strictFormat: false,
      autoclose: false,
      minDate: -Infinity,
      maxDate: +Infinity,
      startView: 0,
      minView: 0,
      startWeek: 0,
      daysOfWeekDisabled: '',
      hasToday: false,
      hasClear: false,
      iconLeft: 'glyphicon glyphicon-chevron-left',
      iconRight: 'glyphicon glyphicon-chevron-right',
      disableWeek: false,
    };

    this.$get = function ($window, $document, $rootScope, $sce, $dateFormatter, datepickerViews, $datePickerTooltip, $timeout) {

      var isNative = /(ip[ao]d|iphone|android)/ig.test($window.navigator.userAgent);
      var isTouch = ('createTouch' in $window.document) && isNative;
      if (!defaults.lang) defaults.lang = $dateFormatter.getDefaultLocale();

      function DatepickerFactory (element, controller, config) {

        var $datepicker = $datePickerTooltip(element, angular.extend({}, defaults, config));
        var parentScope = config.scope;
        var options = $datepicker.$options;
        var scope = $datepicker.$scope;
        if (options.startView) options.startView -= options.minView;

        // View vars

        var pickerViews = datepickerViews($datepicker);
        $datepicker.$views = pickerViews.views;
        var viewDate = pickerViews.viewDate;
        scope.$mode = options.startView;
        scope.$iconLeft = options.iconLeft;
        scope.$iconRight = options.iconRight;
        scope.$hasToday = options.hasToday;
        scope.$hasClear = options.hasClear;
        var $picker = $datepicker.$views[scope.$mode];

        // Scope methods

        scope.$select = function (date, row, index) {
          var selectedRow = scope.rows.find(function(row) {
            return row.isSelected;
          });

          selectedRow && (selectedRow.isSelected = false);
          row.isSelected = true;
          scope.selectedRow = {index: index, startDate: row[0].date};

          $datepicker.select(date);
        };
        scope.$selectPane = function (value) {
          $datepicker.$selectPane(value);
        };
        scope.$toggleMode = function () {
          $datepicker.setMode((scope.$mode + 1) % $datepicker.$views.length);
        };
        scope.$setToday = function () {
          if (options.autoclose) {
            $datepicker.setMode(0);
            $datepicker.select(new Date());
          } else {
            $datepicker.select(new Date(), true);
          }
        };
        scope.$clear = function () {
          if (options.autoclose) {
            $datepicker.setMode(0);
            $datepicker.select(null);
          } else {
            $datepicker.select(null, true);
          }
        };

        // Public methods

        $datepicker.update = function (date) {
          // console.warn('$datepicker.update() newValue=%o', date);
          if (angular.isDate(date) && !isNaN(date.getTime())) {
            $datepicker.$date = date;
            $picker.update.call($picker, date);
          }
          // Build only if pristine
          $datepicker.$build(true);
        };

        $datepicker.updateDisabledDates = function (dateRanges) {
          options.disabledDateRanges = dateRanges;
          for (var i = 0, l = scope.rows.length; i < l; i++) {
            angular.forEach(scope.rows[i], $datepicker.$setDisabledEl);
          }
        };

        $datepicker.select = function (date, keep) {
          if (angular.isDate(date)) {
            if (!angular.isDate(controller.$dateValue) || isNaN(controller.$dateValue.getTime())) {
              controller.$dateValue = new Date(date);
            }
          } else {
            controller.$dateValue = null;
          }
          if (!scope.$mode || keep) {
            controller.$setViewValue(angular.copy(scope.selectedRow.startDate));
            controller.$render();
            if (options.autoclose && !keep) {
              $timeout(function () { $datepicker.hide(true); });
            }
          } else {
            angular.extend(viewDate, {year: date.getFullYear(), month: date.getMonth(), date: date.getDate()});
            $datepicker.setMode(scope.$mode - 1);
            $datepicker.$build();
          }
        };

        $datepicker.setMode = function (mode) {
          // console.warn('$datepicker.setMode', mode);
          scope.$mode = mode;
          $picker = $datepicker.$views[scope.$mode];
          $datepicker.$build();
        };

        // Protected methods

        $datepicker.$build = function (pristine) {
          // console.warn('$datepicker.$build() viewDate=%o', viewDate);
          if (pristine === true && $picker.built) return;
          if (pristine === false && !$picker.built) return;
          $picker.build.call($picker);
        };

        $datepicker.$updateSelected = function () {
          for (var i = 0, l = scope.rows.length; i < l; i++) {
            angular.forEach(scope.rows[i], updateSelected);
          }
        };

        $datepicker.$isSelected = function (date) {
          return $picker.isSelected(date);
        };

        $datepicker.$setDisabledEl = function (el) {
          el.disabled = $picker.isDisabled(el.date);
        };

        $datepicker.$selectPane = function (value) {
          var steps = $picker.steps;
          // set targetDate to first day of month to avoid problems with
          // date values rollover. This assumes the viewDate does not
          // depend on the day of the month
          var targetDate = new Date(Date.UTC(viewDate.year + ((steps.year || 0) * value), viewDate.month + ((steps.month || 0) * value), 1));
          angular.extend(viewDate, {year: targetDate.getUTCFullYear(), month: targetDate.getUTCMonth(), date: targetDate.getUTCDate()});
          $datepicker.$build();
        };

        $datepicker.$onMouseDown = function (evt) {
          // Prevent blur on mousedown on .dropdown-menu
          evt.preventDefault();
          evt.stopPropagation();
          // Emulate click for mobile devices
          if (isTouch) {
            var targetEl = angular.element(evt.target);
            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
              targetEl = targetEl.parent();
            }
            targetEl.triggerHandler('click');
          }
        };

        $datepicker.$onKeyDown = function (evt) {
          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
          evt.preventDefault();
          evt.stopPropagation();

          if (evt.keyCode === 13) {
            if (!scope.$mode) {
              $datepicker.hide(true);
            } else {
              scope.$apply(function () { $datepicker.setMode(scope.$mode - 1); });
            }
            return;
          }

          // Navigate with keyboard
          $picker.onKeyDown(evt);
          parentScope.$digest();
        };

        // Private

        function updateSelected (el) {
          el.selected = $datepicker.$isSelected(el.date);
        }

        function focusElement () {
          element[0].focus();
        }

        // Overrides

        var _init = $datepicker.init;
        $datepicker.init = function () {
          if (isNative && options.useNative) {
            element.prop('type', 'date');
            element.css('-webkit-appearance', 'textfield');
            return;
          } else if (isTouch) {
            element.prop('type', 'text');
            element.attr('readonly', 'true');
            element.on('click', focusElement);
          }
          _init();
        };

        var _destroy = $datepicker.destroy;
        $datepicker.destroy = function () {
          if (isNative && options.useNative) {
            element.off('click', focusElement);
          }
          _destroy();
        };

        var _show = $datepicker.show;
        $datepicker.show = function () {
          _show();
          // use timeout to hookup the events to prevent
          // event bubbling from being processed imediately.
          $timeout(function () {
            // if $datepicker is no longer showing, don't setup events
            if (!$datepicker.$isShown) return;
            $datepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
            if (options.keyboard) {
              element.on('keydown', $datepicker.$onKeyDown);
            }
          }, 0, false);
        };

        var _hide = $datepicker.hide;
        $datepicker.hide = function (blur) {
          if (!$datepicker.$isShown) return;
          $datepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
          if (options.keyboard) {
            element.off('keydown', $datepicker.$onKeyDown);
          }
          _hide(blur);
        };

        return $datepicker;

      }

      DatepickerFactory.defaults = defaults;
      return DatepickerFactory;

    };

  })

  .directive('bsDatepicker', function ($window, $parse, $q, $dateFormatter, $dateParser, $datepicker) {

    // var defaults = $datepicker.defaults;
    var isNative = /(ip[ao]d|iphone|android)/ig.test($window.navigator.userAgent);

    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function postLink (scope, element, attr, controller) {

        // Directive options
        var options = {scope: scope};
        angular.forEach(['template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay',
          'trigger', 'html', 'animation', 'autoclose', 'dateType', 'dateFormat', 'timezone', 'modelDateFormat',
          'dayFormat', 'strictFormat', 'startWeek', 'startDate', 'useNative', 'lang', 'startView', 'minView',
          'iconLeft', 'iconRight', 'daysOfWeekDisabled', 'id', 'prefixClass', 'prefixEvent', 'hasToday',
          'hasClear', 'disableWeek'], function (key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });

        // use string regex match boolean attr falsy values, leave truthy values be
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach(['html', 'container', 'autoclose', 'useNative', 'hasToday', 'hasClear'], function (key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
            options[key] = false;
          }
        });

        // bind functions from the attrs to the show and hide events
        angular.forEach(['onBeforeShow', 'onShow', 'onBeforeHide', 'onHide'], function (key) {
          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
          if (angular.isDefined(attr[bsKey])) {
            options[key] = scope.$eval(attr[bsKey]);
          }
        });

        // Initialize datepicker
        var datepicker = $datepicker(element, controller, options);
        options = datepicker.$options;
        // Set expected iOS format
        if (isNative && options.useNative) options.dateFormat = 'yyyy-MM-dd';

        var lang = options.lang;

        var formatDate = function (date, format) {
          return $dateFormatter.formatDate(date, format, lang);
        };

        var dateParser = $dateParser({format: options.dateFormat, lang: lang, strict: options.strictFormat});

        // Visibility binding support
        if (attr.bsShow) {
          scope.$watch(attr.bsShow, function (newValue, oldValue) {
            if (!datepicker || !angular.isDefined(newValue)) return;
            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(datepicker),?/i);
            if (newValue === true) {
              datepicker.show();
            } else {
              datepicker.hide();
            }
          });
        }

        // Observe attributes for changes
        angular.forEach(['minDate', 'maxDate'], function (key) {
          // console.warn('attr.$observe(%s)', key, attr[key]);
          if (angular.isDefined(attr[key])) {
            attr.$observe(key, function (newValue) {
              // console.warn('attr.$observe(%s)=%o', key, newValue);
              datepicker.$options[key] = dateParser.getDateForAttribute(key, newValue);
              // Build only if dirty
              if (!isNaN(datepicker.$options[key])) datepicker.$build(false);
              validateAgainstMinMaxDate(controller.$dateValue);
            });
          }
        });

        // Observe date format
        if (angular.isDefined(attr.dateFormat)) {
          attr.$observe('dateFormat', function (newValue) {
            datepicker.$options.dateFormat = newValue;
          });
        }

        // Watch model for changes
        scope.$watch(attr.ngModel, function (newValue, oldValue) {
          datepicker.update(controller.$dateValue);
        }, true);

        // Normalize undefined/null/empty array,
        // so that we don't treat changing from undefined->null as a change.
        function normalizeDateRanges (ranges) {
          if (!ranges || !ranges.length) return null;
          return ranges;
        }

        if (angular.isDefined(attr.disabledDates)) {
          scope.$watch(attr.disabledDates, function (disabledRanges, previousValue) {
            disabledRanges = normalizeDateRanges(disabledRanges);
            previousValue = normalizeDateRanges(previousValue);

            if (disabledRanges) {
              datepicker.updateDisabledDates(disabledRanges);
            }
          });
        }

        function validateAgainstMinMaxDate (parsedDate) {
          if (!angular.isDate(parsedDate)) return;
          var isMinValid = isNaN(datepicker.$options.minDate) || parsedDate.getTime() >= datepicker.$options.minDate;
          var isMaxValid = isNaN(datepicker.$options.maxDate) || parsedDate.getTime() <= datepicker.$options.maxDate;
          var isValid = isMinValid && isMaxValid;
          controller.$setValidity('date', isValid);
          controller.$setValidity('min', isMinValid);
          controller.$setValidity('max', isMaxValid);
          // Only update the model when we have a valid date
          if (isValid) controller.$dateValue = parsedDate;
        }

        // viewValue -> $parsers -> modelValue
        controller.$parsers.unshift(function (viewValue) {
          // console.warn('$parser("%s"): viewValue=%o', element.attr('ng-model'), viewValue);
          var date;
          // Null values should correctly reset the model value & validity
          if (!viewValue) {
            controller.$setValidity('date', true);
            // BREAKING CHANGE:
            // return null (not undefined) when input value is empty, so angularjs 1.3
            // ngModelController can go ahead and run validators, like ngRequired
            return null;
          }
          var parsedDate = dateParser.parse(viewValue, controller.$dateValue);
          if (!parsedDate || isNaN(parsedDate.getTime())) {
            controller.$setValidity('date', false);
            // return undefined, causes ngModelController to
            // invalidate model value
            return;
          }
          validateAgainstMinMaxDate(parsedDate);

          if (options.dateType === 'string') {
            date = dateParser.timezoneOffsetAdjust(parsedDate, options.timezone, true);
            return formatDate(date, options.modelDateFormat || options.dateFormat);
          }
          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
          if (options.dateType === 'number') {
            return date.getTime();
          } else if (options.dateType === 'unix') {
            return date.getTime() / 1000;
          } else if (options.dateType === 'iso') {
            return date.toISOString();
          }
          return new Date(date);
        });

        // modelValue -> $formatters -> viewValue
        controller.$formatters.push(function (modelValue) {
          // console.warn('$formatter("%s"): modelValue=%o (%o)', element.attr('ng-model'), modelValue, typeof modelValue);
          var date;
          if (angular.isUndefined(modelValue) || modelValue === null) {
            date = NaN;
          } else if (angular.isDate(modelValue)) {
            date = modelValue;
          } else if (options.dateType === 'string') {
            date = dateParser.parse(modelValue, null, options.modelDateFormat);
          } else if (options.dateType === 'unix') {
            date = new Date(modelValue * 1000);
          } else {
            date = new Date(modelValue);
          }
          // Setup default value?
          // if (isNaN(date.getTime())) {
          //   var today = new Date();
          //   date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
          // }
          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
          return getDateFormattedString();
        });

        // viewValue -> element
        controller.$render = function () {
          // console.warn('$render("%s"): viewValue=%o', element.attr('ng-model'), controller.$viewValue);
          element.val(getDateFormattedString());
        };

        function getDateFormattedString () {
          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.dateFormat);
        }

        // Garbage collection
        scope.$on('$destroy', function () {
          if (datepicker) datepicker.destroy();
          options = null;
          datepicker = null;
        });

      }
    };

  })

  .provider('datepickerViews', function () {

    // var defaults = this.defaults = {
    //   dayFormat: 'dd',
    //   daySplit: 7
    // };

    // Split array into smaller arrays
    function split (arr, size) {
      var arrays = [];
      while (arr.length > 0) {
        arrays.push(arr.splice(0, size));
      }
      return arrays;
    }

    // Modulus operator
    function mod (n, m) {
      return ((n % m) + m) % m;
    }

    this.$get = function ($dateFormatter, $dateParser, $sce) {
      return function (picker) {

        var scope = picker.$scope;
        var options = picker.$options;

        var lang = options.lang;
        var formatDate = function (date, format) {
          return $dateFormatter.formatDate(date, format, lang);
        };
        var dateParser = $dateParser({format: options.dateFormat, lang: lang, strict: options.strictFormat});

        var weekDaysMin = $dateFormatter.weekdaysShort(lang);
        var weekDaysLabels = weekDaysMin.slice(options.startWeek).concat(weekDaysMin.slice(0, options.startWeek));
        var weekDaysLabelsHtml = $sce.trustAsHtml('<th class="dow text-center" style="padding-bottom: 10px;padding-top: 15px;">' + weekDaysLabels.join('</th><th class="dow text-center">') + '</th>');

        var startDate = picker.$date || (options.startDate ? dateParser.getDateForAttribute('startDate', picker.$date ? options.startDate : 'today') : new Date());
        var viewDate = {year: startDate.getFullYear(), month: startDate.getMonth(), date: startDate.getDate()};

        var views = [{
          format: options.dayFormat,
          split: 7,
          steps: {month: 1},
          update: function (date, force) {
            if (!this.built || force || date.getFullYear() !== viewDate.year || date.getMonth() !== viewDate.month) {
              angular.extend(viewDate, {year: picker.$date.getFullYear(), month: picker.$date.getMonth(), date: picker.$date.getDate()});
              picker.$build();
            } else if (date.getDate() !== viewDate.date || date.getDate() === 1) {
              // chaging picker current month will cause viewDate.date to be set to first day of the month,
              // in $datepicker.$selectPane, so picker would not update selected day display if
              // user picks first day of the new month.
              // As a workaround, we are always forcing update when picked date is first day of month.
              viewDate.date = picker.$date.getDate();
              picker.$updateSelected();
            }
          },
          build: function () {
            var firstDayOfMonth = new Date(viewDate.year, viewDate.month, 1);
            var firstDayOfMonthOffset = firstDayOfMonth.getTimezoneOffset();
            var firstDate = new Date(+firstDayOfMonth - mod(firstDayOfMonth.getDay() - options.startWeek, 7) * 864e5);
            var firstDateOffset = firstDate.getTimezoneOffset();
            var today = dateParser.timezoneOffsetAdjust(new Date(), options.timezone).toDateString();
            // Handle daylight time switch
            if (firstDateOffset !== firstDayOfMonthOffset) firstDate = new Date(+firstDate + (firstDateOffset - firstDayOfMonthOffset) * 60e3);
            var days = [];
            var day;
            for (var i = 0; i < 42; i++) { // < 7 * 6
              day = dateParser.daylightSavingAdjust(new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate() + i));
              days.push({date: day, isToday: day.toDateString() === today, label: formatDate(day, this.format), selected: picker.$date && this.isSelected(day), muted: day.getMonth() !== viewDate.month, disabled: this.isDisabled(day)});
            }
            scope.title = formatDate(firstDayOfMonth, options.monthTitleFormat);
            scope.showLabels = true;
            scope.labels = weekDaysLabelsHtml;
            scope.rows = split(days, this.split);

            if(scope.selectedRow) {
              scope.rows.forEach(function(row) {
                row.forEach(function(week) {
                  if(week.date.getTime() === scope.selectedRow.startDate.getTime()) {
                    row.isSelected = true;
                  }
                  if(week.date.getTime() < scope.startRow.startDate.getTime()) {
                    if (options.disableWeek === 'true') {
                      row.isDisabled = true;
                    }
                  }
                });
              });
            }

            if(!this.built) {
              var nextWeek = 0;

              if (picker.$date) {
                picker.$date.setHours(0, 0, 0, 0);
              }

              scope.rows.some(function(row, index) {
                row.some(function(week) {
                  if (week.date.getTime() < (picker.$date || startDate).getTime()) {
                    nextWeek += 1;
                    return true;
                  }
                });
              });

              if (nextWeek >= scope.rows.length) {
                nextWeek = scope.rows.length - 1;
              }

              scope.rows[nextWeek].isSelected = true;
              scope.selectedRow = {index: nextWeek, title: scope.title, startDate: scope.rows[nextWeek][0].date};
              scope.startRow = angular.copy(scope.selectedRow);

              if (options.disableWeek === 'true') {
                scope.rows.forEach(function(row) {
                  row.forEach(function(week) {
                    if(week.date.getTime() < scope.startRow.startDate.getTime()) {
                      row.isDisabled = true;
                    }
                  });
                });
              }
              if(!picker.$date) {
                picker.select(scope.selectedRow.startDate)
              }
            }
            scope.isTodayDisabled = this.isDisabled(new Date());
            this.built = true;
          },
          isSelected: function (date) {
            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth() && date.getDate() === picker.$date.getDate();
          },
          isDisabled: function (date) {
            var time = date.getTime();

            // Disabled because of min/max date.
            if (time < options.minDate || time > options.maxDate) return true;

            // Disabled due to being a disabled day of the week
            if (options.daysOfWeekDisabled.indexOf(date.getDay()) !== -1) return true;

            // Disabled because of disabled date range.
            if (options.disabledDateRanges) {
              for (var i = 0; i < options.disabledDateRanges.length; i++) {
                if (time >= options.disabledDateRanges[i].start && time <= options.disabledDateRanges[i].end) {
                  return true;
                }
              }
            }

            return false;
          },
          onKeyDown: function (evt) {
            if (!picker.$date) {
              return;
            }
            var actualTime = picker.$date.getTime();
            var newDate;

            if (evt.keyCode === 37) newDate = new Date(actualTime - 1 * 864e5);
            else if (evt.keyCode === 38) newDate = new Date(actualTime - 7 * 864e5);
            else if (evt.keyCode === 39) newDate = new Date(actualTime + 1 * 864e5);
            else if (evt.keyCode === 40) newDate = new Date(actualTime + 7 * 864e5);

            if (!this.isDisabled(newDate)) picker.select(newDate, true);
          }
        }, {
          name: 'month',
          format: options.monthFormat,
          split: 4,
          steps: {year: 1},
          update: function (date, force) {
            if (!this.built || date.getFullYear() !== viewDate.year) {
              angular.extend(viewDate, {year: picker.$date.getFullYear(), month: picker.$date.getMonth(), date: picker.$date.getDate()});
              picker.$build();
            } else if (date.getMonth() !== viewDate.month) {
              angular.extend(viewDate, {month: picker.$date.getMonth(), date: picker.$date.getDate()});
              picker.$updateSelected();
            }
          },
          build: function () {
            // var firstMonth = new Date(viewDate.year, 0, 1);
            var months = [];
            var month;
            for (var i = 0; i < 12; i++) {
              month = new Date(viewDate.year, i, 1);
              months.push({date: month, label: formatDate(month, this.format), selected: picker.$isSelected(month), disabled: this.isDisabled(month)});
            }
            scope.title = formatDate(month, options.yearTitleFormat);
            scope.showLabels = false;
            scope.rows = split(months, this.split);
            this.built = true;
          },
          isSelected: function (date) {
            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth();
          },
          isDisabled: function (date) {
            var lastDate = +new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return lastDate < options.minDate || date.getTime() > options.maxDate;
          },
          onKeyDown: function (evt) {
            if (!picker.$date) {
              return;
            }
            var actualMonth = picker.$date.getMonth();
            var newDate = new Date(picker.$date);

            if (evt.keyCode === 37) newDate.setMonth(actualMonth - 1);
            else if (evt.keyCode === 38) newDate.setMonth(actualMonth - 4);
            else if (evt.keyCode === 39) newDate.setMonth(actualMonth + 1);
            else if (evt.keyCode === 40) newDate.setMonth(actualMonth + 4);

            if (!this.isDisabled(newDate)) picker.select(newDate, true);
          }
        }, {
          name: 'year',
          format: options.yearFormat,
          split: 4,
          steps: {year: 12},
          update: function (date, force) {
            if (!this.built || force || parseInt(date.getFullYear() / 20, 10) !== parseInt(viewDate.year / 20, 10)) {
              angular.extend(viewDate, {year: picker.$date.getFullYear(), month: picker.$date.getMonth(), date: picker.$date.getDate()});
              picker.$build();
            } else if (date.getFullYear() !== viewDate.year) {
              angular.extend(viewDate, {year: picker.$date.getFullYear(), month: picker.$date.getMonth(), date: picker.$date.getDate()});
              picker.$updateSelected();
            }
          },
          build: function () {
            var firstYear = viewDate.year - viewDate.year % (this.split * 3);
            var years = [];
            var year;
            for (var i = 0; i < 12; i++) {
              year = new Date(firstYear + i, 0, 1);
              years.push({date: year, label: formatDate(year, this.format), selected: picker.$isSelected(year), disabled: this.isDisabled(year)});
            }
            scope.title = years[0].label + '-' + years[years.length - 1].label;
            scope.showLabels = false;
            scope.rows = split(years, this.split);
            this.built = true;
          },
          isSelected: function (date) {
            return picker.$date && date.getFullYear() === picker.$date.getFullYear();
          },
          isDisabled: function (date) {
            var lastDate = +new Date(date.getFullYear() + 1, 0, 0);
            return lastDate < options.minDate || date.getTime() > options.maxDate;
          },
          onKeyDown: function (evt) {
            if (!picker.$date) {
              return;
            }
            var actualYear = picker.$date.getFullYear();
            var newDate = new Date(picker.$date);

            if (evt.keyCode === 37) newDate.setYear(actualYear - 1);
            else if (evt.keyCode === 38) newDate.setYear(actualYear - 4);
            else if (evt.keyCode === 39) newDate.setYear(actualYear + 1);
            else if (evt.keyCode === 40) newDate.setYear(actualYear + 4);

            if (!this.isDisabled(newDate)) picker.select(newDate, true);
          }
        }];

        return {
          views: options.minView ? Array.prototype.slice.call(views, options.minView) : views,
          viewDate: viewDate
        };

      };

    };

  });

'use strict';

angular.module('components.datepicker.date-parser', [])

  .provider('$dateParser', function ($localeProvider) {

    // define a custom ParseDate object to use instead of native Date
    // to avoid date values wrapping when setting date component values
    function ParseDate () {
      this.year = 1970;
      this.month = 0;
      this.day = 1;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
      this.milliseconds = 0;
    }

    ParseDate.prototype.setMilliseconds = function (value) { this.milliseconds = value; };
    ParseDate.prototype.setSeconds = function (value) { this.seconds = value; };
    ParseDate.prototype.setMinutes = function (value) { this.minutes = value; };
    ParseDate.prototype.setHours = function (value) { this.hours = value; };
    ParseDate.prototype.getHours = function () { return this.hours; };
    ParseDate.prototype.setDate = function (value) { this.day = value; };
    ParseDate.prototype.setMonth = function (value) { this.month = value; };
    ParseDate.prototype.setFullYear = function (value) { this.year = value; };
    ParseDate.prototype.fromDate = function (value) {
      this.year = value.getFullYear();
      this.month = value.getMonth();
      this.day = value.getDate();
      this.hours = value.getHours();
      this.minutes = value.getMinutes();
      this.seconds = value.getSeconds();
      this.milliseconds = value.getMilliseconds();
      return this;
    };

    ParseDate.prototype.toDate = function () {
      return new Date(this.year, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
    };

    var proto = ParseDate.prototype;

    function noop () {
    }

    function isNumeric (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function indexOfCaseInsensitive (array, value) {
      var len = array.length;
      var str = value.toString().toLowerCase();
      for (var i = 0; i < len; i++) {
        if (array[i].toLowerCase() === str) { return i; }
      }
      return -1; // Return -1 per the "Array.indexOf()" method.
    }

    var defaults = this.defaults = {
      format: 'shortDate',
      strict: false
    };

    this.$get = function ($locale, dateFilter) {

      var DateParserFactory = function (config) {

        var options = angular.extend({}, defaults, config);

        var $dateParser = {};

        /* eslint-disable key-spacing, quote-props */
        var regExpMap = {
          'sss'   : '[0-9]{3}',
          'ss'    : '[0-5][0-9]',
          's'     : options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
          'mm'    : '[0-5][0-9]',
          'm'     : options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
          'HH'    : '[01][0-9]|2[0-3]',
          'H'     : options.strict ? '1?[0-9]|2[0-3]' : '[01]?[0-9]|2[0-3]',
          'hh'    : '[0][1-9]|[1][012]',
          'h'     : options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
          'a'     : 'AM|PM',
          'EEEE'  : $locale.DATETIME_FORMATS.DAY.join('|'),
          'EEE'   : $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
          'dd'    : '0[1-9]|[12][0-9]|3[01]',
          'd'     : options.strict ? '[1-9]|[1-2][0-9]|3[01]' : '0?[1-9]|[1-2][0-9]|3[01]',
          'MMMM'  : $locale.DATETIME_FORMATS.MONTH.join('|'),
          'MMM'   : $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
          'MM'    : '0[1-9]|1[012]',
          'M'     : options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
          'yyyy'  : '[1]{1}[0-9]{3}|[2]{1}[0-9]{3}',
          'yy'    : '[0-9]{2}',
          'y'     : options.strict ? '-?(0|[1-9][0-9]{0,3})' : '-?0*[0-9]{1,4}'
        };

        var setFnMap = {
          'sss'   : proto.setMilliseconds,
          'ss'    : proto.setSeconds,
          's'     : proto.setSeconds,
          'mm'    : proto.setMinutes,
          'm'     : proto.setMinutes,
          'HH'    : proto.setHours,
          'H'     : proto.setHours,
          'hh'    : proto.setHours,
          'h'     : proto.setHours,
          'EEEE'  : noop,
          'EEE'   : noop,
          'dd'    : proto.setDate,
          'd'     : proto.setDate,
          'a'     : function (value) { var hours = this.getHours() % 12; return this.setHours(value.match(/pm/i) ? hours + 12 : hours); },
          'MMMM'  : function (value) { return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.MONTH, value)); },
          'MMM'   : function (value) { return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.SHORTMONTH, value)); },
          'MM'    : function (value) { return this.setMonth(1 * value - 1); },
          'M'     : function (value) { return this.setMonth(1 * value - 1); },
          'yyyy'  : proto.setFullYear,
          'yy'    : function (value) { return this.setFullYear(2000 + 1 * value); },
          'y'     : function (value) { return (1 * value <= 50 && value.length === 2) ? this.setFullYear(2000 + 1 * value) : this.setFullYear(1 * value); }
        };
        /* eslint-enable key-spacing, quote-props */

        var regex;
        var setMap;

        $dateParser.init = function () {
          $dateParser.$format = $locale.DATETIME_FORMATS[options.format] || options.format;
          regex = regExpForFormat($dateParser.$format);
          setMap = setMapForFormat($dateParser.$format);
        };

        $dateParser.isValid = function (date) {
          if (angular.isDate(date)) return !isNaN(date.getTime());
          return regex.test(date);
        };

        $dateParser.parse = function (value, baseDate, format, timezone) {
          // check for date format special names
          if (format) format = $locale.DATETIME_FORMATS[format] || format;
          if (angular.isDate(value)) value = dateFilter(value, format || $dateParser.$format, timezone);
          var formatRegex = format ? regExpForFormat(format) : regex;
          var formatSetMap = format ? setMapForFormat(format) : setMap;
          var matches = formatRegex.exec(value);
          if (!matches) return false;
          // use custom ParseDate object to set parsed values
          var date = baseDate && !isNaN(baseDate.getTime()) ? new ParseDate().fromDate(baseDate) : new ParseDate().fromDate(new Date(1970, 0, 1, 0));
          for (var i = 0; i < matches.length - 1; i++) {
            if (formatSetMap[i]) formatSetMap[i].call(date, matches[i + 1]);
          }
          // convert back to native Date object
          var newDate = date.toDate();

          // check new native Date object for day values overflow
          if (parseInt(date.day, 10) !== newDate.getDate()) {
            return false;
          }

          return newDate;
        };

        $dateParser.getDateForAttribute = function (key, value) {
          var date;

          if (value === 'today') {
            var today = new Date();
            date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (key === 'maxDate' ? 1 : 0), 0, 0, 0, (key === 'minDate' ? 0 : -1));
          } else if (angular.isString(value) && value.match(/^".+"$/)) { // Support {{ dateObj }}
            date = new Date(value.substr(1, value.length - 2));
          } else if (isNumeric(value)) {
            date = new Date(parseInt(value, 10));
          } else if (angular.isString(value) && value.length === 0) { // Reset date
            date = key === 'minDate' ? -Infinity : +Infinity;
          } else {
            date = new Date(value);
          }

          return date;
        };

        $dateParser.getTimeForAttribute = function (key, value) {
          var time;

          if (value === 'now') {
            time = new Date().setFullYear(1970, 0, 1);
          } else if (angular.isString(value) && value.match(/^".+"$/)) {
            time = new Date(value.substr(1, value.length - 2)).setFullYear(1970, 0, 1);
          } else if (isNumeric(value)) {
            time = new Date(parseInt(value, 10)).setFullYear(1970, 0, 1);
          } else if (angular.isString(value) && value.length === 0) { // Reset time
            time = key === 'minTime' ? -Infinity : +Infinity;
          } else {
            time = $dateParser.parse(value, new Date(1970, 0, 1, 0));
          }

          return time;
        };

        /* Handle switch to/from daylight saving.
         * Hours may be non-zero on daylight saving cut-over:
         * > 12 when midnight changeover, but then cannot generate
         * midnight datetime, so jump to 1AM, otherwise reset.
         * @param  date  (Date) the date to check
         * @return  (Date) the corrected date
         *
         * __ copied from jquery ui datepicker __
         */
        $dateParser.daylightSavingAdjust = function (date) {
          if (!date) {
            return null;
          }
          date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
          return date;
        };

        /* Correct the date for timezone offset.
         * @param  date  (Date) the date to adjust
         * @param  timezone  (string) the timezone to adjust for
         * @param  undo  (boolean) to add or subtract timezone offset
         * @return  (Date) the corrected date
         */
        $dateParser.timezoneOffsetAdjust = function (date, timezone, undo) {
          if (!date) {
            return null;
          }
          // Right now, only 'UTC' is supported.
          if (timezone && timezone === 'UTC') {
            date = new Date(date.getTime());
            date.setMinutes(date.getMinutes() + (undo ? -1 : 1) * date.getTimezoneOffset());
          }
          return date;
        };

        // Private functions

        function regExpForFormat (format) {
          // `format` string can contain literal values.
          // These need to be escaped by surrounding with
          // single quotes (e.g. `"h 'in the morning'"`).
          // In order to output a single quote, escape it - i.e.,
          // two single quotes in a sequence (e.g. `"h 'o''clock'"`).

          var re = buildDateAbstractRegex(format);
          return buildDateParseRegex(re);
        }

        function buildDateAbstractRegex (format) {
          var escapedFormat = escapeReservedSymbols(format);
          var escapedLiteralFormat = escapedFormat.replace(/''/g, '\\\'');
          var literalRegex = /('(?:\\'|.)*?')/;
          var formatParts = escapedLiteralFormat.split(literalRegex);
          var dateElements = Object.keys(regExpMap);
          var dateRegexParts = [];

          angular.forEach(formatParts, function (part) {
            if (isFormatStringLiteral(part)) {
              part = trimLiteralEscapeChars(part);
            } else {
              // Abstract replaces to avoid collisions
              for (var i = 0; i < dateElements.length; i++) {
                part = part.split(dateElements[i]).join('${' + i + '}');
              }
            }
            dateRegexParts.push(part);
          });

          return dateRegexParts.join('');
        }

        function escapeReservedSymbols (text) {
          return text.replace(/\\/g, '[\\\\]')
            .replace(/-/g, '[-]')
            .replace(/\./g, '[.]')
            .replace(/\*/g, '[*]')
            .replace(/\+/g, '[+]')
            .replace(/\?/g, '[?]')
            .replace(/\$/g, '[$]')
            .replace(/\^/g, '[^]')
            .replace(/\//g, '[/]')
            .replace(/\\s/g, '[\\s]');
        }

        function isFormatStringLiteral (text) {
          return /^'.*'$/.test(text);
        }

        function trimLiteralEscapeChars (text) {
          return text.replace(/^'(.*)'$/, '$1');
        }

        function buildDateParseRegex (abstractRegex) {
          var dateElements = Object.keys(regExpMap);
          var re = abstractRegex;

          // Replace abstracted values
          for (var i = 0; i < dateElements.length; i++) {
            re = re.split('${' + i + '}').join('(' + regExpMap[dateElements[i]] + ')');
          }

          return new RegExp('^' + re + '$', ['i']);
        }

        function setMapForFormat (format) {
          var re = buildDateAbstractRegex(format);
          return buildDateParseValuesMap(re);
        }

        function buildDateParseValuesMap (abstractRegex) {
          var dateElements = Object.keys(regExpMap);
          var valuesRegex = new RegExp('\\${(\\d+)}', 'g');
          var valuesMatch;
          var keyIndex;
          var valueKey;
          var valueFunction;
          var valuesFunctionMap = [];

          /* eslint-disable no-cond-assign */
          while ((valuesMatch = valuesRegex.exec(abstractRegex)) !== null) {
            keyIndex = valuesMatch[1];
            valueKey = dateElements[keyIndex];
            valueFunction = setFnMap[valueKey];

            valuesFunctionMap.push(valueFunction);
          }

          return valuesFunctionMap;
        }

        $dateParser.init();
        return $dateParser;

      };

      return DateParserFactory;

    };

  });

angular.module('components.datepicker.date-formatter', []).service('$dateFormatter', [ '$locale', 'dateFilter', function($locale, dateFilter) {
  this.getDefaultLocale = function() {
    return $locale.id;
  };
  this.getDatetimeFormat = function(format, lang) {
    return $locale.DATETIME_FORMATS[format] || format;
  };
  this.weekdaysShort = function(lang) {
    return $locale.DATETIME_FORMATS.SHORTDAY;
  };
  function splitTimeFormat(format) {
    return /(h+)([:\.])?(m+)([:\.])?(s*)[ ]?(a?)/i.exec(format).slice(1);
  }
  this.hoursFormat = function(timeFormat) {
    return splitTimeFormat(timeFormat)[0];
  };
  this.minutesFormat = function(timeFormat) {
    return splitTimeFormat(timeFormat)[2];
  };
  this.secondsFormat = function(timeFormat) {
    return splitTimeFormat(timeFormat)[4];
  };
  this.timeSeparator = function(timeFormat) {
    return splitTimeFormat(timeFormat)[1];
  };
  this.showSeconds = function(timeFormat) {
    return !!splitTimeFormat(timeFormat)[4];
  };
  this.showAM = function(timeFormat) {
    return !!splitTimeFormat(timeFormat)[5];
  };
  this.formatDate = function(date, format, lang, timezone) {
    return dateFilter(date, format, timezone);
  };
} ]);

angular.module('components.data-access.user-service', ['ngStorage'])
  .factory('userService', function($q, $location, $state, $localStorage, userApiService) {
    var userData = {}, LOGIN_STATE = 'login';

    return {
      isUserLoggedIn: function() {
        return !!$localStorage.apiToken;
      },

      getResetToken: function() {
        return $location.search().resetToken;
      },

      getUser: function(field) {
        return field ? userData[field] : userData;
      },

      setUser: function(user) {
        if(this.isUserLoggedIn()) {
          if(user) {
            angular.extend(userData, user);
          } else {
            userData = $localStorage.user;
          }
        }
      },

      deleteUser: function() {
        userData = {};
        $localStorage.user = '';
      },

      getToken: function() {
        return $localStorage.apiToken || '';
      },

      clearToken: function() {
       $localStorage.apiToken = '';
      },

      checkResetToken: function() {

        return userApiService.checkResetToken(this.getResetToken());
      },

      login: function(user) {

        return userApiService.login(user).then(function(data) {
          userData = data.user;
          userData.firstName = userData.first_name;
          userData.lastName = userData.last_name;
          userData.fullName = userData.firstName + ' ' + userData.lastName;
          if(data.token) {
            $localStorage.apiToken = data.token;
            $localStorage.user = userData;
            $state.go('main.menu');
          }
        });
      },

      logout: function() {
        this.deleteUser();
        this.clearToken();
        $state.go(LOGIN_STATE);
      },

      resetPassword: function(email) {

        return userApiService.resetPassword(email).then(function() {
          $state.go(LOGIN_STATE);
        });
      },

      changePassword: function(password) {

        return userApiService.changePassword(password, this.getResetToken()).then(function() {
          $state.go(LOGIN_STATE);
        });
      }
    }
  });

angular.module('components.data-access.title-service', [])
  .factory('titleService', function() {
    return {
      setTitle: function(title) {
        var currentTitle = title ? title + ' | ' : '';
        document.querySelector('title').textContent = currentTitle + 'Guest Service';
      },
    }
  });

angular.module('components.catalogue.catalogue', [
  'components.data-access.api.recipe-api-service',
  'components.data-access.title-service',
  'components.catalogue.recipe-list.recipe-list',
  'components.catalogue.recipe-filters.recipe-filters',
  'components.catalogue.catalogue-pagination.catalogue-pagination',
  'components.dropdown.dropdown',
  'components.catalogue.create-recipe.create-recipe',
  'components.catalogue.view-recipe.view-recipe',
])
  .directive('catalogue', function (recipeApiService, titleService, $modal, $state, $location, PermPermissionStore, $sessionStorage) {
    return {
      restrict: 'E',
      scope: {
        filters: '=',
        recipes: '=',
        pagination: '=?',
        collapsed: '=?',
        onSelectRecipe: '=?',
      },
      replace: true,
      templateUrl: 'app/components/catalogue/catalogue.html',
      link: function ($scope) {
        var searchParams = $location.search();
        recipeApiService.saveFilters($scope.filters);

        $scope.isLoading = false;
        $scope.isChanged = $scope.noResults = false;
        $scope.categories = searchParams.categories ? JSON.parse(searchParams.categories) : {};
        $scope.filteredRecipes = $scope.recipes;
        $scope.originalPagination = angular.copy($scope.pagination);

        if (!$scope.collapsed) {
          titleService.setTitle('Catalogue');

          if ($sessionStorage.search) {
            $scope.search = $sessionStorage.search;
          }
        }

        $scope.DROPDOWN_MAPPING = [
          { name: 'A-Z', selectedName: 'A-Z', predicate: 'title', dir: 'asc', selected: true },
          { name: 'Z-A', selectedName: 'Z-A', predicate: 'title', dir: 'desc' },
          { name: 'Calories', selectedName: 'calories', predicate: 'calories', dir: 'asc', className: 'asc' },
          { name: 'Calories', selectedName: 'calories', predicate: 'calories', dir: 'desc', className: 'desc' },
          { name: 'Date of creation', selectedName: 'date of creation', predicate: 'created', dir: 'asc', className: 'asc' },
          { name: 'Date of creation', selectedName: 'date of creation', predicate: 'created', dir: 'desc', className: 'desc' }
        ];

        if (searchParams.sort) {
          $scope.sort = searchParams.sort ? JSON.parse(searchParams.sort) : {};
          $scope.DROPDOWN_MAPPING.map(function (item) {
            if (item.predicate === $scope.sort.predicate && item.dir === $scope.sort.dir) {
              item.selected = true;
              $scope.selected = item;
            } else {
              item.selected = false;
            }
          });
        } else {
          $scope.selected = $scope.DROPDOWN_MAPPING[0];
        }

        $scope.onChange = function (categories) {
          $scope.categories = categories;
          $location.search('page', null);

          if (Object.keys(categories).some(function (key) {
              return angular.isArray(categories[key]) && categories[key].length;
            })) {
            $scope.filteredRecipes = [];
            $scope.isLoading = true;
            $scope.noResults = false;

            if ($scope.collapsed) {
              return recipeApiService.filterRecipes(categories, 0, $scope.sort).then(function (recipes) {
                $scope.noResults = !recipes.data.length;
                $scope.filteredRecipes = recipes.data;
                $scope.pagination = recipes.meta.pagination;
              });
            } else {
              $location.search('categories', JSON.stringify(categories));
            }
          } else {
            $scope.noResults = false;
            $scope.filteredRecipes = $scope.recipes;
            $scope.pagination = $scope.originalPagination;
            $location.search('categories', null);
          }
        };

        $scope.setOrder = function (link) {
          $scope.DROPDOWN_MAPPING.find(function (item) {
            return item.selected;
          }).selected = false;
          link.selected = true;
          $scope.sort = link;

          if (($scope.selected.predicate !== link.predicate) || ($scope.selected.dir !== link.dir)) {
            $scope.selected = link;
            $location.search('sort', JSON.stringify(link));
          }
        };

        $scope.onSetPage = function (offset) {
          $scope.offset = offset;
          if ($scope.collapsed) {
            return recipeApiService.filterRecipes($scope.categories, offset, $scope.sort).then(function(recipes) {
              $scope.filteredRecipes = recipes.data;
              $scope.pagination = recipes.meta.pagination;
              $scope.isChanged = false;
              var el = document.querySelector('.recipe-list');
              el.scrollTo(0, 0);
            })
          } else {
            $location.search('page', offset);
          }
        };

        $scope.$watch('search', function (search) {
          if (search && search.length >= 3) {
            $scope.filteredRecipes = [];
            $scope.isLoading = true;
            $scope.noResults = false;
            recipeApiService.searchRecipe(search).then(function (recipes) {
              $scope.noResults = !recipes.length;
              $scope.filteredRecipes = recipes;
              $scope.isChanged = true;
              $sessionStorage.search = search;
            });
          } else if ($scope.isChanged) {
            $scope.filteredRecipes = [];
            $scope.isLoading = true;
            $scope.noResults = false;

            if (Object.keys($scope.categories).length) {
              recipeApiService.filterRecipes($scope.categories, 0, $scope.sort).then(onSuccess);
            } else {
              recipeApiService.getRecipe().then(onSuccess);
            }
          }
        });

        function onSuccess(recipes) {
          $scope.noResults = !recipes.data.length;
          $scope.filteredRecipes = recipes.data;
          $scope.pagination = recipes.meta.pagination;
          $scope.isChanged = false;
          delete $sessionStorage.search;
        }

        $scope.openImportModal = function () {
          return $modal({
            title: 'Import URL',
            templateUrl: 'app/components/modal/templates/import.html',
            customClass: 'user-create-modal',
            scope: $scope,
            controller: function ($scope) {
              $scope.action = function (url) {
                $scope.disableSubmit = true;
                return recipeApiService.importRecipe(url).then(function (recipe) {
                  PermPermissionStore
                    .definePermission('canEditRecipe', function () {
                      return true;
                    });

                  $state.go('main.edit-recipe', { recipe: recipe, recipeId: recipe.id });
                  $scope.$hide();
                }, function () {
                  $scope.disableSubmit = false;
                });
              };
            },
          });
        };
      },
    };
  });

/**
 * Angucomplete
 * Autocomplete directive for AngularJS
 * By Daryl Rowland
 */

angular.module('angucomplete', [])
  .directive('angucomplete', function ($parse, $http, $sce, $timeout) {
    return {
      restrict: 'EA',
      scope: {
        "id": "@id",
        "placeholder": "@placeholder",
        "selectedObject": "=selectedobject",
        "url": "@url",
        "inputChange": "=inputChange",
        'inputChangeParams': '=?',
        'onBlur': '=?',
        'onBlurParams': '=?',
        "ngReadonly": "=ngReadonly",
        "dataField": "@datafield",
        "titleField": "@titlefield",
        "descriptionField": "@descriptionfield",
        "imageField": "@imagefield",
        "imageUri": "@imageuri",
        "inputClass": "@inputclass",
        "inputName": "@",
        "userPause": "@pause",
        "localData": "=localdata",
        "searchFields": "@searchfields",
        "minLengthUser": "@minlength",
        "matchClass": "@matchclass",
      },
      template:
      '<div class="angucomplete-holder">' +
        '<input id="{{id}}_value" autocomplete="new-password" maxlength="150" name="{{inputName}}" ' +
        'required ng-model="searchStr" ng-readonly="ngReadonly" type="text" placeholder="{{placeholder}}" ' +
        'class="{{inputClass}}" onmouseup="this.select();" ng-focus="resetHideResults()" ng-blur="hideResults()" autocomplete="off"/>' +
          '<div id="{{id}}_dropdown" class="angucomplete-dropdown" ng-if="showDropdown">' +
            '<div class="angucomplete-searching" ng-show="searching">Searching...</div>' +
            '<div class="angucomplete-searching" ng-show="!searching && (!results || results.length == 0)">No results found</div>' +
            '<div class="angucomplete-row" ng-repeat="result in results" ng-mousedown="selectResult(result)" ' +
              'ng-mouseover="hoverRow()" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}">' +
                '<div ng-if="imageField" class="angucomplete-image-holder">' +
                '<img ng-if="result.image && result.image != \'\'" ng-src="{{result.image}}" class="angucomplete-image"/>' +
                '<div ng-if="!result.image && result.image != \'\'" class="angucomplete-image-default"></div>' +
            '</div>' +
            '<div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div>' +
            '<div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div>' +
      '<div ng-if="result.description && result.description != \'\'" class="angucomplete-description">{{result.description}}</div>' +
      '</div></div></div>',

      link: function ($scope, elem, attrs) {
        $scope.lastSearchTerm = null;
        $scope.currentIndex = null;
        $scope.justChanged = false;
        $scope.searchTimer = null;
        $scope.hideTimer = null;
        $scope.searching = false;
        $scope.pause = 500;
        $scope.inputName = $scope.inputName || 'IngName';
        $scope.minLength = 3;
        $scope.searchStr = $scope.selectedObject.name || $scope.selectedObject.title || null;

        if ($scope.minLengthUser && $scope.minLengthUser != "") {
          $scope.minLength = $scope.minLengthUser;
        }

        if ($scope.userPause) {
          $scope.pause = $scope.userPause;
        }

        var isNewSearchNeeded = function (newTerm, oldTerm) {
          return newTerm.length >= $scope.minLength && newTerm != oldTerm;
        };

        $scope.processResults = function (responseData, str) {
          if (responseData && responseData.length > 0) {
            $scope.results = [];

            var titleFields = [];
            if ($scope.titleField && $scope.titleField != "") {
              titleFields = $scope.titleField.split(",");
            }

            for (var i = 0; i < responseData.length; i++) {
              // Get title variables
              var titleCode = [];

              for (var t = 0; t < titleFields.length; t++) {
                titleCode.push(responseData[i][titleFields[t]]);
              }

              var description = "";
              if ($scope.descriptionField) {
                description = responseData[i][$scope.descriptionField];
              }

              var imageUri = "";
              if ($scope.imageUri) {
                imageUri = $scope.imageUri;
              }

              var image = "";
              if ($scope.imageField) {
                image = imageUri + responseData[i][$scope.imageField];
              }

              var text = titleCode.join(' ');
              if ($scope.matchClass) {
                var re = new RegExp(str, 'i');
                var strPart = text.match(re)[0];
                text = $sce.trustAsHtml(text.replace(re, '<span class="' + $scope.matchClass + '">' + strPart + '</span>'));
              }

              var resultRow = {
                title: text,
                description: description,
                image: image,
                originalObject: responseData[i],
              };

              $scope.results[$scope.results.length] = resultRow;
            }


          } else {
            $scope.results = [];
          }
        };

        $scope.searchTimerComplete = function (str) {
          // Begin the search

          if (str && str.length >= $scope.minLength) {
            if ($scope.localData) {
              var searchFields = $scope.searchFields.split(",");

              var matches = [];

              for (var i = 0; i < $scope.localData.length; i++) {
                var match = false;

                for (var s = 0; s < searchFields.length; s++) {
                  var isString = typeof $scope.localData[i][searchFields[s]] === 'string';
                  var isFound = $scope.localData[i][searchFields[s]].toLowerCase().indexOf(str.toLowerCase()) >= 0;
                  match = match || (isString && typeof str === 'string' && isFound);
                }

                if (match) {
                  matches[matches.length] = $scope.localData[i];
                }
              }

              $scope.searching = false;
              $scope.processResults(matches, str);

            } else {
              $http.get($scope.url + str, {}).then(function (responseData, status, headers, config) {
                $scope.searching = false;
                $scope.processResults((($scope.dataField) ? responseData.data[$scope.dataField] : responseData.data ), str);
              }).catch(function (data, status, headers, config) {
              });
            }
          }
        };

        $scope.hideResults = function () {
          $scope.onBlur && $scope.onBlur.apply(null, [$scope.selectedObject, $scope.searchStr].concat($scope.onBlurParams));

          $scope.hideTimer = $timeout(function () {
            $scope.showDropdown = false;
          }, $scope.pause);
        };

        $scope.resetHideResults = function () {
          if ($scope.hideTimer) {
            $timeout.cancel($scope.hideTimer);
          }
        };

        $scope.hoverRow = function (index) {
          $scope.currentIndex = index;
        };

        $scope.keyPressed = function (event) {
          if (!(event.which == 38 || event.which == 40 || event.which == 13)) {
            if (!$scope.searchStr || $scope.searchStr == "") {
              $scope.showDropdown = false;
              $scope.lastSearchTerm = null;
            } else if (isNewSearchNeeded($scope.searchStr, $scope.lastSearchTerm)) {
              $scope.lastSearchTerm = $scope.searchStr;
              $scope.showDropdown = true;
              $scope.currentIndex = -1;
              $scope.results = [];

              if ($scope.searchTimer) {
                $timeout.cancel($scope.searchTimer);
              }

              $scope.searching = true;

              $scope.searchTimer = $timeout(function () {
                $scope.searchTimerComplete($scope.searchStr);
              }, $scope.pause);
            }
          } else {
            event.preventDefault();
          }
        };

        $scope.selectResult = function (result) {
          if ($scope.matchClass) {
            result.title = result.title.toString().replace(/(<([^>]+)>)/ig, '');
          }
          $scope.searchStr = $scope.lastSearchTerm = result.title;
          $scope.selectedObject = result;
          $scope.showDropdown = false;
          $scope.results = [];
          $scope.inputChange.apply(null, [result, $scope.selectedObject].concat($scope.inputChangeParams));
          //$scope.$apply();
        };

        var inputField = elem.find('input');

        inputField.on('keyup', $scope.keyPressed);

        elem.on("keyup", function (event) {
          if (event.which === 40) {
            // key arrow down
            if ($scope.results && ($scope.currentIndex + 1) < $scope.results.length) {
              $scope.currentIndex++;
              $scope.$apply();
              event.preventDefault();
              event.stopPropagation();
            }

            $scope.$apply();
          } else if (event.which == 38) {
            // key arrow up
            if ($scope.currentIndex >= 1) {
              $scope.currentIndex--;
              $scope.$apply();
              event.preventDefault();
              event.stopPropagation();
            }

          } else if (event.which == 13) {
            // key enter
            if ($scope.results && $scope.currentIndex >= 0 && $scope.currentIndex < $scope.results.length) {
              $scope.selectResult($scope.results[$scope.currentIndex]);
              $scope.$apply();
              event.preventDefault();
              event.stopPropagation();
            } else {
              $scope.results = [];
              $scope.$apply();
              event.preventDefault();
              event.stopPropagation();
            }

          } else if (event.which == 27) {
            // key escape
            $scope.results = [];
            $scope.showDropdown = false;
            $scope.$apply();
          } else if (event.which == 8) {
            // key backspace
            $scope.selectedObject = {};
            $scope.$apply();
          }
        });

      },
    };
  });


angular.module('components.alert.alert', ['components.modal.modal'])
  .provider('$alert', function () {

    var defaults = this.defaults = {
      animation: 'am-fade',
      prefixClass: 'alert',
      prefixEvent: 'alert',
      placement: null,
      templateUrl: 'app/components/alert/alert.html',
      container: false,
      element: null,
      backdrop: false,
      keyboard: true,
      show: true,
      // Specific options
      duration: false,
      type: false,
      dismissable: true
    };

    this.$get = function ($modal, $timeout) {

      function AlertFactory (config) {

        var $alert = {};

        // Common vars
        var options = angular.extend({}, defaults, config);

        $alert = $modal(options);

        // Support scope as string options [/*title, content, */ type, dismissable]
        $alert.$scope.dismissable = !!options.dismissable;
        if (options.type) {
          $alert.$scope.type = options.type;
        }

        // Support auto-close duration
        var show = $alert.show;
        if (options.duration) {
          $alert.show = function () {
            show();
            $timeout(function () {
              $alert.hide();
            }, options.duration * 1000);
          };
        }

        return $alert;

      }

      return AlertFactory;

    };

  })

  .directive('bsAlert', function ($window, $sce, $alert) {

    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink (scope, element, attr, transclusion) {

        // Directive options
        var options = {scope: scope, element: element, show: false};
        angular.forEach(['template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'keyboard', 'html', 'container', 'animation', 'duration', 'dismissable'], function (key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });

        // use string regex match boolean attr falsy values, leave truthy values be
        var falseValueRegExp = /^(false|0|)$/i;
        angular.forEach(['keyboard', 'html', 'container', 'dismissable'], function (key) {
          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
        });

        // bind functions from the attrs to the show and hide events
        angular.forEach(['onBeforeShow', 'onShow', 'onBeforeHide', 'onHide'], function (key) {
          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
          if (angular.isDefined(attr[bsKey])) {
            options[key] = scope.$eval(attr[bsKey]);
          }
        });

        // overwrite inherited title value when no value specified
        // fix for angular 1.3.1 531a8de72c439d8ddd064874bf364c00cedabb11
        if (!scope.hasOwnProperty('title')) {
          scope.title = '';
        }

        // Support scope as data-attrs
        angular.forEach(['title', 'content', 'type'], function (key) {
          if (attr[key]) {
            attr.$observe(key, function (newValue, oldValue) {
              scope[key] = $sce.trustAsHtml(newValue);
            });
          }
        });

        // Support scope as an object
        if (attr.bsAlert) {
          scope.$watch(attr.bsAlert, function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
              angular.extend(scope, newValue);
            } else {
              scope.content = newValue;
            }
          }, true);
        }

        // Initialize alert
        var alert = $alert(options);

        // Trigger
        element.on(attr.trigger || 'click', alert.toggle);

        // Garbage collection
        scope.$on('$destroy', function () {
          if (alert) alert.destroy();
          options = null;
          alert = null;
        });

      }
    };

  });

angular.module('guestServices')
  .directive('guestServices', function(userService, TABLES_MAPPING, $state) {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: 'app/guest-services/guest-services.html',
      link: function($scope) {
        $scope.user = userService.getUser();

        $scope.TABLES_MAPPING = TABLES_MAPPING;
      }
    }
  });

angular.module('guestServices')
  .config(['$qProvider', function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(false);
  }])
  .run(function ($rootScope, $log, $state, $modal, $window, userService, PermRoleStore, PermPermissionStore) {
    function defineRole(roleName) {
      return userService.getUser('role') === roleName;
    }

    PermRoleStore.defineManyRoles({
      'Admin': defineRole,
      'Main Chef': defineRole,
      'Local Chef': defineRole
    });

    PermPermissionStore.definePermission('authorized', function () {
      return userService.isUserLoggedIn();
    });

    userService.setUser();

    $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from) {
      $rootScope.router = {
        prevState: from.name || 'login'
      };
      $window.scroll(0, 0);
    });

    $rootScope.$on('requestFailed', function (e, error) {
      $modal({
        title: 'An Error Was Encountered ...',
        content: 'This issue has been logged, and we are looking into it. If you require further assistance, please contact the System Administrator.',
        templateUrl: 'app/components/modal/templates/err.tpl.html'
      });
      $log.log(error);
    });

    $rootScope.$on('notFound', function (e, error) {
      $modal({
        title: error.message,
        templateUrl: 'app/components/modal/templates/err.tpl.html'
      });

      $log.log(error);
    });

    $rootScope.$on('noAuth', function (e, error) {
      userService.logout();
      $state.go(error.toState);
      $log.log(error.error);
    });

  });

angular.module('guestServices')
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        template: '<user-login></user-login>',
        data: {
          permissions: {
            except: ['authorized', 'Admin'],
            redirectTo: {
              Admin: 'main.users',
              default: 'main.menu'
            }
          }
        }
      })
      .state('forgot-password', {
        url: '/forgot-password',
        template: '<user-login tpl-type="forgot-password"></user-login>',
        data: {
          permissions: {
            except: ['authorized', 'Admin'],
            redirectTo: {
              Admin: 'main.users',
              default: 'main.menu'
            }
          }
        }
      })
      .state('change-password', {
        url: '/change-password?:resetToken',
        template: '<user-login tpl-type="change-password"></user-login>',
        data: {
          permissions: {
            except: ['authorized', 'Admin'],
            redirectTo: {
              Admin: 'main.users',
              default: 'main.menu'
            }
          }
        }
      })


      .state('main', {
        url: '/',
        template: '<guest-services></guest-services>',
        abstract: true,
        data: {
          permissions: {
            only: ['authorized'],
            redirectTo: 'login'
          }
        }
      })
      .state('main.menu', {
        url: 'menu',
        template: '<menu start-date="startDate"></menu>',
        params: {
          startDate: null
        },
        data: {
          permissions: {
            only: ['authorized'],
            redirectTo: 'login'
          }
        },
        controller: function($scope, $stateParams) {
          $scope.startDate = $stateParams.startDate;
        }
      })
      .state('main.create-menu', {
        url: 'create-menu',
        template: '<create-menu></create-menu>',
        data: {
          permissions: {
            only: ['authorized'],
            redirectTo: 'login'
          },
        }
      })
      .state('main.edit-menu', {
        url: 'edit-menu/:menuId',
        template: '<create-menu menu-data="menuData"></create-menu>',
        data: {
          permissions: {
            only: ['authorized'],
            redirectTo: 'login'
          },
        },
        resolve: {
          menuData: function(menuApiService, $stateParams) {
            return menuApiService.getMenu($stateParams.menuId);
          }
        },
        controller: function($scope, menuData) {
          $scope.menuData = menuData;
        }
      })

      .state('main.catalogue', {
        url: 'catalogue?page&categories&sort',
        template: '<catalogue recipes="recipes" filters="filters" pagination="pagination"></catalogue>',
        data: {
          permissions: {
            only: ['authorized'],
            redirectTo: 'login'
          }
        },
        resolve: {
          filters: function(recipeApiService) {
            return recipeApiService.getDefaultFilters();
          },
          recipes: function(recipeApiService, $stateParams) {
            if ($stateParams.page > 0 || $stateParams.categories || $stateParams.sort) {
              var page = $stateParams.page ? $stateParams.page : 0;
              var categories = $stateParams.categories ? JSON.parse($stateParams.categories) : [];
              var sort = $stateParams.sort ? JSON.parse($stateParams.sort) : {};
              return recipeApiService.filterRecipes(categories, page, sort);
            }
            return recipeApiService.getRecipe();
          }
        },
        controller: function($scope, recipes, filters) {
          $scope.recipes = recipes.data;
          $scope.pagination = recipes.meta ? recipes.meta.pagination : [];
          $scope.filters = filters;
        }
      })
      .state('main.create-recipe', {
        url: 'create-recipe',
        template: '<create-recipe options="options"></create-recipe>',
        data: {
          permissions: {
            only: ['authorized'],
            redirectTo: 'login'
          },
        },
        resolve: {
          options: function(recipeApiService) {
            return recipeApiService.getFilters();
          }
        },
        controller: function($scope, options) {
          $scope.options = options;
        }
      })
      .state('main.edit-recipe', {
        url: 'edit-recipe/:recipeId',
        template: '<create-recipe options="options" recipe="recipe"></create-recipe>',
        data: {
          permissions: {
            only: ['Main Chef','Local Chef', 'Admin', 'canEditRecipe'],
            redirectTo: 'main.menu'
          }
        },
        params: {
          recipe: null
        },
        resolve: {
          recipe: function(recipeApiService, $stateParams) {
            if($stateParams.recipe) {
              $stateParams.recipe.id = undefined;
            }
            return $stateParams.recipe ? $stateParams.recipe : recipeApiService.getRecipe($stateParams.recipeId);
          },
          options: function(recipeApiService) {
            return recipeApiService.getFilters();
          }
        },
        controller: function($scope, recipe, options) {
          $scope.recipe = recipe;
          $scope.options = options;
        }
      })
      .state('main.view-recipe', {
        url: 'view-recipe/:recipeId',
        template: '<view-recipe recipe="recipe"></view-recipe>',
        resolve: {
          recipe: function(recipeApiService, $stateParams) {
            return recipeApiService.calculateRecipe({id: $stateParams.recipeId});
          }
        },
        controller: function($scope, recipe) {
          $scope.recipe = recipe;
        }
      })
      .state('main.users', {
        url: 'users',
        template: '<user-list-table users="users" mapping="TABLES_MAPPING.userList"></user-list-table>',
        resolve: {
          users: function(userListApiService) {
            return userListApiService.getAllUsers();
          }
        },
        data: {
          permissions: {
            only: ['Admin'],
            redirectTo: 'main.menu'
          }
        },
        controller: function($scope, users) {
          $scope.users = users.data;
        }
      });


      $urlRouterProvider.otherwise(function($injector) {
        var $state = $injector.get("$state");
        $state.go('login');
      });
  });

/* global moment:false */

// @todo pas REMOVE

// console.log('PARAMS: ');
// console.log(window.location.protocol);
// console.log(window.location.hostname);
// console.log(window.location.port);

// END remove

angular.module('guestServices')
    
    // @todo PAS CHANGE THIS TO A SERVER/ENVIRONMENT VARIABLE!!!
    .constant('API_URL', 'https://recipes-api.zurka.com/api/v1')

/*
   @todo pas use this line, once proper env parameters are set.
  .constant('API_URL', /local/.test(window.location.hostname) ? 'http://api.recipes.com/api/v1' : '/api/v1')
*/

  .constant('CONFIRM_URL', window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/#/change-password?resetToken=:reset-token:')

  .constant('moment', moment)

  .constant('TABLES_MAPPING', {
    userList: [
      {title: 'Name', value: 'fullName'},
      {title: 'Email', value: 'email'},
      {title: 'Role', value: 'role'}
    ]
  });

angular.module('guestServices')
  .config(function config($httpProvider, $modalProvider, $alertProvider, $datepickerProvider, $logProvider, $locationProvider) {
    $logProvider.debugEnabled(true);

    $locationProvider.html5Mode(false);
    $locationProvider.hashPrefix('');

    angular.extend($modalProvider.defaults, {
      animation: 'am-fade-and-scale',
      placement: 'center',
      backdrop: 'static',
      keyboard: false
    });

    angular.extend($alertProvider.defaults, {
      animation: 'am-fade-and-slide-top',
      duration: 5,
      dismissable: false
    });

    angular.extend($datepickerProvider.defaults, {
      trigger: 'manual',
      dateFormat: 'dd/MM/yyyy',
      startWeek: 1
    });

    $httpProvider.interceptors.push(function ($q, $rootScope, $localStorage) {
      return {
        request: function(config) {
          if($localStorage.apiToken) {
            config.headers['X-Authorization'] = 'Bearer ' + $localStorage.apiToken;
          }

          return config;
        },
        responseError: function (error) {
          if(error.status === 500) {
            $rootScope.$broadcast('requestFailed', error);
          } else if(error.status === 401) {
            $rootScope.$broadcast('noAuth', {toState: 'login', error: error});
          } else if(error.status === 404) {
            $rootScope.$broadcast('notFound', error.data);
          }

          return $q.reject(error);
        }
      };
    });
  });

angular.module("guestServices").run(["$templateCache", function($templateCache) {$templateCache.put("app/guest-services/guest-services.html","<div class=\"guest-services container m-t-25\"><div class=clearfix><div class=\"corporate-logo pull-left m-b-0\" ui-sref=main.menu></div><main-menu class=\"pull-left m-t-10\" role=user.role mapping=MAIN_MENU_LINKS_MAPPING></main-menu><div class=\"pull-right text-right user-account-data no-print\"><span class=pull-left>{{user.fullName}}<br><span class=display-6-g>{{user.role}}</span></span><logout></logout></div></div><div class=\"main-content m-t-15 clearfix\" ui-view></div></div>");
$templateCache.put("app/components/alert/alert.html","<span class=alert ng-class=\"[type ? \'alert-\' + type : null]\"><button type=button class=close ng-if=dismissable ng-click=$hide()>&times;</button> <span ng-if=title><strong ng-bind=title></strong>&nbsp;<span ng-bind-html=content class=alert-content></span> </span><span ng-if=!title ng-bind-html=content class=alert-content></span> </span>");
$templateCache.put("app/components/catalogue/catalogue.html","<div class=\"catalogue clearfix\" ng-class=\"{collapsed: collapsed}\"><div class=\"search-wrapper m-t-10\"><input title=search type=text class=\"search-input display-6\" ng-model=search ng-model-options=\"{debounce: 300}\" placeholder=Search></div><recipe-filters class=pull-left filters=filters categories-filter=categories on-change=onChange is-menu-state=collapsed ng-class=\"{disabled: isChanged}\"></recipe-filters><div class=\"recipe-list-column clearfix m-b-20 pull-right\"><div class=\"dropdown-menu-wrapper p-l-20\" ng-class=\"{disabled: isChanged}\"><span class=\"dropdown-menu-button display-6-g\" data-animation=am-flip-x bs-dropdown aria-haspopup=true aria-expanded=false>Sorting by {{selected.selectedName}}</span><ul class=dropdown-menu role=menu><li class=\"dropdown-menu-item {{link.className}}\" ng-repeat=\"link in DROPDOWN_MAPPING\" ng-click=\"setOrder(link, $event)\" ng-class=\"{selected: link.selected}\"><a>{{link.name}}</a></li></ul></div><button class=\"btn btn-success pull-right\" ui-sref=main.create-recipe permission permission-only=\"[\'Main Chef\', \'Admin\']\">Create Recipe</button><!-- <button class=\"btn btn-transparent pull-right m-r-20\" ng-click=\"openImportModal()\">Import url</button> --></div><recipe-list class=pull-left recipes=filteredRecipes is-loading=isLoading on-select=onSelectRecipe></recipe-list><div class=clearfix></div><catalogue-pagination data=\"pagination || $parent.pagination\" on-set-page=\"onSetPage || $parent.onSetPage\" class=pull-right></catalogue-pagination></div>");
$templateCache.put("app/components/datepicker/datepicker.html","<div class=\"dropdown-menu datepicker\" ng-class=\"\'datepicker-mode-\' + $mode\" style=\"max-width: 320px\"><table style=\"table-layout: fixed; height: 100%; width: 100%\"><thead><tr class=text-center><th><button tabindex=-1 type=button class=\"select-pane-button btn btn-default pull-left\" ng-click=$selectPane(-1)><span class=\"icon i-prev\"></span></button></th><th colspan=\"{{ rows[0].length - 2 }}\" style=\"vertical-align: middle\"><button tabindex=-1 type=button class=\"btn btn-default btn-block text-strong\" style=\"padding: 0\"><strong style=\"text-transform: capitalize\" ng-bind=title></strong></button></th><th><button tabindex=-1 type=button class=\"select-pane-button btn btn-default pull-right\" ng-click=$selectPane(+1)><span class=\"icon i-next\"></span></button></th></tr><tr ng-if=showLabels ng-bind-html=labels></tr></thead><tbody><tr ng-repeat=\"(i, row) in rows\" height=\"{{ 100 / rows.length }}%\" ng-class=\"{\'current-week\': row.isSelected}\" ng-init=\"rowIndex = $index\"><td class=text-center ng-repeat=\"(j, el) in row\"><button tabindex=-1 type=button class=\"btn btn-default\" style=\"width: 100%\" ng-class=\"{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}\" ng-click=\"$select(el.date, row, rowIndex)\" ng-disabled=\"el.disabled || row.isDisabled\"><span ng-class=\"{\'text-muted\': el.muted}\" ng-bind=el.label></span></button></td></tr></tbody><tfoot><tr><td colspan=\"{{ rows[0].length }}\"><div class=\"btn-group btn-group-justified\" role=group><div class=btn-group role=group ng-if=$hasToday><button type=button class=\"btn btn-default today\" ng-click=$setToday() ng-disabled=isTodayDisabled><strong style=\"text-transform: capitalize\">Today</strong></button></div><div class=btn-group role=group ng-if=$hasClear><button type=button class=\"btn btn-default clear\" ng-click=$clear()><strong style=\"text-transform: capitalize\">Clear</strong></button></div></div></td></tr></tfoot></table></div>");
$templateCache.put("app/components/dropdown/dropdown.html","<ul tabindex=-1 class=dropdown-menu role=menu ng-show=\"content && content.length\"><li role=presentation ng-class=\"{divider: item.divider, active: item.active}\" ng-repeat=\"item in content\"><a role=menuitem tabindex=-1 ng-href={{item.href}} ng-if=\"!item.divider && item.href\" target=\"{{item.target || \'\'}}\" ng-bind=item.text></a> <a role=menuitem tabindex=-1 href=javascript:void(0) ng-if=\"!item.divider && item.click\" ng-click=$eval(item.click);$hide() ng-bind=item.text></a></li></ul>");
$templateCache.put("app/components/logout/logout.html","<div class=logout-wrapper><span class=\"logout-icon pull-right\" title=Logout ng-click=openLogoutModal()></span></div>");
$templateCache.put("app/components/menu/menu.html","<div class=\"menu clearfix\"><div class=menu-list><div ng-show=menuList.length><div class=\"display-8-g text-weight-semibold text-upper\">Menus</div><hr style=\"background: #e6e6e6; height: 1px; border: 0\"><div class=\"menu-list-item m-t-10\" ng-repeat=\"menuItem in menuList\" ng-click=\"selectMenu(menuItem, $event)\" ng-class=\"{selected: menuItem.isSelected}\"><div class=\"display-4 text-weight-semibold m-b-5\">{{menuItem.title}}</div><div class=m-b-5><span class=\"display-6-g p-r-15 m-r-20\">Author </span><span class=display-6>{{menuItem.author_chef_name}}</span></div><div class=m-b-10><span class=\"display-6-g m-r-5\">Last Update</span><span class=display-6>{{menuItem.updated_at | limitTo: 10}}</span></div></div></div></div><div class=\"m-l-15 menu-content\"><div class=\"no-menus-wrapper relative text-center\" ng-show=\"menuList.$resolved && !menuList.length\"><span class=\"no-menus display-4-g\"><span class=no-menus-img></span><br>No menus added</span></div><div class=\"display-1 text-weight-bold clearfix\"><div style=\"display: inline-block; max-width: 585px\" class=\"pull-left m-t-5\">{{menuData.title}}</div></div><div><div class=\"tabs-wrapper clearfix\" ng-show=menuData.id><div class=\"tab-header text-upper\" ng-class=\"{selected: tab.isSelected}\" ng-repeat=\"tab in ::tabs\" style=\"display: inline-block\" ng-click=selectTab(tab);>{{tab.name}}</div></div><div class=tab-wrapper ng-repeat=\"tab in ::tabs\" ng-show=\"tab.isSelected && menuData.id\"><div class=m-b-20 ng-repeat=\"station in menuData.weekdays[tab.name] track by $index\"><div class=\"text-weight-bold text-upper m-b-10 p-l-15\">{{station.name}}</div><div class=menu-section ng-class=\"{\'menu-section-first\': $first, \'menu-section-last\': $last}\" ng-repeat=\"recipe in station.recipes track by $index\" ui-sref=\"main.view-recipe({recipeId: recipe.id})\"><span title={{recipe.price}} class=\"text-weight-bold menu-recipe menu-recipe-price\" style=\"position: absolute; right: 20px; top: 22px\">{{recipe.price}}</span><div class=\"recipe-photo-wrapper border-radius pull-left m-r-15\" ng-style=\"{backgroundImage: recipe.photo.url && \'url(\' + recipe.photo.url + \')\'}\"><img class=border-radius ng-show=!recipe.photo.url ng-src=../../../../assets/images/img-placeholder.png></div><div class=\"display-3 text-weight-bold m-b-10 menu-recipe menu-recipe-name\" style=\"padding-left: 90px\">{{recipe.title}}</div><div style=\"padding-left: 90px\"><span class=display-6-g>Servings size:</span> <span class=display-6>{{recipe.serving}}</span></div><div style=\"padding-left: 90px\"><span class=display-6-g>kcal: </span><span class=display-6>{{recipe.calories}}</span></div><div style=\"padding-left: 90px\" class=display-6>{{recipe.cuisine.name}}</div><div class=border-line ng-if=!$last></div></div></div></div></div></div><div class=\"menu-right-content m-l-15\"><div class=clearfix><div class=\"text-right m-b-20\"><button class=\"btn btn-success letter-spacing\" ui-sref=main.create-menu>Create menu</button></div><div class=\"no-print menu-action-buttons\" ng-class=\"{\'hidden\': !menuData.id}\"><button class=\"btn btn-success\" data-placement=bottom data-animation=am-flip-x bs-popover=popover data-template-url=app/components/popover/templates/download.html auto-close=1 ng-disabled=disableDownload>Download</button> <button permission permission-only=\"[\'Main Chef\', \'Local Chef\', \'Admin\']\" ng-if=isMenuAuthor() class=\"btn btn-default btn-clear\" ui-sref=\"main.edit-menu({menuId: menuData.id})\">Edit</button> <button permission permission-only=\"[\'Main Chef\', \'Local Chef\', \'Admin\']\" ng-if=isMenuAuthor() class=\"btn btn-default btn-clear\" ng-click=openRemoveModal(menuData.id)>Delete</button><!--<button--><!--permission permission-only=\"\'Local Chef\'\"--><!--class=\"btn btn-default btn-clear\"--><!--ng-click=\"print()\">Print--><!--</button>--></div></div><div class=clearfix><div><span class=\"display-6 text-weight-bold\">Select week</span></div><input data-bs-show=true bs-datepicker ng-model=currentWeek readonly ng-change=setDate(currentWeek) data-disable-week=false style=\"border: 0\" ng-hide=true></div><div permission permission-only=\"[\'Main Chef\', \'Local Chef\', \'Admin\']\" class=\"menu-section clearfix\" ng-if=menuData.schedule.length><div class=clearfix><span class=\"text-weight-bold display-6 pull-left\">Schedule of meal</span></div><div><div ng-repeat=\"station in menuData.schedule\" ng-class=\"{\'m-t-20\': $first}\"><div class=\"display-6 pull-left\" style=\"padding-bottom: 8px\"><span class=text-weight-bold style=\"text-overflow: ellipsis; width: 180px;display: inline-block;overflow: hidden\">{{station.name}}</span><div>{{station.start + \' - \' + station.end}}</div></div><hr ng-hide=$last style=\"background: #f1f1f1; height: 1px; border: 0\"></div></div></div><div permission permission-only=\"[\'Main Chef\', \'Local Chef\', \'Admin\']\" class=menu-section ng-if=menuData.assigned_chefs.length><div class=clearfix><span class=\"text-weight-bold display-6 pull-left\">Assigned to</span></div><div><div ng-repeat=\"selectedChef in menuData.assigned_chefs | orderBy : \'last_name\'\" ng-class=\"{\'m-t-30\': $first}\">{{selectedChef.first_name + \' \' + selectedChef.last_name}}<hr ng-hide=$last style=\"background: #f1f1f1; height: 1px; border: 0; margin: 12px 0\"></div></div></div></div></div>");
$templateCache.put("app/components/modal/modal.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=modal-header ng-show=title><h4 class=modal-title>{{title}}</h4></div><div class=modal-body>{{content}}</div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$hide()>Close</button></div></div></div></div>");
$templateCache.put("app/components/main-menu/main-menu.html","<div class=\"main-menu no-print\"><ul><li class=\"menu-li text-weight-semibold display-4\" ui-sref=main.menu ng-class=\"{\'active\': isActive([\'menu\'])}\"><a ng-href=#/menu>Menu</a></li><li class=\"menu-li text-weight-semibold display-4\" ui-sref=main.catalogue ng-class=\"{\'active\': isActive([\'catalogue\', \'recipe\'])}\"><a ng-href=#/catalogue>Catalogue</a></li><li class=\"menu-li text-weight-semibold display-4\" ui-sref=main.users ui-sref-active=active permission permission-only=\"\'Admin\'\"><a ng-href=#/users>Users</a></li></ul><span class=\"alert-container relative\"></span></div>");
$templateCache.put("app/components/nutritions-table/nutritions-table.html","<div class=nutritions-table><div class=nutritions-table-wrapper><h4 class=\"table-title text-upper display-6\">Total Nutrition Facts</h4><span class=\"subtitle display-7\">Portion Size {{data.portion.size + \' \' + data.portion.unit}}</span><hr><table class=\"total-nutrition-table m-t-15\"><tr ng-repeat=\"nutrition in ::mapping\"><td class=\"display-6 p-b-10 p-r-20\">{{ nutrition.key }}</td><td class=\"value display-6 text-weight-bold text-right p-r-10\">{{ data.nutrition_report[nutrition.value] | number: 1 }}</td><td class=\"entry display-6-g\">{{ nutrition.unit }}</td></tr></table><div class=\"icon icon-print\" ng-click=print()></div></div></div>");
$templateCache.put("app/components/popover/popover.html","<div class=popover tabindex=-1><div class=arrow></div><h3 class=popover-title ng-bind-html=title ng-show=title></h3><div class=popover-content ng-bind-html=content></div></div>");
$templateCache.put("app/components/pagination/pagination.html","<div class=pagination ng-show=\"perPage < totalCount\"><span class=pagination-item ng-show=\"pages.length > 1\" ng-click=\"currentChunk > 0 && setChunk(-1, $event)\">&laquo;</span> <span class=pagination-item ng-class=\"{active: $index === currentPage}\" ng-repeat=\"page in pages[currentChunk ]\" ng-click=\"setPage($index, $event)\">{{page}}</span> <span class=pagination-item ng-show=\"pages.length > 1\" ng-click=\"currentChunk < pages.length - 1 && setChunk(1, $event)\">&raquo;</span></div>");
$templateCache.put("app/components/user-list-table/user-list-table.html","<div class=user-list-table><div class=table><div class=table-head><div ng-repeat=\"th in ::mapping\" ng-show=users.length class={{th.value}}>{{th.title}}</div><div class=\"action-cell text-right\"><button class=\"btn btn-success\" ng-click=openUserCreateModal()>Create user</button></div></div><div class=table-body ng-if=users.length><div class=row ng-repeat=\"user in filteredUsers | orderBy : \'last_name\'\"><div ng-repeat=\"td in ::mapping\" class=\"cell {{td.value}}\">{{user[td.value]}}</div><div class=\"action-cell text-right\"><span class=user-remove data-animation=am-flip-x bs-tooltip=tooltip data-title=Delete ng-click=openUserRemoveModal(user.id)></span> <span class=user-edit data-animation=am-flip-x bs-tooltip=tooltip data-title=Edit ng-click=openUserEditModal(user)></span></div></div></div></div><pagination class=m-t-25 total-count=users.length per-page=50 on-set-page=setPage></pagination><div class=\"no-users-wrapper relative text-center\" ng-if=!users.length><span class=\"no-users display-4-g\"><span class=no-users-img></span><br>No users added</span></div></div>");
$templateCache.put("app/components/tooltip/tooltip.html","<div class=\"tooltip in\" ng-show=title><div class=tooltip-arrow></div><div class=tooltip-inner ng-bind=title></div></div>");
$templateCache.put("app/components/user-login/change-password.html","<div class=\"corporate-logo m-t-15\"></div><div class=\"h3 text-center\">Change Password</div><div class=form-group><label><span class=\"text-weight-bold pull-left\">New password</span> <span class=\"display-6 text-italic pull-right\" ng-hide=\"loginForm.userPassword.$error.required && (loginForm.userPassword.$touched || loginForm.$submitted)\" ng-class=\"{\'form-error-text\': loginForm.userPassword.$error.pattern && (loginForm.userPassword.$touched || loginForm.$submitted)}\">At least 8 characters, 1 letter, 1 number </span><span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.userPassword.$error.required && (loginForm.userPassword.$touched || loginForm.$submitted)\">New password is required </span><span class=\"relative block\"><input type=password class=form-input name=userPassword required ng-model=user.password ng-model-options=\"{updateOn: \'blur\'}\" pattern=\"(?=.*\\d)(?=.*[a-zA-Z]).{8,}\"> <span class=input-checkbox ng-show=\"!loginForm.userPassword.$error.pattern && !loginForm.userPassword.$error.required &&\n      (loginForm.userPassword.$touched || loginForm.$submitted)\"></span> <span class=input-cross ng-show=\"loginForm.userPassword.$error.pattern &&\n       (loginForm.userPassword.$touched || loginForm.$submitted)\"></span></span></label></div><div class=form-group><label><span class=\"text-weight-bold pull-left\">Repeat new password</span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.userPasswordRepeat.$error.required && (loginForm.userPasswordRepeat.$touched || loginForm.$submitted)\">Repeat new password is required </span><span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.userPasswordRepeat.$error.equals && (loginForm.userPasswordRepeat.$touched || loginForm.$submitted)\">Password doesn\'t match </span><span class=\"relative block\"><input type=password class=form-input name=userPasswordRepeat required ng-model=user.passwordRepeat ng-model-options=\"{updateOn: \'blur\'}\" pattern=\"(?=.*\\d)(?=.*[a-zA-Z]).{8,}\" equals=userPassword> <span class=input-checkbox ng-show=\"!loginForm.userPasswordRepeat.$error.pattern && !loginForm.userPasswordRepeat.$error.required &&\n       (loginForm.userPasswordRepeat.$touched || loginForm.$submitted)\"></span> <span class=input-cross ng-show=\"loginForm.userPasswordRepeat.$error.pattern &&\n       (loginForm.userPasswordRepeat.$touched || loginForm.$submitted)\"></span></span></label></div><div class=\"form-group m-b-25\"><button class=\"btn btn-success m-t-25 text-weight-bold letter-spacing\" type=submit ng-click=\"loginForm.$valid && submit(\'changePassword\', user.password, $event)\" ng-disabled=disableSubmit>submit</button></div>");
$templateCache.put("app/components/user-login/forgot-password.html","<div class=\"h3 text-center relative\"><div class=\"btn-back pull-left\" ui-sref={{$root.router.prevState}}></div>Forgot your password?</div><div class=\"text-center h6\">Please enter your email and we will send<br>you password reset instructions</div><div class=form-group><label><span class=user-login-form__input-title>Email</span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.userEmail.$error.required && (loginForm.userEmail.$touched || loginForm.$submitted)\">Email is required </span><span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.userEmail.$error.email && (loginForm.userEmail.$touched || loginForm.$submitted)\">Invalid email </span><input type=email class=form-input name=userEmail required ng-model=user.email ng-model-options=\"{updateOn: \'blur\'}\"></label></div><div class=\"form-group m-b-25\"><button class=\"btn btn-success m-t-25 text-weight-bold letter-spacing\" type=submit ng-click=\"loginForm.$valid && submit(\'resetPassword\', user.email, $event)\" ng-disabled=disableSubmit>Request reset link</button></div>");
$templateCache.put("app/components/user-login/login.html","<div class=login><div class=\"corporate-logo m-t-15\"></div><div class=\"h3 text-center\">Log Into Your Account<div><div class=form-group><label><span class=user-login-form__input-title>Email</span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.userEmail.$error.required && (loginForm.userEmail.$touched || loginForm.$submitted)\">Email is required </span><span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.userEmail.$error.email && (loginForm.userEmail.$touched || loginForm.$submitted)\">Invalid email </span><span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.$valid && isUserExist === false && (loginForm.userPassword.$touched || loginForm.$submitted)\">Credentials are not valid </span><input type=email class=form-input name=userEmail required ng-model=user.email on-enter-press=login()></label></div><div class=form-group><label><span class=user-login-form__input-title>Password</span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"loginForm.userPassword.$error.required && (loginForm.userPassword.$touched || loginForm.$submitted)\">Password is required </span><input type=password class=form-input name=userPassword required ng-model=user.password on-enter-press=login()></label></div><div class=form-group><button class=\"btn btn-success m-t-25 text-weight-bold letter-spacing\" type=submit ng-click=login($event) ng-disabled=disableSubmit>login</button></div><div class=form-group><div class=\"forgot-password h4 text-center\"><a ui-sref=forgot-password href=/forgot-password>Forgot password?</a></div></div></div></div></div>");
$templateCache.put("app/components/user-login/user-login.html","<div class=user-login><div class=\"password-reset-alert-wrapper text-center\"><span class=alert-container></span></div><form class=\"user-login-form box-shadow border-radius container\" name=loginForm novalidate><div ng-include=\"\'app/components/user-login/\' + tplType + \'.html\'\"></div></form></div>");
$templateCache.put("app/components/catalogue/catalogue-pagination/catalogue-pagination.html","<div class=catalogue-pagination ng-hide=$parent.isChanged><div ng-show=\"data.total > data.per_page\"><span class=pagination-item ng-show=\"pages.length > 1\" ng-click=\"currentChunk > 0 && setChunk(-1, $event)\">&laquo;</span> <span class=pagination-item ng-repeat=\"page in pages[currentChunk]\" ng-class=\"{active: page === currentPage}\" ng-click=\"setPage(page, $event)\">{{page + 1}}</span> <span class=pagination-item ng-show=\"pages.length > 1\" ng-click=\"currentChunk < pages.length - 1 && setChunk(1, $event)\">&raquo;</span></div></div>");
$templateCache.put("app/components/catalogue/create-recipe/create-recipe.html","<div class=create-recipe-content><div class=create-recipe-body><h2 class=title>{{recipe ? \'Edit\' : \'Create\'}} Recipe</h2><form name=createRecipeForm class=\"recipe-block recipe-categories-allergens\" novalidate><div class=recipe-inputs-wrapper><div class=\"input-wrapper form-group\"><label class=\"label required-field\">Recipe Title</label><span class=\"form-error-text p-l-20\" ng-show=\"createRecipeForm.recipeTitle.$error.required && (createRecipeForm.recipeTitle.$touched || createRecipeForm.$submitted)\">Recipe title is required </span><input type=text name=recipeTitle class=text-input ng-model=recipeData.mainRecipe.title ng-change=checkSubmit() placeholder=\"Enter the name of the recipe, example: Ciabatta Egg Sandwich With Tomato Jam\" input-max-length=300 required> <span class=\"icon i-delete\" ng-click=\"recipeData.mainRecipe.title = \'\'\" title=\"Clear recipe title\"></span></div><div class=\"input-wrapper number-wrapper\"><label class=label>Servings per recipe</label><input type=text class=text-input value=1 min=1 ng-model=recipeData.mainRecipe.serving input-max-length=3 ng-change=calculateTotalNutritions(true) only=integer></div><div class=\"input-wrapper number-wrapper\"><label class=label>Serving size</label><input type=text class=text-input value=0 ng-disabled=\"recipeData.mainRecipe.portion.unit.id === \'qty\'\" min=0 ng-model=recipeData.mainRecipe.portion.size only=float></div><div class=\"input-wrapper unit-wrapper\"><label class=label>Unit</label><div class=dropdown-wrapper><select class=dropdown-toggle name=unitSelect ng-options=\"option.name for option in recipeData.unit.availableOptions track by option.id\" ng-model=recipeData.mainRecipe.portion.unit></select><span class=caret></span></div></div><div class=\"input-wrapper cuisine-wrapper\"><label class=label>Cuisine</label><div class=dropdown-wrapper><select class=dropdown-toggle name=unitSelect ng-options=\"option.name for option in options.cuisines track by option.id\" ng-model=recipeData.mainRecipe.cuisine><option value=\"\" disabled selected hidden>Select Cuisine</option></select><span class=caret></span></div></div></div><div class=checkboxes-wrapper><h4 class=subtitle>Categories</h4><div class=\"checkbox-list-wrapper m-t-25\" ng-repeat=\"category in options.category_groups\"><span class=checkbox-group-name>{{category.name}}</span><div class=checkboxes-container><ul class=checkbox-list ng-style=\"{columns: category.categories.length >= 7 && getColumnsCount(category.categories.length, 7)}\"><li class=list-item ng-repeat=\"checkbox in category.categories | orderBy : \'name\'\"><label class=checkbox-element><input ng-change=\"selectOption(checkbox, \'categories\');\" type=checkbox ng-model=checkbox.isChecked> <span class=checkbox-item><span ng-class=\"{checked : checkbox.isChecked}\" class=label></span> </span><span class=checkbox-label>{{checkbox.name}}</span></label></li></ul></div></div></div><div class=checkboxes-wrapper><h4 class=subtitle>Allergens</h4><div class=\"checkboxes-container m-t-25\"><ul class=checkbox-list ng-style=\"{columns: options.allergens.length >= 2 && getColumnsCount(options.allergens.length, 2)}\"><li class=list-item ng-repeat=\"checkbox in options.allergens | orderBy : \'name\'\"><label class=checkbox-element><input ng-change=\"selectOption(checkbox, \'allergens\');\" type=checkbox ng-model=checkbox.isChecked> <span class=checkbox-item><span ng-class=\"{checked : checkbox.isChecked}\" class=label></span> </span><span class=checkbox-label>{{checkbox.name}}</span></label></li></ul></div></div><div class=checkboxes-wrapper><h4 class=subtitle>Dietary</h4><div class=\"checkboxes-container m-t-25\"><ul class=checkbox-list ng-style=\"{columns: options.dietary.length >= 4 && getColumnsCount(options.dietary.length, 4)}\"><li class=list-item ng-repeat=\"checkbox in options.dietary | orderBy : \'name\'\"><label class=checkbox-element><input ng-change=\"selectOption(checkbox, \'dietaries\');\" type=checkbox ng-model=checkbox.isChecked> <span class=checkbox-item><span ng-class=\"{checked : checkbox.isChecked}\" class=label></span> </span><span class=checkbox-label>{{checkbox.name}}</span></label></li></ul></div></div></form><div class=\"recipe-block recipe-ingredients\" ng-repeat=\"recipe in recipeData.recipes\"><form name=recipeForm novalidate><div class=recipe-inputs-wrapper><div class=input-wrapper><label class=label>{{ $first ? \'Main Recipe\' : \'Sub Recipe\' }}</label><span class=\"icon i-trash\" title=\"Remove sub recipe\" ng-if=!$first ng-click=\"removeByIndex(recipeData.recipes, $index, [], \'sub recipe section\')\"></span><div ng-if=!$first><angucomplete placeholder=\"Enter the title of the part recipe, example: Caribean Sauce\" pause=350 url=\"{{API_URL + \'/subrecipes/search?q=\'}}\" selectedobject=recipe searchfields=title titlefield=title minlength=3 maxlength=300 input-change=getSubRecipe input-change-params=\"[recipe, $index]\" on-blur=checkSubrecipe on-blur-params=\"[recipe, $index]\" inputclass=text-input input-name=recipeName><span class=\"icon i-delete\" title=\"Clear title\" ng-click=\"recipe.title = \'\'; recipeForm.$setDirty()\"></span></div></div></div><span class=validation ng-class=\"{\'show\': recipeForm.$invalid && (recipeForm.$dirty || createRecipeForm.$submitted)}\"><span ng-show=recipeForm.IngCount.$error.required>Amount is required<span class=\"icon i-warn\"></span></span> <span ng-show=\"recipeForm.IngNutrition.$error.required && !recipeForm.IngName.$error.required && !recipeForm.IngCount.$error.required\">Nutritional facts are required<span class=\"icon i-warn\"></span></span> <span ng-show=recipeForm.IngName.$error.required>Ingredients are required<span class=\"icon i-warn\"></span></span></span><table class=\"ingredient-table m-t-20\"><col width=509px><col width=74px><col width=162px><col><col><col><col><col><col><col><thead><tr><td></td><td></td><td></td><td>Fat</td><td>Carbs</td><td>Prot</td><td>Cal</td><td></td><td></td><td></td></tr><tr><td><span class=\"table-title required-field\">Ingredients</span></td><td>Amount</td><td>Units</td><td class=value>{{ recipe.nutritionsSum.total_fat | number: 1 }}</td><td class=value>{{ recipe.nutritionsSum.carbohydrate | number: 1 }}</td><td class=value>{{ recipe.nutritionsSum.protein | number: 1 }}</td><td class=value>{{ recipe.nutritionsSum.calories | number: 0 }}</td><td class=nutrion-info ng-class=\"{\'active\' : isInfo}\"><span class=\"icon i-info\" ng-click=\"isInfo = !isInfo\" on-click-outside=\"isInfo = false;\"></span><div class=total-nutrition-facts ng-if=recipe.nutritionsSum.calories><h4 class=table-title>Nutrition Facts</h4><table class=total-nutrition-table><tr ng-repeat=\"nutrition in ::NUTRITION_MAPPING\"><td>{{ nutrition.key }}</td><td class=value>{{ recipe.nutritionsSum[nutrition.value] | number: 1 }}</td><td class=entry>{{ nutrition.unit }}</td></tr></table></div></td><td></td><td></td></tr></thead><tbody><tr ng-repeat=\"ingredient in recipe.ingredients\"><td style=\"min-width: 360px\"><angucomplete placeholder=\"Enter an ingredient\" id={{ingredient.nid}} pause=350 url=\"{{API_URL + \'/ingredients/search?q=\'}}\" selectedobject=ingredient searchfields=name titlefield=name minlength=3 maxlength=150 input-change=getInfo input-change-params=\"[recipe, $index]\" on-blur=onBlurIngredient on-blur-params=\"[recipe, $index]\" inputclass=text-input name=IngName></td><td style=\"min-width: 120px\"><input type=text name=IngCount class=\"text-input input-number\" required ng-model=ingredient.amount min=0 ng-change=\"changeAmount(recipe, $index)\" input-max-length=10 only=float></td><td style=\"min-width: 100px\"><div class=dropdown-wrapper><select ng-if=\"!ingredient.units.length || (ingredient.units.length && ingredient.is_custom !== false)\" class=dropdown-toggle name=unitSelect ng-options=\"option.name for option in recipeData.ingredientUnits.availableOptions track by option.id\" ng-model=ingredient.unit ng-change=\"changeCustomIngredientUnit(ingredient.unit, recipe, $index)\"></select><select ng-if=\"ingredient.units.length && ingredient.is_custom === false\" class=dropdown-toggle name=unitSelect ng-model=ingredient.unit ng-change=\"changeIngredientUnit(ingredient.unit, recipe, $index)\"><option ng-repeat=\"option in ingredient.units track by option.id\" label={{option.name}} ng-value=option ng-disabled=option.separator>{{option.name}}</option></select><span class=caret></span></div></td><td style=\"min-width: 80px\"><input name=IngNutrition class=\"text-input read-only\" required type=text readonly ng-model-options=\"{ updateOn: \'blur\' }\" ng-model=ingredient.nutritionSum.total_fat placeholder=\"{{ingredient.total_fat === undefined ? \'N/A\' : \'-\'}}\" input-max-length=6></td><td style=\"min-width: 80px\"><input name=IngNutrition class=\"text-input read-only\" required type=text readonly ng-model-options=\"{ updateOn: \'blur\' }\" ng-model=ingredient.nutritionSum.carbohydrate placeholder=\"{{ingredient.carbohydrate === undefined ? \'N/A\' : \'-\'}}\" input-max-length=6></td><td style=\"min-width: 80px\"><input name=IngNutrition class=\"text-input read-only\" required type=text readonly ng-model-options=\"{ updateOn: \'blur\' }\" ng-model=ingredient.nutritionSum.protein placeholder=\"{{ingredient.protein === undefined ? \'N/A\' : \'-\'}}\" input-max-length=6></td><td style=\"min-width: 80px\"><input name=IngNutrition class=\"text-input read-only\" required type=text readonly ng-model-options=\"{ updateOn: \'blur\' }\" ng-model=ingredient.nutritionSum.calories placeholder=\"{{ingredient.calories === undefined ? \'N/A\' : \'-\'}}\" input-max-length=6></td><td class=nutrion-info ng-class=\"{\'active\' : isInfo}\"><span class=\"icon i-info\" ng-click=\"isInfo = !isInfo\" on-click-outside=\"isInfo = false;\"></span><div class=total-nutrition-facts ng-if=ingredient.name><h4 class=table-title>Nutrition Facts</h4><table class=total-nutrition-table><tr ng-repeat=\"nutrition in ::NUTRITION_MAPPING\"><td>{{ nutrition.key }}</td><td class=value>{{ ingredient.nutritionSum[nutrition.value] | number: 1 }}</td><td class=entry>{{ nutrition.unit }}</td></tr></table></div></td><td ng-show=!ingredient.nid><span class=\"icon i-edit\" title=\"Edit nutrition facts\" ng-click=\"!ingredient.nid && editNutritions(ingredient, recipe, $index)\"></span></td><td><span class=\"icon i-delete\" ng-hide=\"recipe.ingredients.length === 1\" ng-click=\"removeByIndex(recipe.ingredients, $index, recipe, \'ingredient\'); recipeForm.$setPristine();\"></span></td></tr></tbody><tfoot><tr ng-if=\"recipe.ingredients.length < 70\"><td colspan=10><span class=add-element-control ng-click=\"helper.addRecipeIngredient(recipe.ingredients); recipeForm.$setPristine();\">Add ingredient</span></td></tr></tfoot></table><div class=recipe-inputs-wrapper><div class=input-wrapper><label class=label>Method</label><div class=method-input-wrapper><ul class=method-input-list><li class=list-item ng-repeat=\"method in recipe.methods\"><textarea class=\"text-input m-b-10\" cols=30 rows=1 placeholder=\"{{ $index + 1 }}. Step\" ng-model=method.desc input-max-length=1000>\n                    {{ method.desc }}\n                  </textarea><span class=\"icon i-delete\" ng-if=\"recipe.methods.length > 1\" ng-click=\"removeByIndex(recipe.methods, $index, {}, \'step\')\"></span><div class=\"add-element-control m-b-15\" ng-if=\"recipe.methods.length < 70\" ng-click=\"helper.addRecipeMethod(recipe.methods, $index)\">Add step</div></li></ul></div></div></div></form></div><div class=additional-info><div class=photos-and-subscribes><div class=add-new-subscribe ng-if=\"recipeData.recipes.length <= 10\"><span class=add-new-subscribe-button ng-click=helper.addRecipe(recipeData.recipes)><span class=\"icon i-add\"></span> Add new sub recipe</span></div><div class=add-new-photo ng-hide=\"img.name || imgPreview.name\"><span class=add-new-photo-button ngf-select=\"uploadImage($file, $invalidFiles)\" accept=image/png,image/jpeg ngf-dimensions=\"$width > 200 || $height > 200\" ngf-max-size=5MB><span class=\"icon i-photo\"></span> Add photo</span></div><div class=img-container ng-show=\"img.name || imgPreview.name\"><img src=\"\" ngf-thumbnail=img style=\"width: 200px\" ng-hide=imgPreview.name> <img ng-src={{imgPreview.url}} style=\"width: 200px\" ng-hide=img.name> <span class=\"icon i-edit\" ngf-select=\"uploadImage($file, $invalidFiles)\" title=\"Change image\" accept=image/png,image/jpeg ngf-dimensions=\"$width > 200 || $height > 200\" ngf-max-size=5MB></span> <span class=\"icon i-delete\" title=\"Remove image\" ng-click=\"img = null; imgPreview = null; recipeData.mainRecipe.photo = null;\"></span></div><div class=\"pink m-t-15\" ng-show=invalidImg>Photo must be no less than 200 pixels tall and wide. Photo size must be no more than 5 MB. Jpeg or PNG formats are supported.</div></div><div class=total-nutrition-facts><h4 class=table-title>Total Nutrition Facts</h4><span class=subtitle>per serving</span><table class=total-nutrition-table><tr ng-repeat=\"nutrition in ::NUTRITION_MAPPING\"><td>{{ nutrition.key }}</td><td class=value>{{ totalNutritionsWithServing[nutrition.value] | number: 1 }}</td><td class=entry>{{ nutrition.unit }}</td></tr></table></div></div></div><div class=create-recipe-bottom><button class=\"btn btn-default\" ng-if=recipe.id ng-click=deleteRecipe(recipe.id)>Delete</button> <button class=\"btn btn-default m-l-20\" ng-click=cancelPage()>Cancel</button> <button type=button class=\"btn btn-default btn-submit m-l-20\" ng-class=\"{\'btn-disable\': createRecipeForm.$invalid}\" ng-if=recipe.id ng-disabled=disableSubmit ng-click=\"createRecipeForm.$setSubmitted(); submitRecipe(\'create\', true)\">Save as Copy</button> <button class=\"save-recipe-btn btn btn-success m-l-20\" ng-class=\"{\'btn-disable\': createRecipeForm.$invalid}\" ng-disabled=disableSubmit ng-click=\"createRecipeForm.$setSubmitted(); submitRecipe(recipe.id ? \'update\' : \'create\')\">Save recipe</button></div></div>");
$templateCache.put("app/components/catalogue/recipe-filters/recipe-filters.html","<div class=\"recipe-filters clearfix\"><div class=recipe-filters-column><div class=\"checkboxes-wrapper p-l-10\"><h5 class=\"h7 text-upper m-b-10 m-t-25\">Cuisine</h5><div class=checkbox-list-wrapper style=\"margin-right: 0\"><div class=checkboxes-container><ul class=\"checkbox-list cuisine-list\"><li class=list-item ng-repeat=\"cuisine in filters.cuisines | orderBy : \'name\'\"><label class=checkbox-element><input ng-change=\"selectOption(cuisine, \'cuisines\', \'cuisine[]\');\" type=checkbox ng-model=cuisine.isChecked> <span class=checkbox-item><span ng-class=\"{checked : cuisine.isChecked}\" class=label></span> </span><span class=checkbox-label>{{cuisine.name}}</span></label></li></ul></div></div><h5 class=\"h7 text-upper m-t-20\">Categories</h5><div class=\"checkbox-list-wrapper m-t-10 m-b-20\" ng-repeat=\"category in filters.category_groups\"><div class=checkbox-group-name><label class=checkbox-element><input ng-change=\"selectAllOptions(category.categories, \'category_groups\', \'category[]\', category);\" type=checkbox ng-model=category.isChecked> <span class=checkbox-item><span ng-class=\"{checked : category.isChecked}\" class=label></span> </span><span class=checkbox-label>{{category.name}}</span></label></div><div class=checkboxes-container><ul class=checkbox-list><li class=list-item ng-repeat=\"subcategory in category.categories | orderBy : \'name\'\"><label class=checkbox-element><input ng-change=\"selectOption(subcategory, \'category_groups\', \'category[]\');\" type=checkbox ng-model=subcategory.isChecked> <span class=checkbox-item><span ng-class=\"{checked : subcategory.isChecked}\" class=label></span> </span><span class=checkbox-label>{{subcategory.name}}</span></label></li></ul></div></div><h5 class=\"h7 text-upper\">Dietary</h5><div class=\"checkbox-list-wrapper m-t-10\"><div class=checkboxes-container><ul class=checkbox-list><li class=list-item ng-repeat=\"dietary in filters.dietary | orderBy : \'name\'\"><label class=checkbox-element><input ng-change=\"selectOption(dietary, \'dietaries\', \'dietary[]\');\" type=checkbox ng-model=dietary.isChecked> <span class=checkbox-item><span ng-class=\"{checked : dietary.isChecked}\" class=label></span> </span><span class=checkbox-label>{{dietary.name}}</span></label></li></ul></div></div></div><hr style=\"border: 1px solid #e9e9e9; height: 0\"><button class=\"btn btn-default m-t-20 clear-all\" ng-click=clearAll()>Clear all</button></div></div>");
$templateCache.put("app/components/catalogue/recipe-list/recipe-list.html","<div class=recipe-list><div class=recipe-wrapper ng-repeat=\"recipe in recipes track by $index\" ng-click=onSelect(recipe)><div class=\"recipe-photo-wrapper {{getRandomColor($index)}}\" ng-style=\"{backgroundImage: recipe.photo.url && \'url(\' + recipe.photo.url + \')\'}\"><img class=border-radius ng-show=!recipe.photo.url ng-src=\"{{\'../../../../assets/images/img-placeholder.png\'}}\"></div><div class=recipe-title>{{recipe.title | truncate : 65 : true}}</div><div class=recipe-description><div class=display-6><span class=calories-label>cal:</span> {{recipe.calories}}</div><div class=\"display-6 cuisine-label m-t-10\" ng-show=recipe.cuisine>{{recipe.cuisine.name}}</div></div></div><div class=\"no-recipes-wrapper relative text-center\" ng-if=\"!recipes.length && !isLoading && !$parent.noResults\"><span class=\"no-recipes display-4-g\"><span class=no-recipes-img></span><br>No recipes added</span></div><div class=\"no-recipes-wrapper relative text-center\" ng-if=$parent.noResults style=\"background: transparent\"><span class=\"no-recipes display-4-g\"><span class=no-recipes-img></span><br>No results</span></div></div>");
$templateCache.put("app/components/catalogue/view-recipe/view-recipe.html","<div class=\"view-recipe container\"><div class=view-recipe-wrapper><div class=\"view-recipe-header clearfix\"><div class=\"labels-wrapper pull-left\"><span class=\"label display-4-g m-r-10\" ng-show=recipe.cuisine>{{recipe.cuisine.name}}</span><div class=\"label label-rounded display-6-g m-r-10 m-b-15\" ng-repeat=\"category in recipe.categories\">{{category.group_name + \': \' + category.name}}</div><div class=\"label label-rounded display-6-g m-r-10 m-b-15\" ng-repeat=\"dietary in recipe.dietaries\">{{\'Dietary: \' + dietary.name}}</div></div><div class=\"pull-right no-print\"><!-- <button class=\"btn btn-default\" ui-sref=\"main.create-recipe({recipeId: recipe.id})\" permission permission-only=\"[\'Main Chef\', \'Admin\']\">Copy</button> --><!-- <button class=\"btn btn-default\" ng-click=\"copyRecipe()\" permission permission-only=\"[\'Main Chef\', \'Admin\']\">Copy</button> --> <button class=\"btn btn-default\" ng-click=print()>Print</button> <button class=\"btn btn-default\" ui-sref=\"main.edit-recipe({recipeId: recipe.id})\" permission permission-only=\"[\'Admin\', \'canEditRecipe\']\">Edit</button></div></div><div class=\"view-recipe-main-info m-t-20 m-b-20 clearfix\"><div class=\"recipe-photo-wrapper pull-left m-r-20 border-radius\"><img ng-show=recipe.photo.url class=border-radius ng-src={{recipe.photo.url}}> <img ng-show=!recipe.photo.url class=border-radius ng-src=\"{{\'../../../../assets/images/img-placeholder.png\'}}\"></div><div class=pull-left style=\"max-width: 435px\"><span class=\"hero recipe-title\">{{recipe.title}}</span><div class=\"recipe-author m-t-20\" style=\"line-height: 21px\"><span class=\"recipe-author display-6-g\">Author</span><br><span class=\"recipe-author display-4 text-weight-bold\">{{recipe.chef.name}}</span></div><div class=\"recipe-serving m-t-20\"><span class=\"display-9 form-group\"><span style=\"max-width: 65px; display: inline-block\"><input type=text class=\"form-input input-small\" ng-model=recipe.serving only=integer ng-change=onChangeServings() input-max-length=4 on-keyup=calculateIngredients(recipe.serving) keys=13> </span>Servings <span class=\"element-control m-l-15 no-print\" ng-class=\"{\'disabled\': disableApply}\" ng-click=calculateIngredients(recipe.serving)>Apply</span><div class=\"element-control m-t-20 no-print\" ng-class=\"{\'disabled\': disableReset}\" ng-click=calculateIngredients(recipe.default.serving)>Reset to default</div></span></div></div><div class=pull-right><nutritions-table mapping=NUTRITION_MAPPING data=recipe></nutritions-table></div></div><div class=\"view-recipe-subrecipe-info m-t-20 m-b-20 clearfix\" ng-repeat=\"subrecipe in recipe.sub_recipes\"><div class=\"subrecipe-header text-weight-bold display-4 text-upper\">{{subrecipe.title}}</div><div class=subrecipe-body><div class=\"subrecipe-ingredients pull-left\"><div class=\"display-6 text-upper text-weight-bold\">Ingredients</div><table class=\"m-t-20 display-4\"><tbody><tr ng-repeat=\"ingredient in subrecipe.ingredients\"><td ng-click=openEditModal(ingredient) permission permission-only=\"[\'Main Chef\', \'canEditRecipe\']\" class=\"text-weight-bold p-b-10 p-t-10\" style=\"max-width: 260px;min-width: 260px;cursor: pointer;overflow: hidden;text-overflow: ellipsis\">{{ingredient.user_title}}</td><td permission permission-except=\"[\'Main Chef\', \'canEditRecipe\']\" class=\"text-weight-bold p-b-10 p-t-10\" style=\"max-width: 260px;min-width: 260px\">{{ingredient.user_title || ingredient.name}}</td><td style=\"min-width: 40px\">{{ingredient.amount}}</td><td style=\"min-width: 130px;padding-bottom: 10px;padding-left: 10px\">{{ingredient.unit.name}}</td></tr></tbody></table></div><div class=\"subrecipe-methods pull-right\" ng-show=subrecipe.methods.length><div class=\"display-6 text-upper text-weight-bold\">Method</div><div class=\"subrecipe-method m-t-20 m-b-20\" ng-repeat=\"method in subrecipe.methods\"><div class=\"subrecipe-step display-6 text-weight-bold\">Step {{$index + 1}}</div>{{method.desc}}</div></div></div></div><div class=\"view-recipe-subrecipe-info m-t-20 m-b-20 clearfix\" ng-show=recipe.allergens.length><div class=\"subrecipe-header text-weight-bold display-4 text-upper\">Allergens</div><div class=\"subrecipe-body text-weight-bold\"><span ng-repeat=\"allergen in recipe.allergens\">{{allergen.name}}<span ng-hide=$last>,&nbsp;</span></span></div></div></div><div class=recipe-to-print><table><tr><td><h1>{{recipe.title}}</h1></td><td class=category-img-wrapper><div ng-repeat=\"categoryToPrint in categoriesToPrint\"><img ng-src=../../../../assets/images/icon_{{categoryToPrint}}.png></div></td></tr></table><div><span class=serving-size-block><span class=\"text-weight-bold font-size-13\">Serving Size:</span> <span class=font-size-13>{{recipe.portion.unit !== \'quantity\' ? (recipe.portion.size + \' \' + recipe.portion.unit) : 1}}.</span></span><div class=\"recipe-to-print-nutrition m-t-10\"><span class=\"text-weight-bold m-b-5 font-size-13\">Calories:</span> <span class=font-size-13>{{recipe.nutrition_report.calories | number : 0}}</span></div><div ng-repeat=\"nutrition in ::NUTRITION_TO_PRINT_MAPPING\" class=recipe-to-print-nutrition ng-hide=$first><div class=\"recipe-to-print-category-title font-size-13\" ng-show=nutrition.categories><span class=\"text-weight-bold m-b-5\">{{nutrition.key}}:</span> <span>{{recipe.nutrition_report[nutrition.value] | number : 1}}</span> <span>{{nutrition.unit}}</span></div><div class=\"recipe-to-print-category-nutrition p-l-10 font-size-13\" ng-if=nutrition.categories ng-repeat=\"category in ::nutrition.categories track by category.value\"><span>{{category.key}}:</span> <span>{{recipe.nutrition_report[category.value] | number : 1}}</span> <span>{{category.unit}}</span></div><div ng-if=!nutrition.categories class=font-size-13><span class=text-weight-bold>{{nutrition.key}}:</span> <span>{{recipe.nutrition_report[nutrition.value] | number : 1}}</span> <span>{{nutrition.unit}}</span></div></div><div><div class=\"text-weight-bold m-b-10 m-t-10 font-size-11\">Ingredients:</div><div class=\"ingreditents-block font-size-9\"><span ng-repeat=\"subrecipe in recipe.sub_recipes\" ng-init=\"lastRecipe = $last\">{{ getIngredientsForPrint(subrecipe.ingredients)}}<br></span></div><div class=m-t-10><div class=\"text-weight-bold m-b-10 font-size-11\">Allergens <span class=\"font-size-9 text-italic text-weight-normal\">(Our kitchen is <span class=text-underline>not</span> an allergen-free environment)</span>:</div><div class=\"allergents-block font-size-9\"><span ng-repeat=\"allergen in recipe.allergens\">{{allergen.name}}<span ng-hide=$last>,&nbsp;</span></span></div></div></div></div></div></div>");
$templateCache.put("app/components/menu/create-menu/create-menu.html","<form name=menuForm class=\"create-menu clearfix\" novalidate onkeypress=\"return event.keyCode!=13\"><h3 class=\"h3 text-upper\">{{menuData ? \'Edit\' : \'Create\'}} Menu</h3><div class=\"create-menu-wrapper m-b-25 clearfix\"><div class=pull-left style=\"width: 900px\"><div class=\"menu-section form-group\"><label><h5 class=\"h5 m-t-0\" style=\"display: inline-block\">Menu Title<span class=pink>&nbsp;*</span></h5><span class=\"form-error-text text-italic pull-right\" ng-show=\"menuForm.menuTitle.$error.required && (menuForm.menuTitle.$touched || menuForm.$submitted)\">Menu title is required </span><input name=menuTitle class=text-input type=text placeholder=\"Enter menu title\" ng-model=menu.data.title input-max-length=300 required></label></div><div class=\"tabs-wrapper clearfix\"><div class=\"tab-header text-upper\" ng-class=\"{selected: tab.isSelected}\" ng-repeat=\"tab in ::tabs\" style=\"display: inline-block\" ng-click=selectTab(tab);>{{tab.name}}</div></div><div ng-repeat=\"tab in ::tabs\"><div class=\"menu-section m-b-10\" ng-show=tab.isSelected ng-repeat=\"station in menu.data.weekdays[tab.name] track by $index\"><input class=text-input placeholder=\"Station name\" ng-model=station.name input-max-length=100 style=\"max-width: 830px\"> <span ng-if=\"menu.data.weekdays[tab.name].length > 1\" style=\"margin-top: 8px;float: right\"><span class=\"icon i-trash\" ng-click=\"openRemoveModal(menu.data.weekdays[tab.name], \'station\', $index, \'\')\"></span></span><div class=\"m-b-20 clearfix\" ng-repeat=\"recipe in station.recipes track by $index\"><span class=pull-left style=\"display: inline-block; margin-top: 3px\"><span class=\"icon i-service\"></span> <span class=m-l-5>{{recipe.title}}</span> </span><span class=\"m-l-15 pull-right\" style=\"margin-top: 7px\"><span class=\"icon i-edit\" ng-click=\"addRecipe(station.recipes, \'Replace Recipe\', $index)\"></span> <span class=\"icon i-trash\" ng-click=\"openRemoveModal(station.recipes, \'recipe\', $index, \'\')\"></span> </span><input type=text class=\"text-input pull-right\" placeholder=\"Price, $\" ng-model=recipe.price input-max-length=20 style=\"max-width: 100px\"></div><div class=add-element-control ng-show=\"station.recipes.length < 50\" ng-click=\"station.recipes.length < 50 && addRecipe(station.recipes)\">Add Recipe</div></div></div><div class=\"add-new-station p-l-20 m-t-20\" ng-show=\"menu.data.weekdays[selectedTab.name].length < 50\"><span class=add-new-station-button ng-click=\"menu.data.weekdays[selectedTab.name].length < 50 && addNewStation(menu.data.weekdays)\"><span class=\"icon i-add\"></span> Add New Station</span></div></div><div class=pull-right><div style=\"margin-top: 8px; margin-bottom: 8px\"><span class=\"display-6 text-weight-bold\">Select Week</span></div><input data-bs-show=true bs-datepicker ng-model=menu.data.start_date readonly style=\"border: 0\" ng-hide=true data-disable-week=true data-start-date=menu.data.start_date data-timezone=\"\'UTC\'\"><div class=\"menu-section m-b-20 clearfix\" permission-only=\"\'Main Chef\'\"><div class=clearfix><span class=\"text-weight-bold display-6 pull-left\">Schedule of Meal</span> <span class=\"element-control pull-right\" ng-click=scheduleMeal(menu.data.schedule)>Edit Schedule</span></div><div><div ng-repeat=\"station in menu.data.schedule\" ng-class=\"{\'m-t-15\': $first}\"><div class=\"display-6 pull-left\" style=\"padding-bottom: 8px\"><span class=text-weight-bold style=\"text-overflow: ellipsis;width: 180px;display: inline-block;overflow: hidden\">{{station.name}}</span><div>{{station.start + \' - \' + station.end}}</div></div><span class=\"icon i-trash pull-right\" ng-click=\"openRemoveModal(menu.data.schedule, \'stationMenu\', $index, station.name)\"></span><hr ng-hide=$last style=\"background: #f1f1f1; height: 1px; border: 0\"></div></div></div><div class=\"menu-section m-b-20\"><div class=clearfix><span class=\"text-weight-bold display-6 pull-left\">Assigned to</span> <span class=\"add-element-control pull-right\" ng-click=assignChefs()>Add Chefs</span></div><div><div ng-repeat=\"selectedChef in menu.data.assigned_chefs | orderBy : \'last_name\'\" ng-class=\"{\'m-t-15\': $first}\">{{selectedChef.first_name + \' \' + selectedChef.last_name}} <span class=\"icon i-trash pull-right\" ng-click=\"openRemoveModal(menu.data.assigned_chefs, \'chef\', $index - 1, (selectedChef.first_name + \' \' + selectedChef.last_name))\"></span><hr ng-hide=$last style=\"background: #f1f1f1; height: 1px; border: 0\"></div></div></div></div></div><div class=\"menu-footer text-right\"><span ng-if=menuData><button type=button class=\"btn btn-default\" permission permission-only=\"[\'Main Chef\', \'Local Chef\']\" ng-click=openRemoveMenuModal(menuData.id)>Delete</button> <button type=button class=\"btn btn-default m-l-20\" ng-click=cancelPage(menuData.id)>Cancel</button> <button type=button class=\"btn btn-default btn-submit m-l-20\" ng-disabled=disableSubmit ng-click=\"menuForm.$valid && createMenu(\'create\', true);\">Save as Copy</button> </span><button ng-if=!menuData type=button class=\"btn btn-default\" ng-click=cancelPage(false)>Cancel</button> <button type=submit class=\"btn btn-success btn-submit m-l-20\" ng-disabled=disableSubmit ng-click=\"menuForm.$valid && createMenu();\">{{menuData ? \'Save Changes\' : \'Create New Menu\'}}</button></div></form>");
$templateCache.put("app/components/modal/templates/catalogue.html","<div class=\"modal catalogue-modal\" tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog style=\"max-width: none\"><div class=modal-content><div class=\"modal-header display-3 text-center\" ng-show=title style=\"border-bottom: 1px solid #f1f1f1\"><h4 class=modal-title>{{title}} <button type=button class=close ng-click=$hide() title=Close>&times;</button></h4></div><div class=modal-body style=\"padding: 0 0 20px 20px\"><catalogue recipes=recipes filters=filters collapsed=true on-select-recipe=onSelectRecipe></catalogue></div></div></div></div>");
$templateCache.put("app/components/modal/templates/confirm.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=\"modal-header text-center\" ng-show=title style=\"padding-top: 35px\"><h4 class=\"modal-title display-3\" ng-bind-html=title></h4></div><div class=\"modal-body display-4\" ng-bind-html=content style=\"padding-top: 0\"></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$hide()>No</button> <button type=button class=\"btn btn-success\" ng-click=action()>Yes</button></div></div></div></div>");
$templateCache.put("app/components/modal/templates/edit-ingredient.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><form name=editIngredientForm novalidate><div class=\"modal-header text-center\" ng-show=title style=\"padding-top: 35px\"><h4 class=\"modal-title display-3\" ng-bind-html=title></h4></div><div class=\"modal-body display-4 form-group\" style=\"padding-top: 0\"><span class=\"form-error-text pull-right display-6\" ng-show=\"editIngredientForm.ingredientName.$error.required && (editIngredientForm.ingredientName.$touched || editIngredientForm.$submitted)\">Ingredient name is required </span><input class=form-input type=text name=ingredientName required ng-model=ingredientName input-max-length=50> <span class=\"pull-right display-6 element-control\" ng-show=ingredient.user_title ng-click=resetToDefault(ingredient.name)>Reset to default</span></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$hide()>Cancel</button> <button type=submit class=\"btn btn-success no-loading\" ng-class=\"{\'no-loading\': (ingredient.user_title === ingredientName) || editIngredientForm.$invalid}\" ng-disabled=\"disableSubmit || (ingredient.user_title === ingredientName) || editIngredientForm.$invalid\" ng-click=\"editIngredientForm.$valid && action(ingredientName);\">Save</button></div></form></div></div></div>");
$templateCache.put("app/components/modal/templates/edit-nutritions.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=modal-header ng-show=title><h4 class=\"modal-title display-3 text-center\" ng-bind-html=title></h4></div><div class=\"modal-body display-4\" style=\"padding-top: 0;padding-bottom: 20px\"><form name=editNutritionsForm novalidate class=edit-nutrition-form><div class=\"form-group clearfix\" ng-repeat=\"nutrition in ::NUTRITION_MAPPING\"><label><span class=pull-left style=\"display: inline-block;padding-top: 10px;box-sizing: border-box\">{{nutrition.key}}</span><div class=\"pull-right text-right\" style=\"width: 130px\"><input type=text class=\"form-input input-small\" required ng-model=ingredient[nutrition.value] only=float placeholder=\"{{ingredient[nutrition.value] === undefined ? \'N/A\' : nutrition.key + \' ,\' + nutrition.unit}}\" style=\"width: 50%\" input-max-length=10 min=0> <span class=display-5-g style=\"padding-left: 10px;display: inline-block;width: 22px\">{{nutrition.unit}}</span></div></label></div></form><div class=form-group><span class=\"form-error-text text-italic\" ng-show=\"editNutritionsForm.$invalid && (editNutritionsForm.$touched || editNutritionsForm.$submitted)\">All nutritions are required</span></div><div class=\"modal-footer form-group\" style=\"padding: 20px 0 10px 0\"><button type=button class=\"btn btn-default\" ng-click=cancel()>Cancel</button> <button type=submit class=\"btn btn-success\" ng-click=\"editNutritionsForm.$setSubmitted(); editNutritionsForm.$valid && edit()\">Save</button></div></div></div></div></div>");
$templateCache.put("app/components/modal/templates/err.tpl.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=modal-header ng-show=title style=\"padding-left: 45px;padding-top: 45px\"><h4 class=\"modal-title display-3\" ng-bind-html=title></h4></div><div class=\"modal-body display-4\" ng-bind-html=content style=\"padding-top: 0\"></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$hide()>Close</button></div></div></div></div>");
$templateCache.put("app/components/modal/templates/import.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><form name=importForm novalidate><div class=\"modal-header text-center\" ng-show=title style=\"padding-top: 35px\"><h4 class=\"modal-title display-3\" ng-bind-html=title></h4></div><div class=\"modal-body display-4 form-group\" style=\"padding-top: 0\"><span class=\"form-error-text pull-right display-6\" ng-show=\"importForm.importUrl.$error.required && (importForm.importUrl.$touched || importForm.$submitted)\">URL is required </span><span class=\"form-error-text pull-right display-6\" ng-show=\"importForm.importUrl.$error.pattern && (importForm.importUrl.$touched || importForm.$submitted)\">Invalid URL </span><input class=form-input type=text name=importUrl required ng-model=importUrl pattern=^(https?:\\/\\/)+(([\\w\\.]+)\\.)?(myrecipes|allrecipes|food|foodnetwork|epicurious\\.?)\\.com(\\/[\\w\\.#-]*)*\\/?$><div class=\"form-error-text display-6\" ng-show=\"importForm.importUrl.$error.pattern && (importForm.importUrl.$touched || importForm.$submitted)\">Links to recipes from the following web-sites are supported:<ul><li>Myrecipes.com</li><li>Allrecipes.com</li><li>Food.com</li><li>FoodNetwork.com</li><li>Epicurious.com</li></ul></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$hide()>Cancel</button> <button type=submit class=\"btn btn-success\" ng-disabled=\"!importUrl.length || disableSubmit\" ng-click=action(importUrl);>Import</button></div></form></div></div></div>");
$templateCache.put("app/components/modal/templates/local-chefs.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=\"modal-header display-3 text-center\" ng-show=title><h4 class=modal-title>{{title}}</h4><input class=\"search-input m-t-20\" type=text placeholder=Search ng-model=searchText style=\"width: 90%\"></div><div class=modal-body><div class=local-chefs-wrapper><div class=local-chefs ng-repeat=\"localChef in localChefs | orderBy : \'last_name\' | filter : searchText\"><label class=checkbox-element><input type=checkbox ng-model=localChef.isChecked> <span class=checkbox-item><span ng-class=\"{checked : localChef.isChecked}\" class=label></span> </span><span class=checkbox-label>{{localChef.first_name + \' \' + localChef.last_name}}</span></label></div></div></div><div class=\"modal-footer form-group\"><button type=button class=\"btn btn-default\" ng-click=$hide()>Cancel</button> <button type=submit class=\"btn btn-success\" ng-click=action();>Assign</button></div></div></div></div>");
$templateCache.put("app/components/modal/templates/logout.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=\"modal-header text-center\" ng-show=title style=\"padding-top: 35px\"><h4 class=\"modal-title display-3\" ng-bind-html=title></h4></div><div class=\"modal-body display-4\" ng-bind-html=content style=\"padding-top: 0\"></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$hide()>Cancel</button> <button type=button class=\"btn btn-success\" ng-click=logout()>Log out</button></div></div></div></div>");
$templateCache.put("app/components/modal/templates/schedule.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog style=\"top: 50%\"><div class=modal-content><div class=\"modal-header clearfix\" ng-show=title style=\"padding: 25px 45px\"><h4 class=\"modal-title display-3 pull-left\" ng-bind-html=title></h4><span class=\"add-element-control pull-right\" style=\"padding-top: 6px\" ng-click=addStation()>Add new section</span></div><div class=\"modal-body display-4\" style=\"padding-top: 0; padding-bottom: 0; max-height: 60vh; overflow-y: auto\"><form name=scheduleMealForm novalidate><div class=\"form-group text-right\" ng-repeat=\"station in schedule\"><div class=clearfix><input name=stationName-{{$index}} type=text class=\"form-input pull-left bordered\" required ng-model=station.name placeholder=\"Station name\" input-max-length=50 style=\"width: 80%\"> <span class=\"icon i-trash pull-right\" ng-click=\"removeByIndex(schedule, $index)\" style=\"margin-top: 17px\"></span></div><div class=\"text-center clearfix m-t-10 m-b-15\"><select class=\"form-select pull-left\" ng-model=station.start style=\"width: 40%\"><option ng-repeat=\"hours in ::scheduleHours\">{{hours}}</option></select><span style=\"display: inline-block; margin-top: 20px\">to</span><select class=\"form-select pull-right\" ng-model=station.end style=\"width: 40%\"><option ng-repeat=\"hours in ::scheduleHours\">{{hours}}</option></select></div><div class=form-group><span class=\"form-error-text text-italic\" ng-show=\"scheduleMealForm[\'stationName-{{$index}}\'].$error.required && (scheduleMealForm.$touched || scheduleMealForm.$submitted)\">Station name is required</span></div></div></form></div><div class=\"modal-footer form-group\" style=\"padding: 20px 45px 20px 45px\"><button type=button class=\"btn btn-default\" ng-click=cancel()>Cancel</button> <button type=submit class=\"btn btn-success\" ng-click=\"scheduleMealForm.$setSubmitted(); scheduleMealForm.$valid && edit()\">Edit</button></div></div></div></div>");
$templateCache.put("app/components/modal/templates/user-create.tpl.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=modal-header ng-show=title><h4 class=\"modal-title display-3 text-center\" ng-bind-html=title></h4></div><div class=\"modal-body display-4\" style=\"padding-top: 0;padding-bottom: 20px\"><form name=userCreateForm novalidate><div class=form-group><label><span>First Name <span class=pink>*</span></span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"userCreateForm.userFirstName.$error.required && (userCreateForm.userFirstName.$touched || userCreateForm.$submitted)\">First name is required </span><input type=text class=form-input name=userFirstName ng-model=newUser.first_name ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=off required></label></div><div class=form-group><label><span>Last Name <span class=pink>*</span></span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"userCreateForm.userLastName.$error.required && (userCreateForm.userLastName.$touched || userCreateForm.$submitted)\">Last name is required </span><input type=text class=form-input name=userLastName ng-model=newUser.last_name ng-model-options=\"{updateOn: \'blur\'}\" autocomplete=off required></label></div><div class=form-group><label><span>Email <span class=pink>*</span></span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"userCreateForm.userEmail.$error.required && (userCreateForm.userEmail.$touched || userCreateForm.$submitted)\">Email is required </span><span class=\"form-error-text text-italic pull-right\" ng-show=\"userCreateForm.userEmail.$error.email && (userCreateForm.userEmail.$touched || userCreateForm.$submitted)\">Invalid email </span><span class=\"form-error-text text-italic pull-right\" ng-show=emailAlreadyTaken>Email has already been taken </span><input type=email class=form-input name=userEmail required ng-model=newUser.email ng-model-options=\"{updateOn: \'blur\'}\" ng-change=\"emailAlreadyTaken = false;\"></label></div><div class=\"form-group m-t-25\"><label><span>Role</span><select class=form-select ng-model=newUser.role_id ng-options=\"role.name for role in ::ACCEPTED_USER_ROLES\"></select><span class=arrows></span></label></div><div class=\"modal-footer form-group\" style=\"padding: 35px 0 10px 0\"><button type=button class=\"btn btn-default\" ng-click=$hide()>Cancel</button> <button type=submit class=\"btn btn-success\" ng-click=\"userCreateForm.$valid && createUser($event)\">Submit</button></div></form></div></div></div></div>");
$templateCache.put("app/components/modal/templates/user-edit.tpl.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=\"modal-header text-center\" ng-show=title><h4 class=\"modal-title display-3\" ng-bind-html=title></h4></div><div class=\"modal-body display-4\" style=\"padding-top: 0;padding-bottom: 20px\"><form name=userEditForm novalidate><div class=form-group><label><span>First Name <span class=pink>*</span></span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"userEditForm.userFirstName.$error.required && (userEditForm.userFirstName.$touched || userEditForm.$submitted)\">First name is required </span><input type=text class=form-input name=userFirstName required ng-model=user.first_name ng-model-options=\"{updateOn: \'blur\'}\"></label></div><div class=form-group><label><span>Last Name <span class=pink>*</span></span> <span class=\"form-error-text text-italic pull-right\" ng-show=\"userEditForm.userLastName.$error.required && (userEditForm.userLastName.$touched || userEditForm.$submitted)\">Last name is required </span><input type=text class=form-input name=userLastName required ng-model=user.last_name ng-model-options=\"{updateOn: \'blur\'}\"></label></div><div class=form-group><span>Email</span><div class=m-t-5>{{email}}</div></div><div class=\"form-group m-t-25\"><label><span>Role</span><select class=form-select ng-model=user.role_id ng-options=\"role.name for role in ::ACCEPTED_USER_ROLES\"></select><span class=arrows></span></label></div><div class=\"modal-footer form-group\" style=\"padding: 35px 0 10px 0\"><button type=button class=\"btn btn-default\" ng-click=$hide()>Cancel</button> <button type=submit class=\"btn btn-success\" ng-click=\"userEditForm.$valid && editUser($event)\">Save changes</button></div></form></div></div></div></div>");
$templateCache.put("app/components/modal/templates/user-remove.tpl.html","<div class=modal tabindex=-1 role=dialog aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=\"modal-header text-center\" ng-show=title style=\"padding-top: 35px\"><h4 class=\"modal-title display-3\" ng-bind-html=title></h4></div><div class=\"modal-body display-4\" ng-bind-html=content style=\"padding-top: 0\"></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$hide()>No</button> <button type=button class=\"btn btn-success\" ng-click=removeUser()>Yes</button></div></div></div></div>");
$templateCache.put("app/components/popover/templates/download.html","<div class=\"popover ng-scope am-flip-x bottom\"><div class=arrow style=\"left: 50%\"></div><div class=popover-content style=\"padding: 0\"><ul><li style=\"padding: 15px; border-bottom: 1px solid #e6e6e6; cursor:pointer\" ng-click=downloadMenuTemplate(menuData.id)><a class=element-control>Menu - Word</a></li><li style=\"padding: 15px; border-bottom: 1px solid #e6e6e6; cursor:pointer\" ng-click=downloadMenuPDF(menuData.id)><a class=element-control>Menu - PDF</a></li><li style=\"padding: 15px; cursor:pointer\" ng-click=downloadMenuSheet(menuData.id)><a class=element-control>Production Sheet</a></li></ul></div></div>");}]);